import { FeatureCollection } from "geojson";

export const statesData: FeatureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {
        STATEFP: "06",
        STATENS: "01779778",
        AFFGEOID: "0400000US06",
        GEOID: "06",
        STUSPS: "CA",
        NAME: "California",
        LSAD: "00",
        ALAND: 403483823181,
        AWATER: 20483271881,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-118.593969, 33.467197999999996],
              [-118.484785, 33.487483],
              [-118.286261, 33.351462999999995],
              [-118.325244, 33.299075],
              [-118.374768, 33.320065],
              [-118.465368, 33.326056],
              [-118.482609, 33.369914],
              [-118.593969, 33.467197999999996],
            ],
          ],
          [
            [
              [-118.594033, 33.035951],
              [-118.446771, 32.895424],
              [-118.353504, 32.821962],
              [-118.425634, 32.800595],
              [-118.581513, 32.931672],
              [-118.641578, 33.017129],
              [-118.594033, 33.035951],
            ],
          ],
          [
            [
              [-119.578942, 33.278628],
              [-119.510489, 33.307269],
              [-119.427171, 33.266023],
              [-119.464725, 33.215432],
              [-119.545872, 33.233405999999995],
              [-119.578942, 33.278628],
            ],
          ],
          [
            [
              [-119.91621599999999, 34.058351],
              [-119.857304, 34.071298],
              [-119.739472, 34.049299],
              [-119.364214, 34.050793999999996],
              [-119.391587, 33.994636],
              [-119.554472, 33.99782],
              [-119.662825, 33.985889],
              [-119.721206, 33.959582999999995],
              [-119.873358, 33.980374999999995],
              [-119.91621599999999, 34.058351],
            ],
          ],
          [
            [
              [-120.368278, 34.076465],
              [-120.24248, 34.057172],
              [-120.135853, 34.026087],
              [-120.05510699999999, 34.037729],
              [-119.984316, 33.983948],
              [-119.973691, 33.942481],
              [-120.121817, 33.895711999999996],
              [-120.200085, 33.956904],
              [-120.36484, 33.991780999999996],
              [-120.454134, 34.028081],
              [-120.368278, 34.076465],
            ],
          ],
          [
            [
              [-124.21160499999999, 41.99846],
              [-123.656998, 41.995137],
              [-123.347562, 41.999108],
              [-123.145959, 42.009246999999995],
              [-123.045254, 42.003049],
              [-122.501135, 42.00846],
              [-121.846712, 42.00307],
              [-121.035195, 41.993323],
              [-119.999168, 41.99454],
              [-119.999866, 41.183974],
              [-119.996155, 40.32125],
              [-119.997634, 39.956505],
              [-120.005142, 39.291258],
              [-120.001014, 38.999573999999996],
              [-119.587679, 38.714734],
              [-118.949673, 38.26894],
              [-118.500958, 37.949019],
              [-117.68061, 37.353398999999996],
              [-117.000895, 36.847694],
              [-116.48823300000001, 36.459097],
              [-116.093601, 36.155805],
              [-115.647683, 35.809357999999996],
              [-115.043812, 35.332012],
              [-114.633487, 35.001857],
              [-114.634382, 34.87289],
              [-114.465246, 34.691202],
              [-114.422382, 34.580711],
              [-114.378223, 34.516521],
              [-114.378852, 34.450376],
              [-114.335372, 34.450038],
              [-114.172845, 34.344978999999995],
              [-114.139055, 34.259538],
              [-114.229715, 34.186928],
              [-114.292806, 34.166725],
              [-114.428026, 34.092787],
              [-114.454807, 34.010968],
              [-114.534987, 33.928498999999995],
              [-114.508708, 33.900639999999996],
              [-114.520465, 33.827777999999995],
              [-114.496565, 33.719155],
              [-114.525201, 33.661583],
              [-114.524599, 33.552231],
              [-114.597283, 33.490653],
              [-114.635183, 33.422726],
              [-114.707348, 33.376628],
              [-114.723259, 33.288078999999996],
              [-114.674491, 33.255597],
              [-114.679359, 33.159518999999996],
              [-114.706175, 33.105335],
              [-114.670803, 33.037984],
              [-114.511343, 33.023455],
              [-114.463127, 32.901883999999995],
              [-114.468971, 32.845155],
              [-114.570675, 32.747417],
              [-114.719633, 32.718762999999996],
              [-115.465164, 32.667100000000005],
              [-116.04662, 32.623353],
              [-117.12486200000001, 32.534155999999996],
              [-117.136664, 32.618753999999996],
              [-117.196767, 32.688851],
              [-117.246069, 32.669351999999996],
              [-117.25497, 32.786947999999995],
              [-117.28217000000001, 32.839546999999996],
              [-117.25447, 32.900146],
              [-117.28077, 33.012343],
              [-117.362572, 33.168437],
              [-117.445583, 33.268516999999996],
              [-117.547693, 33.365491],
              [-117.59588, 33.386629],
              [-117.64558199999999, 33.440728],
              [-117.726486, 33.483427],
              [-117.840289, 33.573523],
              [-117.927091, 33.605520999999996],
              [-118.132698, 33.753217],
              [-118.258687, 33.703741],
              [-118.39660599999999, 33.735917],
              [-118.394307, 33.804314999999995],
              [-118.412708, 33.883913],
              [-118.460611, 33.969111],
              [-118.519514, 34.027509],
              [-118.603572, 34.039048],
              [-118.744952, 34.032103],
              [-118.805114, 34.001239],
              [-118.854653, 34.034214999999996],
              [-118.954722, 34.048167],
              [-119.10978399999999, 34.094566],
              [-119.227743, 34.161728],
              [-119.270144, 34.252902999999996],
              [-119.46103600000001, 34.374064],
              [-119.616862, 34.420995],
              [-119.709067, 34.395396999999996],
              [-119.785871, 34.415997],
              [-119.873971, 34.408795],
              [-119.971951, 34.444641],
              [-120.141165, 34.473405],
              [-120.295051, 34.470622999999996],
              [-120.451425, 34.447094],
              [-120.511421, 34.522953],
              [-120.64573899999999, 34.581035],
              [-120.60197, 34.692095],
              [-120.62631999999999, 34.738071999999995],
              [-120.610266, 34.85818],
              [-120.670835, 34.904115],
              [-120.63356999999999, 35.033085],
              [-120.635787, 35.123805],
              [-120.714185, 35.175998],
              [-120.756086, 35.160458999999996],
              [-120.84667400000001, 35.204429],
              [-120.89679, 35.247876999999995],
              [-120.862133, 35.360763],
              [-120.88475700000001, 35.430195999999995],
              [-121.003359, 35.46071],
              [-121.166712, 35.635399],
              [-121.272322, 35.666711],
              [-121.314632, 35.71331],
              [-121.332449, 35.783106],
              [-121.462264, 35.885618],
              [-121.48620000000001, 35.970348],
              [-121.574602, 36.025155999999996],
              [-121.680145, 36.165818],
              [-121.77985100000001, 36.227407],
              [-121.826425, 36.241859999999996],
              [-121.888491, 36.30281],
              [-121.903195, 36.393603],
              [-121.970427, 36.582754],
              [-121.923866, 36.634558999999996],
              [-121.860604, 36.611135999999995],
              [-121.81446199999999, 36.682857999999996],
              [-121.791544, 36.815186],
              [-121.862266, 36.931551999999996],
              [-121.906468, 36.96895],
              [-122.027174, 36.95115],
              [-122.105976, 36.955951],
              [-122.20618, 37.013949],
              [-122.284882, 37.101746999999996],
              [-122.322971, 37.11546],
              [-122.397065, 37.187249],
              [-122.418452, 37.248521],
              [-122.40132299999999, 37.337008999999995],
              [-122.445987, 37.461541],
              [-122.516689, 37.521339999999995],
              [-122.496786, 37.612136],
              [-122.511983, 37.77113],
              [-122.465396, 37.800878999999995],
              [-122.398139, 37.80563],
              [-122.376462, 37.738558],
              [-122.39319, 37.707530999999996],
              [-122.360219, 37.592501],
              [-122.244372, 37.55814],
              [-122.168449, 37.504143],
              [-122.111998, 37.528850999999996],
              [-122.144396, 37.581866],
              [-122.163049, 37.667933],
              [-122.312974, 37.777243999999996],
              [-122.303931, 37.830087],
              [-122.33453, 37.908791],
              [-122.378709, 37.905190999999995],
              [-122.425258, 37.955672],
              [-122.367582, 37.978168],
              [-122.262861, 38.051473],
              [-122.301804, 38.105142],
              [-122.393588, 38.143449],
              [-122.491283, 38.108087],
              [-122.499465, 38.032165],
              [-122.486375, 37.921881],
              [-122.41847, 37.852720999999995],
              [-122.483483, 37.826727999999996],
              [-122.537285, 37.830328],
              [-122.60129, 37.875126],
              [-122.678474, 37.906604],
              [-122.70264, 37.89382],
              [-122.856573, 38.016717],
              [-122.939711, 38.031908],
              [-122.97439, 37.992429],
              [-123.011533, 38.003437999999996],
              [-122.960889, 38.112961999999996],
              [-122.953629, 38.17567],
              [-123.004122, 38.297011999999995],
              [-123.053504, 38.299385],
              [-123.085572, 38.390525],
              [-123.166428, 38.474947],
              [-123.249797, 38.511044999999996],
              [-123.33189899999999, 38.565542],
              [-123.441774, 38.699743999999995],
              [-123.51478399999999, 38.741966],
              [-123.71054, 38.91323],
              [-123.73289199999999, 38.954994],
              [-123.69074, 39.021293],
              [-123.72150500000001, 39.125327],
              [-123.765891, 39.193657],
              [-123.825331, 39.360814],
              [-123.81469, 39.446538],
              [-123.766475, 39.552803],
              [-123.792659, 39.684121999999995],
              [-123.829545, 39.723071],
              [-123.851714, 39.832041],
              [-123.907664, 39.863028],
              [-124.087086, 40.078441999999995],
              [-124.187874, 40.130542],
              [-124.363414, 40.260974],
              [-124.353124, 40.331424999999996],
              [-124.409591, 40.438075999999995],
              [-124.387023, 40.504954],
              [-124.301355, 40.659642999999996],
              [-124.176715, 40.843618],
              [-124.118147, 40.989263],
              [-124.125448, 41.048504],
              [-124.163988, 41.138675],
              [-124.122677, 41.189726],
              [-124.092284, 41.287695],
              [-124.063076, 41.439578999999995],
              [-124.081987, 41.547761],
              [-124.154246, 41.728801],
              [-124.19104, 41.736079],
              [-124.245027, 41.792300000000004],
              [-124.219592, 41.846432],
              [-124.203402, 41.940964],
              [-124.21160499999999, 41.99846],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 11,
        STATENS: "01702382",
        AFFGEOID: "0400000US11",
        GEOID: 11,
        STUSPS: "DC",
        NAME: "District of Columbia",
        LSAD: "00",
        ALAND: 158350578,
        AWATER: 18633500,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-77.119759, 38.934343],
            [-77.041018, 38.995548],
            [-76.909393, 38.892852],
            [-77.039006, 38.791644999999995],
            [-77.039099, 38.868111999999996],
            [-77.119759, 38.934343],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 12,
        STATENS: "00294478",
        AFFGEOID: "0400000US12",
        GEOID: 12,
        STUSPS: "FL",
        NAME: "Florida",
        LSAD: "00",
        ALAND: 138903200855,
        AWATER: 31407883551,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-81.81169299999999, 24.568745],
              [-81.751266, 24.653516999999997],
              [-81.584599, 24.736696],
              [-81.571151, 24.756353999999998],
              [-81.44351, 24.813364],
              [-81.305054, 24.755184999999997],
              [-81.24323199999999, 24.673997999999997],
              [-81.401889, 24.623544],
              [-81.44391499999999, 24.642677],
              [-81.685243, 24.558676],
              [-81.812536, 24.545469],
              [-81.81169299999999, 24.568745],
            ],
          ],
          [
            [
              [-82.01491, 24.543070999999998],
              [-81.983908, 24.580682],
              [-81.86871099999999, 24.58412],
              [-81.918855, 24.498130999999997],
              [-82.02809099999999, 24.498715999999998],
              [-82.01491, 24.543070999999998],
            ],
          ],
          [
            [
              [-82.188031, 24.574699],
              [-82.144099, 24.622481],
              [-82.086643, 24.590071],
              [-82.100757, 24.533288],
              [-82.17945399999999, 24.52947],
              [-82.188031, 24.574699],
            ],
          ],
          [
            [
              [-85.002499, 31.000681999999998],
              [-84.983757, 30.936984],
              [-84.935698, 30.878702999999998],
              [-84.91815, 30.772081999999997],
              [-84.864693, 30.711541999999998],
              [-84.12499299999999, 30.678037],
              [-83.499951, 30.645663],
              [-82.45979243541369, 30.584276528306198],
              [-82.21860699999999, 30.564394999999998],
              [-82.229427, 30.520813999999998],
              [-82.200965, 30.474427],
              [-82.210318, 30.424577],
              [-82.180043, 30.36861],
              [-82.04076599999999, 30.370144],
              [-82.015728, 30.601698],
              [-82.04952899999999, 30.655544],
              [-82.03266699999999, 30.750674],
              [-81.943187, 30.827437],
              [-81.868624, 30.792755999999997],
              [-81.808543, 30.790015999999998],
              [-81.732238, 30.749634999999998],
              [-81.56170999999999, 30.715597],
              [-81.444124, 30.709713999999998],
              [-81.43406399999999, 30.522568999999997],
              [-81.410809, 30.482039],
              [-81.396407, 30.34004],
              [-81.256711, 29.784692999999997],
              [-81.163581, 29.55529],
              [-80.96617599999999, 29.147959999999998],
              [-80.787021, 28.875266],
              [-80.583884, 28.597704999999998],
              [-80.525094, 28.459453999999997],
              [-80.587813, 28.410856],
              [-80.60687399999999, 28.336484],
              [-80.589975, 28.177989999999998],
              [-80.547675, 28.048795],
              [-80.383695, 27.740045],
              [-80.253665, 27.37979],
              [-80.153375, 27.169307999999997],
              [-80.046263, 26.859237999999998],
              [-80.03211999999999, 26.77153],
              [-80.03886299999999, 26.569347],
              [-80.109566, 26.087165],
              [-80.117904, 25.915772],
              [-80.10995299999999, 25.81826],
              [-80.154972, 25.66549],
              [-80.229107, 25.732509],
              [-80.301464, 25.613298999999998],
              [-80.337049, 25.465621],
              [-80.31036, 25.389706999999998],
              [-80.234849, 25.42196],
              [-80.176024, 25.521154],
              [-80.163156, 25.452184],
              [-80.23855499999999, 25.326819999999998],
              [-80.358183, 25.153228],
              [-80.49676099999999, 24.999323999999998],
              [-80.651189, 24.866131],
              [-80.966245, 24.707852],
              [-81.10337299999999, 24.669463],
              [-81.148718, 24.710476999999997],
              [-81.03890799999999, 24.772596],
              [-80.847471, 24.851753],
              [-80.610869, 25.006995],
              [-80.516571, 25.095457],
              [-80.49539399999999, 25.199807999999997],
              [-80.542391, 25.206379],
              [-80.650532, 25.189097],
              [-80.74774599999999, 25.147441],
              [-80.812133, 25.186038999999997],
              [-80.87545999999999, 25.174321],
              [-80.91592399999999, 25.141301],
              [-81.079859, 25.118796999999997],
              [-81.14227799999999, 25.183],
              [-81.170907, 25.245856999999997],
              [-81.14810299999999, 25.332793],
              [-81.146765, 25.407577],
              [-81.208201, 25.504936999999998],
              [-81.24051899999999, 25.599041],
              [-81.289901, 25.673554],
              [-81.355986, 25.703526],
              [-81.38381, 25.776750999999997],
              [-81.614735, 25.893977],
              [-81.67263299999999, 25.856654],
              [-81.727086, 25.907207],
              [-81.80883299999999, 26.152245999999998],
              [-81.844555, 26.327712],
              [-81.923611, 26.436657999999998],
              [-82.013913, 26.452057999999997],
              [-82.075015, 26.422058999999997],
              [-82.180717, 26.476257],
              [-82.245395, 26.601094],
              [-82.264682, 26.756836],
              [-82.31427699999999, 26.858383999999997],
              [-82.45267299999999, 27.079359],
              [-82.53971899999999, 27.254326],
              [-82.610581, 27.348817],
              [-82.69182099999999, 27.437217999999998],
              [-82.743017, 27.531086],
              [-82.65071999999999, 27.523114999999997],
              [-82.58462899999999, 27.596021],
              [-82.514265, 27.705588],
              [-82.43198, 27.768092],
              [-82.448786, 27.810036],
              [-82.553946, 27.848461999999998],
              [-82.622723, 27.779868],
              [-82.62501999999999, 27.732706],
              [-82.705017, 27.62531],
              [-82.733076, 27.612972],
              [-82.746223, 27.731306],
              [-82.846526, 27.854301],
              [-82.82816299999999, 28.020129999999998],
              [-82.859624, 28.174135],
              [-82.76410299999999, 28.244345],
              [-82.656694, 28.544814],
              [-82.668722, 28.695657999999998],
              [-82.712373, 28.720920999999997],
              [-82.730245, 28.850154999999997],
              [-82.688864, 28.905609],
              [-82.759378, 29.006618999999997],
              [-82.759704, 29.054191999999997],
              [-82.82365899999999, 29.098902],
              [-82.827073, 29.158424999999998],
              [-82.996144, 29.178074],
              [-83.053207, 29.130838999999998],
              [-83.078986, 29.196944],
              [-83.07473399999999, 29.247975],
              [-83.16957599999999, 29.290354999999998],
              [-83.175518, 29.34469],
              [-83.240509, 29.433177999999998],
              [-83.401552, 29.523291],
              [-83.414701, 29.670536],
              [-83.537645, 29.72306],
              [-83.62502599999999, 29.856892],
              [-83.67921899999999, 29.918512999999997],
              [-83.78872899999999, 29.976982],
              [-83.93151, 30.039068],
              [-84.000716, 30.096208999999998],
              [-84.06299, 30.101378],
              [-84.179149, 30.073186999999997],
              [-84.20801, 30.084775999999998],
              [-84.289727, 30.057197],
              [-84.366115, 30.008661999999998],
              [-84.33374599999999, 29.923720999999997],
              [-84.349066, 29.896811999999997],
              [-84.470323, 29.924523999999998],
              [-84.57744, 29.887828],
              [-84.564976, 29.81018],
              [-84.692619, 29.763039],
              [-84.77695399999999, 29.692190999999998],
              [-85.045074, 29.586990999999998],
              [-85.15731, 29.642889999999998],
              [-85.25971899999999, 29.681296],
              [-85.352615, 29.659786999999998],
              [-85.40283, 29.758782],
              [-85.41654799999999, 29.842627999999998],
              [-85.38472999999999, 29.920949],
              [-85.487764, 29.961226999999997],
              [-85.60117799999999, 30.056341999999997],
              [-85.69681, 30.09689],
              [-85.811219, 30.17832],
              [-85.999937, 30.27078],
              [-86.222561, 30.343584999999997],
              [-86.412076, 30.380346],
              [-86.632953, 30.396299],
              [-86.850625, 30.380967],
              [-87.15539199999999, 30.327748],
              [-87.319518, 30.317814],
              [-87.51832399999999, 30.280434999999997],
              [-87.452282, 30.344096999999998],
              [-87.41468499999999, 30.457289],
              [-87.444722, 30.507483999999998],
              [-87.401189, 30.604383],
              [-87.400189, 30.657200999999997],
              [-87.52362099999999, 30.738284999999998],
              [-87.63494299999999, 30.865857],
              [-87.592064, 30.951459999999997],
              [-87.59893699999999, 30.997422],
              [-87.162644, 30.999025999999997],
              [-86.56349399999999, 30.995202],
              [-85.893632, 30.993454999999997],
              [-85.002499, 31.000681999999998],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 13,
        STATENS: "01705317",
        AFFGEOID: "0400000US13",
        GEOID: 13,
        STUSPS: "GA",
        NAME: "Georgia",
        LSAD: "00",
        ALAND: 148963503399,
        AWATER: 4947080103,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.605165, 34.984677999999995],
            [-85.384967, 34.982987],
            [-85.045183, 34.986883],
            [-84.32186899999999, 34.988408],
            [-83.619985, 34.986592],
            [-83.10861399600839, 35.000658821346],
            [-83.140621, 34.924915],
            [-83.25258199999999, 34.853483],
            [-83.323866, 34.789712],
            [-83.35323799999999, 34.728648],
            [-83.33869, 34.682002],
            [-83.221402, 34.609947],
            [-83.154577, 34.588198],
            [-83.048289, 34.493254],
            [-82.99508999999999, 34.472483],
            [-82.873831, 34.471508],
            [-82.82342, 34.358872],
            [-82.744982, 34.244861],
            [-82.715373, 34.148165],
            [-82.642797, 34.081312],
            [-82.55683499999999, 33.945353],
            [-82.51294999999999, 33.936969],
            [-82.43115, 33.867051],
            [-82.32448, 33.820032999999995],
            [-82.239098, 33.730872],
            [-82.161908, 33.610642999999996],
            [-82.10624, 33.595636999999996],
            [-82.028238, 33.544934],
            [-81.990938, 33.494234999999996],
            [-81.92633599999999, 33.462937],
            [-81.932737, 33.343541],
            [-81.846136, 33.303843],
            [-81.846536, 33.241746],
            [-81.76353499999999, 33.203648],
            [-81.755135, 33.15155],
            [-81.601655, 33.084688],
            [-81.50202999999999, 33.015113],
            [-81.499566, 32.943722],
            [-81.42062, 32.831223],
            [-81.393818, 32.653490999999995],
            [-81.397106, 32.605587],
            [-81.27492699999999, 32.544157999999996],
            [-81.194829, 32.465086],
            [-81.194931, 32.411488999999996],
            [-81.133032, 32.334793999999995],
            [-81.128034, 32.276297],
            [-81.153531, 32.237687],
            [-81.119361, 32.177141999999996],
            [-81.113334, 32.113205],
            [-81.038265, 32.084469],
            [-81.006745, 32.101152],
            [-80.885517, 32.034600000000005],
            [-80.848441, 31.988279],
            [-80.91120699999999, 31.943769],
            [-81.000317, 31.856744],
            [-81.077057, 31.761256],
            [-81.130634, 31.722692],
            [-81.133493, 31.623348],
            [-81.17725399999999, 31.517073999999997],
            [-81.25861599999999, 31.404425],
            [-81.279338, 31.351126999999998],
            [-81.260958, 31.30391],
            [-81.304957, 31.206173],
            [-81.368241, 31.136533999999997],
            [-81.402096, 31.125383],
            [-81.420474, 31.016703],
            [-81.405153, 30.908203],
            [-81.460061, 30.769911999999998],
            [-81.444124, 30.709713999999998],
            [-81.56170999999999, 30.715597],
            [-81.732238, 30.749634999999998],
            [-81.808543, 30.790015999999998],
            [-81.868624, 30.792755999999997],
            [-81.943187, 30.827437],
            [-82.03266699999999, 30.750674],
            [-82.04952899999999, 30.655544],
            [-82.015728, 30.601698],
            [-82.04076599999999, 30.370144],
            [-82.180043, 30.36861],
            [-82.210318, 30.424577],
            [-82.200965, 30.474427],
            [-82.229427, 30.520813999999998],
            [-82.21860699999999, 30.564394999999998],
            [-82.45979243541369, 30.584276528306198],
            [-83.499951, 30.645663],
            [-84.12499299999999, 30.678037],
            [-84.864693, 30.711541999999998],
            [-84.91815, 30.772081999999997],
            [-84.935698, 30.878702999999998],
            [-84.983757, 30.936984],
            [-85.002499, 31.000681999999998],
            [-85.03561499999999, 31.108192],
            [-85.10751599999999, 31.186450999999998],
            [-85.09248699999999, 31.362880999999998],
            [-85.071621, 31.468383999999997],
            [-85.04188099999999, 31.544684],
            [-85.05816899999999, 31.620227],
            [-85.12553, 31.694965],
            [-85.11892999999999, 31.732664],
            [-85.141831, 31.839260999999997],
            [-85.067829, 31.967357999999997],
            [-85.047063, 32.087389],
            [-85.05874899999999, 32.136018],
            [-84.930127, 32.219051],
            [-84.891841, 32.263397999999995],
            [-85.008096, 32.336677],
            [-84.98346599999999, 32.363186],
            [-84.971831, 32.442842999999996],
            [-85.00710000000001, 32.523868],
            [-85.069848, 32.583146],
            [-85.11425, 32.730447],
            [-85.18440000000001, 32.861317],
            [-85.42949899999999, 34.125095],
            [-85.561424, 34.750079],
            [-85.605165, 34.984677999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 16,
        STATENS: "01779783",
        AFFGEOID: "0400000US16",
        GEOID: 16,
        STUSPS: "ID",
        NAME: "Idaho",
        LSAD: "00",
        ALAND: 214045425549,
        AWATER: 2397728105,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-116.915989, 45.995413],
            [-116.942656, 46.061],
            [-116.981962, 46.084914999999995],
            [-116.923958, 46.170919999999995],
            [-116.962966, 46.19968],
            [-116.96437900000001, 46.253282],
            [-116.99726, 46.303151],
            [-117.062748, 46.353623999999996],
            [-117.035545, 46.410011999999995],
            [-117.039771, 46.471779],
            [-117.041107, 48.124904],
            [-117.035289, 48.422731999999996],
            [-117.032351, 48.999188],
            [-116.049193, 49.000912],
            [-116.049153, 47.999922999999995],
            [-115.900934, 47.843064],
            [-115.845474, 47.814966999999996],
            [-115.835365, 47.760957],
            [-115.72377, 47.696670999999995],
            [-115.73627, 47.654762],
            [-115.694284, 47.623459999999994],
            [-115.717024, 47.532692999999995],
            [-115.634684, 47.48176],
            [-115.69293, 47.457237],
            [-115.71034, 47.417784],
            [-115.578619, 47.367007],
            [-115.531971, 47.314121],
            [-115.470959, 47.284873],
            [-115.326903, 47.255911999999995],
            [-115.255786, 47.174724999999995],
            [-115.189451, 47.131032],
            [-115.071254, 47.022082999999995],
            [-115.031651, 46.971548],
            [-114.927432, 46.914184999999996],
            [-114.943281, 46.867971],
            [-114.880588, 46.811791],
            [-114.79004, 46.778729],
            [-114.76718, 46.738828],
            [-114.69900799999999, 46.740223],
            [-114.626695, 46.712889],
            [-114.621483, 46.658142999999995],
            [-114.547321, 46.644484999999996],
            [-114.453239, 46.649266],
            [-114.360709, 46.669059],
            [-114.320665, 46.646963],
            [-114.351655, 46.508119],
            [-114.403019, 46.498675],
            [-114.384756, 46.411784],
            [-114.422458, 46.387097],
            [-114.449819, 46.237119],
            [-114.445928, 46.173933],
            [-114.514706, 46.167725999999995],
            [-114.52130000000001, 46.125287],
            [-114.460049, 46.097103999999995],
            [-114.480241, 46.030325],
            [-114.402261, 45.961489],
            [-114.422963, 45.855381],
            [-114.517143, 45.835992999999995],
            [-114.562509, 45.779927],
            [-114.504869, 45.722176],
            [-114.499637, 45.669035],
            [-114.538132, 45.606834],
            [-114.50634099999999, 45.559216],
            [-114.36852, 45.492716],
            [-114.279217, 45.480616],
            [-114.251836, 45.537811999999995],
            [-114.18647, 45.545539],
            [-114.08314899999999, 45.603995999999995],
            [-113.971565, 45.700635999999996],
            [-113.898883, 45.644166999999996],
            [-113.806729, 45.602146],
            [-113.802849, 45.523159],
            [-113.759986, 45.480734999999996],
            [-113.763368, 45.427732],
            [-113.73239, 45.385058],
            [-113.735601, 45.325264999999995],
            [-113.650064, 45.23471],
            [-113.57467, 45.128411],
            [-113.45197, 45.059247],
            [-113.437726, 45.006966999999996],
            [-113.47457299999999, 44.910846],
            [-113.422376, 44.842594999999996],
            [-113.301508, 44.798984999999995],
            [-113.24716599999999, 44.82295],
            [-113.131387, 44.764738],
            [-113.049349, 44.62938],
            [-113.061071, 44.577329],
            [-113.006828, 44.518439],
            [-113.006846, 44.471714999999996],
            [-112.951146, 44.416699],
            [-112.881769, 44.380314999999996],
            [-112.821896, 44.407436],
            [-112.828191, 44.442471999999995],
            [-112.707815, 44.503023],
            [-112.473207, 44.480027],
            [-112.387389, 44.448057999999996],
            [-112.358917, 44.528847],
            [-112.286187, 44.568472],
            [-112.221698, 44.543518999999996],
            [-112.125101, 44.528527],
            [-111.870504, 44.564032999999995],
            [-111.807914, 44.511716],
            [-111.704218, 44.560204999999996],
            [-111.562814, 44.555209],
            [-111.519126, 44.582916],
            [-111.438793, 44.720546],
            [-111.385005, 44.755128],
            [-111.323669, 44.724474],
            [-111.224161, 44.623402],
            [-111.201459, 44.575696],
            [-111.143557, 44.535731999999996],
            [-111.122654, 44.493659],
            [-111.048974, 44.474072],
            [-111.043564, 42.722623999999996],
            [-111.046689, 42.001567],
            [-112.109532, 41.997597999999996],
            [-112.264936, 42.000991],
            [-113.24915899999999, 41.996203],
            [-113.817964, 41.98858],
            [-114.041723, 41.993719999999996],
            [-114.59826699999999, 41.994510999999996],
            [-114.89921, 41.999908999999995],
            [-115.313877, 41.996103],
            [-116.625947, 41.997378999999995],
            [-117.026197, 41.99989],
            [-117.026889, 43.596033],
            [-117.023577, 43.823811],
            [-116.976024, 43.895548],
            [-116.937342, 44.029376],
            [-116.977351, 44.085364],
            [-116.895931, 44.154295],
            [-116.965498, 44.194126],
            [-116.971958, 44.235676999999995],
            [-117.059352, 44.237244],
            [-117.121037, 44.277584999999995],
            [-117.170342, 44.25889],
            [-117.216974, 44.288357],
            [-117.192203, 44.32863],
            [-117.243027, 44.390974],
            [-117.21507199999999, 44.427161999999996],
            [-117.225932, 44.479389],
            [-117.14293, 44.557235999999996],
            [-117.062273, 44.727143],
            [-116.93180000000001, 44.787181],
            [-116.833632, 44.928976],
            [-116.858313, 44.978761],
            [-116.841314, 45.030907],
            [-116.754643, 45.113972],
            [-116.67464799999999, 45.314341999999996],
            [-116.502756, 45.566607999999995],
            [-116.463504, 45.615784999999995],
            [-116.528272, 45.681473],
            [-116.535698, 45.734231],
            [-116.59300400000001, 45.778541],
            [-116.665344, 45.781997999999994],
            [-116.78752, 45.840204],
            [-116.85979499999999, 45.907264],
            [-116.915989, 45.995413],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 17,
        STATENS: "01779784",
        AFFGEOID: "0400000US17",
        GEOID: 17,
        STUSPS: "IL",
        NAME: "Illinois",
        LSAD: "00",
        ALAND: 143794747023,
        AWATER: 6200927458,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.419422, 40.378264],
            [-91.37292099999999, 40.399108],
            [-91.367876, 40.510479],
            [-91.394475, 40.534543],
            [-91.339719, 40.613488],
            [-91.247851, 40.63839],
            [-91.18697999999999, 40.637297],
            [-91.12082, 40.672776999999996],
            [-91.09299299999999, 40.821079],
            [-90.985462, 40.912141],
            [-90.95223299999999, 40.954046999999996],
            [-90.957246, 41.111084999999996],
            [-90.997906, 41.162563999999996],
            [-91.041536, 41.166138],
            [-91.11418599999999, 41.250029],
            [-91.065058, 41.369101],
            [-91.02778699999999, 41.423603],
            [-90.924343, 41.42286],
            [-90.86728199999999, 41.448215],
            [-90.70115899999999, 41.454743],
            [-90.571136, 41.516332],
            [-90.461432, 41.523533],
            [-90.339528, 41.598633],
            [-90.33672899999999, 41.664532],
            [-90.31070799999999, 41.742214],
            [-90.18064299999999, 41.811979],
            [-90.140613, 41.995999],
            [-90.163446, 42.040406999999995],
            [-90.161159, 42.106372],
            [-90.207421, 42.149108999999996],
            [-90.338169, 42.203320999999995],
            [-90.43088399999999, 42.27823],
            [-90.417125, 42.319942999999995],
            [-90.44632, 42.357040999999995],
            [-90.565248, 42.438742],
            [-90.646727, 42.471903999999995],
            [-90.642843, 42.508480999999996],
            [-89.926484, 42.505787],
            [-88.70738, 42.493587],
            [-88.21690000000001, 42.495923],
            [-87.800477, 42.49192],
            [-87.80337, 42.420621],
            [-87.834769, 42.301522],
            [-87.800066, 42.208023999999995],
            [-87.74168992918979, 42.1282651594678],
            [-87.68235899999999, 42.075728999999995],
            [-87.60945, 41.845233],
            [-87.52404399999999, 41.708335],
            [-87.52676799999999, 41.298176999999995],
            [-87.526292, 40.535409],
            [-87.532308, 40.011587],
            [-87.531646, 39.347888],
            [-87.600397, 39.312903999999996],
            [-87.577029, 39.211123],
            [-87.640435, 39.166727],
            [-87.625379, 39.101805999999996],
            [-87.572588, 39.057286],
            [-87.579117, 39.001607],
            [-87.529496, 38.971925],
            [-87.54737, 38.875614],
            [-87.498948, 38.757774],
            [-87.545538, 38.677613],
            [-87.62012, 38.639489],
            [-87.660732, 38.541092],
            [-87.714047, 38.47988],
            [-87.779996, 38.370841999999996],
            [-87.831972, 38.307241],
            [-87.96896799999999, 38.237389],
            [-87.975819, 38.197834],
            [-87.92746799999999, 38.151945999999995],
            [-87.98877, 38.055591],
            [-88.030884, 38.030713],
            [-88.016311, 37.961574],
            [-88.067364, 37.856051],
            [-88.02803, 37.799223999999995],
            [-88.05958799999999, 37.742608],
            [-88.132341, 37.697142],
            [-88.160062, 37.654332],
            [-88.131622, 37.572967999999996],
            [-88.072242, 37.528825999999995],
            [-88.062294, 37.487837],
            [-88.281667, 37.452596],
            [-88.358436, 37.40486],
            [-88.418594, 37.421987],
            [-88.46586099999999, 37.400546999999996],
            [-88.51466099999999, 37.290948],
            [-88.424776, 37.149901],
            [-88.47612699999999, 37.068222999999996],
            [-88.531576, 37.067192],
            [-88.61144, 37.112745],
            [-88.753068, 37.154700999999996],
            [-88.83505099999999, 37.196486],
            [-88.93174499999999, 37.227593],
            [-89.000968, 37.224401],
            [-89.058036, 37.188767],
            [-89.168087, 37.074217999999995],
            [-89.12889899999999, 37.017908],
            [-89.132915, 36.982057],
            [-89.195039, 36.989768],
            [-89.359456, 37.042606],
            [-89.384175, 37.103266999999995],
            [-89.456105, 37.18812],
            [-89.470525, 37.253357],
            [-89.517032, 37.28192],
            [-89.49516, 37.324795],
            [-89.428185, 37.356158],
            [-89.42594, 37.407471],
            [-89.5124, 37.52981],
            [-89.494051, 37.580116],
            [-89.521948, 37.696475],
            [-89.667993, 37.759484],
            [-89.696559, 37.814336999999995],
            [-89.85104799999999, 37.90398],
            [-89.92318499999999, 37.870672],
            [-90.008353, 37.970179],
            [-90.12600599999999, 38.05057],
            [-90.21870799999999, 38.094364999999996],
            [-90.32235299999999, 38.181593],
            [-90.36392599999999, 38.236354999999996],
            [-90.372519, 38.323353999999995],
            [-90.34974299999999, 38.377609],
            [-90.288815, 38.438452999999996],
            [-90.248913, 38.544751999999995],
            [-90.18450999999999, 38.611551],
            [-90.18110999999999, 38.659549999999996],
            [-90.20991, 38.72605],
            [-90.117707, 38.805748],
            [-90.113327, 38.849306],
            [-90.230336, 38.91086],
            [-90.395816, 38.960037],
            [-90.467784, 38.961808999999995],
            [-90.50011699999999, 38.910408],
            [-90.55569299999999, 38.870785],
            [-90.595354, 38.87505],
            [-90.657254, 38.920269999999995],
            [-90.713629, 39.053976999999996],
            [-90.681086, 39.10059],
            [-90.70790199999999, 39.15086],
            [-90.72995999999999, 39.255894],
            [-90.84010599999999, 39.340438],
            [-90.93741899999999, 39.400802999999996],
            [-91.03827, 39.448436],
            [-91.100307, 39.538695],
            [-91.148275, 39.545798],
            [-91.17423199999999, 39.591975],
            [-91.367753, 39.729029],
            [-91.361571, 39.787548],
            [-91.43605099999999, 39.84551],
            [-91.43709, 39.946417],
            [-91.48406399999999, 40.019332],
            [-91.511956, 40.170441],
            [-91.469656, 40.322409],
            [-91.419422, 40.378264],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 19,
        STATENS: "01779785",
        AFFGEOID: "0400000US19",
        GEOID: 19,
        STUSPS: "IA",
        NAME: "Iowa",
        LSAD: "00",
        ALAND: 144668594415,
        AWATER: 1076856589,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.45326, 43.500389999999996],
            [-95.21493799999999, 43.500885],
            [-93.9707615585282, 43.49960500320739],
            [-91.21770599999999, 43.50055],
            [-91.232276, 43.450952],
            [-91.20736699999999, 43.373658999999996],
            [-91.107237, 43.313645],
            [-91.05790999999999, 43.253968],
            [-91.175253, 43.134665],
            [-91.174692, 43.038713],
            [-91.138, 42.903772],
            [-91.09881999999999, 42.864421],
            [-91.07071599999999, 42.775501999999996],
            [-91.01723899999999, 42.719566],
            [-90.94156699999999, 42.683844],
            [-90.74367699999999, 42.645559999999996],
            [-90.700856, 42.626445],
            [-90.642843, 42.508480999999996],
            [-90.646727, 42.471903999999995],
            [-90.565248, 42.438742],
            [-90.44632, 42.357040999999995],
            [-90.417125, 42.319942999999995],
            [-90.43088399999999, 42.27823],
            [-90.338169, 42.203320999999995],
            [-90.207421, 42.149108999999996],
            [-90.161159, 42.106372],
            [-90.163446, 42.040406999999995],
            [-90.140613, 41.995999],
            [-90.18064299999999, 41.811979],
            [-90.31070799999999, 41.742214],
            [-90.33672899999999, 41.664532],
            [-90.339528, 41.598633],
            [-90.461432, 41.523533],
            [-90.571136, 41.516332],
            [-90.70115899999999, 41.454743],
            [-90.86728199999999, 41.448215],
            [-90.924343, 41.42286],
            [-91.02778699999999, 41.423603],
            [-91.065058, 41.369101],
            [-91.11418599999999, 41.250029],
            [-91.041536, 41.166138],
            [-90.997906, 41.162563999999996],
            [-90.957246, 41.111084999999996],
            [-90.95223299999999, 40.954046999999996],
            [-90.985462, 40.912141],
            [-91.09299299999999, 40.821079],
            [-91.12082, 40.672776999999996],
            [-91.18697999999999, 40.637297],
            [-91.247851, 40.63839],
            [-91.339719, 40.613488],
            [-91.394475, 40.534543],
            [-91.367876, 40.510479],
            [-91.37292099999999, 40.399108],
            [-91.419422, 40.378264],
            [-91.498093, 40.401925999999996],
            [-91.608347, 40.50004],
            [-91.618999, 40.539083999999995],
            [-91.670993, 40.550937],
            [-91.729115, 40.61364],
            [-91.939292, 40.60615],
            [-92.68669299999999, 40.589808999999995],
            [-93.135802, 40.582854],
            [-94.09108499999999, 40.572897],
            [-94.533878, 40.570738999999996],
            [-95.76564499999999, 40.585208],
            [-95.781909, 40.653272],
            [-95.84603399999999, 40.682604999999995],
            [-95.888697, 40.736292],
            [-95.834156, 40.783015999999996],
            [-95.841309, 40.845604],
            [-95.81070899999999, 40.886680999999996],
            [-95.837774, 40.924712],
            [-95.828329, 40.972378],
            [-95.865878, 41.017403],
            [-95.86868799999999, 41.124697999999995],
            [-95.856788, 41.187098],
            [-95.90969, 41.184398],
            [-95.890152, 41.278307999999996],
            [-95.92568999999999, 41.322196999999996],
            [-95.922529, 41.455766],
            [-95.982962, 41.469778],
            [-96.005079, 41.544004],
            [-96.08049299999999, 41.528199],
            [-96.118105, 41.613495],
            [-96.11148299999999, 41.668548],
            [-96.064537, 41.793002],
            [-96.159098, 41.910056999999995],
            [-96.132537, 41.974624999999996],
            [-96.272877, 42.047238],
            [-96.2689, 42.113589999999995],
            [-96.347752, 42.166806],
            [-96.33600299999999, 42.264806],
            [-96.40799799999999, 42.337407999999996],
            [-96.411808, 42.410894],
            [-96.38130699999999, 42.461694],
            [-96.44550799999999, 42.490629999999996],
            [-96.49297, 42.517282],
            [-96.476952, 42.556079],
            [-96.526766, 42.641183999999996],
            [-96.624704, 42.725497],
            [-96.62187499999999, 42.779255],
            [-96.53785099999999, 42.878474999999995],
            [-96.54168899999999, 42.922576],
            [-96.50030799999999, 42.959391],
            [-96.51160499999999, 43.039927],
            [-96.458201, 43.067554],
            [-96.439335, 43.113915999999996],
            [-96.475571, 43.221053999999995],
            [-96.52208399999999, 43.22096],
            [-96.578823, 43.291095],
            [-96.53039199999999, 43.300034],
            [-96.52157199999999, 43.385639999999995],
            [-96.59425399999999, 43.434152999999995],
            [-96.598928, 43.500457],
            [-96.45326, 43.500389999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 21,
        STATENS: "01779786",
        AFFGEOID: "0400000US21",
        GEOID: 21,
        STUSPS: "KY",
        NAME: "Kentucky",
        LSAD: "00",
        ALAND: 102262419204,
        AWATER: 2393338940,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.132915, 36.982057],
            [-89.12889899999999, 37.017908],
            [-89.168087, 37.074217999999995],
            [-89.058036, 37.188767],
            [-89.000968, 37.224401],
            [-88.93174499999999, 37.227593],
            [-88.83505099999999, 37.196486],
            [-88.753068, 37.154700999999996],
            [-88.61144, 37.112745],
            [-88.531576, 37.067192],
            [-88.47612699999999, 37.068222999999996],
            [-88.424776, 37.149901],
            [-88.51466099999999, 37.290948],
            [-88.46586099999999, 37.400546999999996],
            [-88.418594, 37.421987],
            [-88.358436, 37.40486],
            [-88.281667, 37.452596],
            [-88.062294, 37.487837],
            [-88.072242, 37.528825999999995],
            [-88.131622, 37.572967999999996],
            [-88.160062, 37.654332],
            [-88.132341, 37.697142],
            [-88.05958799999999, 37.742608],
            [-88.02803, 37.799223999999995],
            [-87.97026199999999, 37.781856],
            [-87.903804, 37.817761999999995],
            [-87.93812799999999, 37.870650999999995],
            [-87.87254, 37.920998999999995],
            [-87.808013, 37.875191],
            [-87.723635, 37.892058],
            [-87.68163299999999, 37.855917],
            [-87.625851, 37.851918999999995],
            [-87.608479, 37.898793999999995],
            [-87.551277, 37.925418],
            [-87.486347, 37.920218],
            [-87.418585, 37.944763],
            [-87.25524999999999, 37.867326],
            [-87.18006299999999, 37.841375],
            [-87.105614, 37.767631],
            [-87.057836, 37.827456999999995],
            [-87.01031499999999, 37.919668],
            [-86.927747, 37.934956],
            [-86.810913, 37.99715],
            [-86.722247, 37.892648],
            [-86.61521499999999, 37.852857],
            [-86.599848, 37.906754],
            [-86.509368, 37.902887],
            [-86.52182499999999, 38.038326999999995],
            [-86.471903, 38.046217999999996],
            [-86.387216, 38.124632],
            [-86.321274, 38.147418],
            [-86.206439, 38.021876],
            [-86.095766, 38.00893],
            [-86.033386, 37.970382],
            [-85.922395, 38.028679],
            [-85.894764, 38.188469],
            [-85.816164, 38.282969],
            [-85.750962, 38.267869999999995],
            [-85.683561, 38.295469],
            [-85.64620099999999, 38.342915999999995],
            [-85.621625, 38.417089],
            [-85.587758, 38.450495],
            [-85.49886599999999, 38.468242],
            [-85.4156, 38.546341],
            [-85.43616999999999, 38.598292],
            [-85.44886199999999, 38.713367999999996],
            [-85.400481, 38.73598],
            [-85.275454, 38.741172],
            [-85.18727799999999, 38.687608999999995],
            [-85.071928, 38.741566999999996],
            [-84.962535, 38.778034999999996],
            [-84.812877, 38.786086999999995],
            [-84.786406, 38.88222],
            [-84.87776199999999, 38.920356999999996],
            [-84.832617, 38.961459999999995],
            [-84.897171, 39.052406999999995],
            [-84.820157, 39.10548],
            [-84.750749, 39.147358],
            [-84.677247, 39.098259999999996],
            [-84.607928, 39.073237999999996],
            [-84.462042, 39.121759999999995],
            [-84.40093999999999, 39.046361999999995],
            [-84.326539, 39.027463],
            [-84.232132, 38.880483],
            [-84.212904, 38.805707],
            [-84.051642, 38.771397],
            [-83.978814, 38.787104],
            [-83.852085, 38.751433],
            [-83.78362, 38.695640999999995],
            [-83.77216, 38.65815],
            [-83.679484, 38.630036],
            [-83.626922, 38.679387],
            [-83.533339, 38.702104999999996],
            [-83.376302, 38.661473],
            [-83.286514, 38.599241],
            [-83.239515, 38.628588],
            [-83.172647, 38.620252],
            [-83.112372, 38.671685],
            [-83.011816, 38.730056999999995],
            [-82.88919299999999, 38.756076],
            [-82.851314, 38.604334],
            [-82.800112, 38.563182999999995],
            [-82.724846, 38.5576],
            [-82.61847399999999, 38.477089],
            [-82.593673, 38.421808999999996],
            [-82.597979, 38.344909],
            [-82.571877, 38.315781],
            [-82.581796, 38.248591999999995],
            [-82.626182, 38.134834999999995],
            [-82.464987, 37.976859],
            [-82.487556, 37.916975],
            [-82.41869, 37.872375],
            [-82.327356, 37.762232999999995],
            [-82.29611799999999, 37.686174],
            [-82.226111, 37.653092],
            [-82.06441799999999, 37.544516],
            [-81.96829699999999, 37.537797999999995],
            [-82.35534299999999, 37.26522],
            [-82.449164, 37.243908],
            [-82.558178, 37.199605999999996],
            [-82.726294, 37.111852],
            [-82.72225399999999, 37.057947999999996],
            [-82.750715, 37.024107],
            [-82.86918299999999, 36.974182],
            [-82.865192, 36.920922999999995],
            [-82.895445, 36.882145],
            [-83.012587, 36.847288999999996],
            [-83.07558999999999, 36.850589],
            [-83.136395, 36.743088],
            [-83.23639899999999, 36.726887],
            [-83.43650799999999, 36.666185],
            [-83.527112, 36.665985],
            [-83.67541299999999, 36.600814],
            [-83.690714, 36.582581],
            [-83.987842, 36.589600000000004],
            [-84.499938, 36.596678],
            [-84.7853999785503, 36.6033754199356],
            [-85.096128, 36.622482999999995],
            [-85.290627, 36.62645],
            [-85.48835299999999, 36.614993999999996],
            [-85.873857, 36.623642],
            [-86.50777099999999, 36.652445],
            [-87.64115, 36.638036],
            [-87.85320399999999, 36.633247],
            [-87.849567, 36.663700999999996],
            [-88.070532, 36.678118],
            [-88.033802, 36.551733],
            [-88.050466, 36.500053],
            [-88.96447099999999, 36.502190999999996],
            [-89.21140899999999, 36.50563],
            [-89.539232, 36.497934],
            [-89.57148099999999, 36.538087],
            [-89.544434, 36.57451],
            [-89.407906, 36.562345],
            [-89.378694, 36.622292],
            [-89.324658, 36.624032],
            [-89.27893499999999, 36.577698999999996],
            [-89.227319, 36.569375],
            [-89.165488, 36.662425999999996],
            [-89.202511, 36.716618],
            [-89.15699, 36.755967999999996],
            [-89.147674, 36.847148],
            [-89.098843, 36.95785],
            [-89.132915, 36.982057],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 22,
        STATENS: "01629543",
        AFFGEOID: "0400000US22",
        GEOID: 22,
        STUSPS: "LA",
        NAME: "Louisiana",
        LSAD: "00",
        ALAND: 111901043977,
        AWATER: 23750204105,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.042964, 33.019219],
            [-92.971137, 33.017192],
            [-92.222825, 33.00908],
            [-91.166073, 33.004106],
            [-91.072075, 32.937832],
            [-91.070602, 32.888659],
            [-91.13789, 32.848974999999996],
            [-91.157614, 32.776033],
            [-91.113652, 32.73997],
            [-91.079506, 32.60068],
            [-91.011275, 32.516596],
            [-91.06051599999999, 32.512361],
            [-91.05290699999999, 32.438442],
            [-90.965986, 32.424806],
            [-90.986672, 32.35176],
            [-90.92116999999999, 32.342073],
            [-90.991227, 32.214662],
            [-91.108509, 32.208149999999996],
            [-91.034707, 32.101053],
            [-91.117409, 31.987057],
            [-91.17741, 31.973257],
            [-91.18110999999999, 31.920059],
            [-91.29013499999999, 31.833658],
            [-91.345714, 31.842861],
            [-91.35951399999999, 31.799362],
            [-91.318576, 31.745314999999998],
            [-91.380915, 31.732464],
            [-91.395715, 31.644164999999997],
            [-91.46381699999999, 31.620365],
            [-91.43761599999999, 31.546166],
            [-91.51714, 31.498393999999998],
            [-91.510356, 31.438927999999997],
            [-91.53606099999999, 31.338355],
            [-91.50885799999999, 31.291643999999998],
            [-91.56419199999999, 31.261633],
            [-91.621358, 31.267811],
            [-91.644356, 31.234413999999997],
            [-91.590051, 31.193693],
            [-91.62167099999999, 31.13687],
            [-91.56036499999999, 31.049508],
            [-91.63694199999999, 30.999416],
            [-90.346007, 31.000363],
            [-89.7281756901606, 31.002313887984098],
            [-89.750073, 30.91293],
            [-89.836331, 30.727197],
            [-89.791664, 30.551523999999997],
            [-89.712493, 30.47751],
            [-89.634208, 30.308256],
            [-89.607655, 30.217095999999998],
            [-89.524504, 30.180753],
            [-89.65698599999999, 30.118381],
            [-89.683712, 30.076017999999998],
            [-89.84506499999999, 30.01841],
            [-89.852583, 29.952721],
            [-89.744272, 29.917647],
            [-89.701725, 29.874084999999997],
            [-89.598129, 29.881408999999998],
            [-89.57442499999999, 29.983738],
            [-89.44461799999999, 30.060958999999997],
            [-89.342163, 30.059172],
            [-89.23316799999999, 30.134957],
            [-89.183256, 30.149344],
            [-89.185799, 30.063934],
            [-89.21567499999999, 29.993523],
            [-89.23629799999999, 29.877080999999997],
            [-89.293251, 29.803053],
            [-89.271034, 29.756355],
            [-89.39916199999999, 29.770591999999997],
            [-89.403956, 29.681808],
            [-89.50473799999999, 29.631508],
            [-89.535202, 29.648567],
            [-89.602109, 29.610294999999997],
            [-89.56461499999999, 29.543785999999997],
            [-89.56960699999999, 29.494044],
            [-89.53215, 29.434566999999998],
            [-89.48231799999999, 29.406222],
            [-89.312085, 29.388037999999998],
            [-89.257852, 29.336872],
            [-89.200389, 29.344417999999997],
            [-89.134337, 29.279339999999998],
            [-89.116653, 29.219531999999997],
            [-89.02597399999999, 29.215152999999997],
            [-89.01428, 29.166912999999997],
            [-89.066617, 29.090714],
            [-89.11653, 29.074097],
            [-89.148792, 29.02967],
            [-89.218673, 29.022515],
            [-89.259354, 29.058358],
            [-89.400966, 28.933812],
            [-89.40352999999999, 29.016963999999998],
            [-89.361098, 29.071848],
            [-89.482844, 29.215052999999997],
            [-89.606651, 29.252022999999998],
            [-89.639663, 29.290530999999998],
            [-89.842641, 29.318823],
            [-89.88346299999999, 29.307102999999998],
            [-90.058512, 29.183687],
            [-90.223587, 29.085075],
            [-90.334935, 29.063803],
            [-90.442734, 29.056053],
            [-90.65211599999999, 29.057720999999997],
            [-90.74837699999999, 29.04006],
            [-90.867853, 29.056064],
            [-90.877583, 29.104891],
            [-90.94187699999999, 29.162373],
            [-91.094015, 29.187711],
            [-91.158148, 29.2181],
            [-91.278792, 29.247775999999998],
            [-91.334885, 29.298775],
            [-91.265452, 29.360975999999997],
            [-91.334051, 29.391524999999998],
            [-91.34751399999999, 29.444437999999998],
            [-91.394307, 29.497114999999997],
            [-91.46096299999999, 29.469960999999998],
            [-91.531021, 29.531543],
            [-91.541974, 29.594352999999998],
            [-91.600179, 29.631155999999997],
            [-91.623829, 29.69924],
            [-91.66712799999999, 29.745822],
            [-91.737253, 29.74937],
            [-91.85307, 29.702935999999998],
            [-91.873266, 29.627277],
            [-91.711081, 29.569328],
            [-91.76826299999999, 29.490361999999998],
            [-91.821579, 29.473924999999998],
            [-92.06451299999999, 29.585665],
            [-92.15862399999999, 29.581616],
            [-92.25186, 29.539354],
            [-92.323465, 29.531496999999998],
            [-92.568038, 29.577396999999998],
            [-92.68448599999999, 29.605000999999998],
            [-92.993128, 29.723845999999998],
            [-93.17693, 29.770487],
            [-93.29557299999999, 29.775070999999997],
            [-93.538462, 29.763299],
            [-93.741948, 29.736342999999998],
            [-93.837971, 29.690618999999998],
            [-93.929208, 29.802951999999998],
            [-93.83037399999999, 29.894358999999998],
            [-93.80781499999999, 29.954549],
            [-93.70393999999999, 30.054291],
            [-93.70719, 30.275513],
            [-93.760328, 30.329924],
            [-93.745333, 30.397022],
            [-93.702665, 30.429947],
            [-93.72919499999999, 30.544842],
            [-93.685121, 30.625200999999997],
            [-93.629904, 30.67994],
            [-93.617688, 30.738478999999998],
            [-93.56930299999999, 30.802968999999997],
            [-93.530936, 30.924533999999998],
            [-93.549841, 30.967118],
            [-93.531219, 31.051678],
            [-93.535097, 31.185613999999998],
            [-93.602443, 31.182540999999997],
            [-93.613942, 31.259375],
            [-93.67544, 31.301039999999997],
            [-93.668146, 31.375103],
            [-93.697603, 31.428409],
            [-93.749476, 31.46869],
            [-93.834924, 31.586211],
            [-93.80341899999999, 31.700685999999997],
            [-93.85338999999999, 31.805467],
            [-93.90955699999999, 31.893144],
            [-93.97746099999999, 31.926419],
            [-94.041833, 31.992402],
            [-94.042964, 33.019219],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 24,
        STATENS: "01714934",
        AFFGEOID: "0400000US24",
        GEOID: 24,
        STUSPS: "MD",
        NAME: "Maryland",
        LSAD: "00",
        ALAND: 25147575220,
        AWATER: 6983455225,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.046213, 38.025532999999996],
              [-75.98008899999999, 38.004891],
              [-75.98464799999999, 37.938120999999995],
              [-76.04652999999999, 37.953586],
              [-76.046213, 38.025532999999996],
            ],
          ],
          [
            [
              [-79.47666199999999, 39.721078],
              [-79.045576, 39.722927999999996],
              [-78.075861, 39.722448],
              [-77.469274, 39.720228999999996],
              [-75.788596, 39.722198999999996],
              [-75.76690460670919, 39.3776515935512],
              [-75.693721, 38.460128],
              [-75.479283, 38.453697999999996],
              [-75.04893899999999, 38.451263],
              [-75.085518, 38.32427],
              [-75.102947, 38.311524999999996],
              [-75.19379599999999, 38.096013],
              [-75.242266, 38.027209],
              [-75.624341, 37.994211],
              [-75.66971099999999, 37.950796],
              [-75.78381499999999, 37.972594],
              [-75.860727, 37.91831],
              [-75.898956, 37.974514],
              [-75.857507, 38.038778],
              [-75.86381, 38.100968],
              [-75.937089, 38.124209],
              [-75.942375, 38.187066],
              [-75.864104, 38.200858],
              [-75.888513, 38.241423],
              [-76.038935, 38.254932],
              [-76.005904, 38.077169999999995],
              [-76.095548, 38.125122999999995],
              [-76.088639, 38.192648999999996],
              [-76.217613, 38.305682999999995],
              [-76.33636, 38.492235],
              [-76.277461, 38.541851],
              [-76.279589, 38.609519999999996],
              [-76.165435, 38.6102],
              [-76.175159, 38.673235999999996],
              [-76.238725, 38.712845],
              [-76.322418, 38.679303999999995],
              [-76.379739, 38.788314],
              [-76.310081, 38.796845999999995],
              [-76.271575, 38.851771],
              [-76.21932799999999, 38.812371],
              [-76.19109, 38.82966],
              [-76.203638, 38.928382],
              [-76.31794699999999, 38.911311999999995],
              [-76.334019, 38.860237999999995],
              [-76.37620199999999, 38.850460999999996],
              [-76.361727, 38.939175],
              [-76.301847, 39.039651],
              [-76.231765, 39.018518],
              [-76.233457, 39.091384999999995],
              [-76.278527, 39.145764],
              [-76.211253, 39.269812],
              [-76.11052699999999, 39.372257],
              [-76.00688, 39.414527],
              [-76.060931, 39.452208],
              [-76.146373, 39.40531],
              [-76.29660899999999, 39.301137],
              [-76.349994, 39.248822],
              [-76.425281, 39.205708],
              [-76.498384, 39.204808],
              [-76.525785, 39.177907999999995],
              [-76.428681, 39.131709],
              [-76.420394, 39.042069999999995],
              [-76.45027999999999, 38.941113],
              [-76.516944, 38.851157],
              [-76.48987799999999, 38.838715],
              [-76.55874299999999, 38.756352],
              [-76.52665499999999, 38.72443],
              [-76.51127799999999, 38.615745],
              [-76.517506, 38.539148999999995],
              [-76.492699, 38.482849],
              [-76.393378, 38.389477],
              [-76.402894, 38.311402],
              [-76.392668, 38.239663],
              [-76.32013599999999, 38.138338999999995],
              [-76.322093, 38.036502999999996],
              [-76.430425, 38.119383],
              [-76.481036, 38.115873],
              [-76.54038, 38.152991],
              [-76.590637, 38.214211999999996],
              [-76.740055, 38.235226999999995],
              [-76.86429199999999, 38.268944999999995],
              [-76.975492, 38.347327],
              [-77.01637099999999, 38.445572],
              [-77.21118799999999, 38.380662],
              [-77.259962, 38.435821],
              [-77.246584, 38.538340999999996],
              [-77.1302, 38.635017],
              [-77.13250099999999, 38.673815999999995],
              [-77.040998, 38.737913999999996],
              [-77.039006, 38.791644999999995],
              [-76.909393, 38.892852],
              [-77.041018, 38.995548],
              [-77.119759, 38.934343],
              [-77.14660099999999, 38.96421],
              [-77.249803, 38.985909],
              [-77.2484037049754, 39.026888354292296],
              [-77.310705, 39.052008],
              [-77.462617, 39.076248],
              [-77.51992899999999, 39.120925],
              [-77.521222, 39.161057],
              [-77.45988299999999, 39.218682],
              [-77.588235, 39.301955],
              [-77.71951899999999, 39.321314],
              [-77.740012, 39.401694],
              [-77.823762, 39.525907],
              [-77.829814, 39.587288],
              [-77.92598799999999, 39.607642],
              [-78.006734, 39.601337],
              [-78.08225999999999, 39.671166],
              [-78.22507499999999, 39.658878],
              [-78.382959, 39.622246],
              [-78.460951, 39.525987],
              [-78.590654, 39.530192],
              [-78.707098, 39.555856999999996],
              [-78.77114, 39.638387],
              [-78.851016, 39.554044],
              [-78.942618, 39.479614],
              [-78.956751, 39.440264],
              [-79.035623, 39.473344],
              [-79.091329, 39.472407],
              [-79.16649699999999, 39.400887999999995],
              [-79.283723, 39.30964],
              [-79.424413, 39.228170999999996],
              [-79.486873, 39.205960999999995],
              [-79.47666199999999, 39.721078],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 26,
        STATENS: "01779789",
        AFFGEOID: "0400000US26",
        GEOID: 26,
        STUSPS: "MI",
        NAME: "Michigan",
        LSAD: "00",
        ALAND: 146455316950,
        AWATER: 104031344385,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-84.61622, 45.89447],
              [-84.517895, 45.828542999999996],
              [-84.35602, 45.771895],
              [-84.394038, 45.727623],
              [-84.484128, 45.730709999999995],
              [-84.65078299999999, 45.85921],
              [-84.61622, 45.89447],
            ],
          ],
          [
            [
              [-85.701809, 45.736129],
              [-85.651866, 45.743139],
              [-85.52444799999999, 45.829794],
              [-85.360952, 45.817554],
              [-85.377132, 45.769013],
              [-85.509276, 45.596475],
              [-85.561634, 45.572213],
              [-85.62274099999999, 45.586028],
              [-85.696872, 45.69725],
              [-85.701809, 45.736129],
            ],
          ],
          [
            [
              [-86.13809499999999, 45.043037999999996],
              [-86.04442999999999, 45.159582],
              [-85.954021, 45.119281],
              [-85.976883, 45.06266],
              [-86.081487, 44.990096],
              [-86.15482399999999, 45.002393999999995],
              [-86.13809499999999, 45.043037999999996],
            ],
          ],
          [
            [
              [-83.45383199999999, 41.732647],
              [-84.134417, 41.712931],
              [-84.80608199999999, 41.696089],
              [-84.805883, 41.760216],
              [-85.79136299999999, 41.759051],
              [-86.824828, 41.760239999999996],
              [-86.69326699999999, 41.835403],
              [-86.597899, 41.918290999999996],
              [-86.466262, 42.134406],
              [-86.356218, 42.254166],
              [-86.284448, 42.394563],
              [-86.240642, 42.54],
              [-86.208309, 42.762789],
              [-86.226305, 42.988284],
              [-86.254646, 43.083408999999996],
              [-86.407832, 43.338436],
              [-86.479276, 43.515335],
              [-86.529507, 43.593461999999995],
              [-86.540787, 43.644593],
              [-86.445123, 43.771564],
              [-86.431198, 43.84072],
              [-86.46320311524849, 43.9710645597197],
              [-86.514702, 44.058119],
              [-86.42987099999999, 44.119782],
              [-86.26871, 44.345324],
              [-86.248914, 44.483004],
              [-86.220697, 44.566742],
              [-86.25394999999999, 44.64808],
              [-86.248474, 44.699045999999996],
              [-86.089186, 44.741496],
              [-86.065966, 44.821521999999995],
              [-86.05886199999999, 44.911012],
              [-85.98021899999999, 44.906136],
              [-85.9316, 44.968787999999996],
              [-85.854304, 44.938147],
              [-85.780439, 44.977931999999996],
              [-85.746444, 45.051229],
              [-85.681096, 45.092693],
              [-85.633124, 45.170899],
              [-85.55107199999999, 45.210741999999996],
              [-85.531461, 45.177247],
              [-85.56613, 45.043633],
              [-85.520034, 44.973996],
              [-85.380659, 45.046319],
              [-85.366749, 45.101591],
              [-85.38046399999999, 45.180876],
              [-85.37159299999999, 45.270834],
              [-85.196704, 45.360641],
              [-84.959119, 45.375972999999995],
              [-84.912956, 45.409776],
              [-85.040936, 45.436701],
              [-85.109252, 45.521626],
              [-85.119737, 45.569026],
              [-85.061488, 45.639505],
              [-84.97095, 45.686333999999995],
              [-85.01450899999999, 45.760329],
              [-84.866976, 45.752066],
              [-84.77276499999999, 45.789300999999995],
              [-84.718904, 45.777598999999995],
              [-84.46168, 45.652404],
              [-84.413642, 45.669427],
              [-84.329537, 45.66438],
              [-84.196043, 45.621455999999995],
              [-84.126532, 45.556616],
              [-84.095905, 45.497298],
              [-83.909472, 45.485783999999995],
              [-83.841543, 45.435286999999995],
              [-83.697316, 45.396239],
              [-83.599273, 45.352561],
              [-83.488826, 45.355872],
              [-83.385104, 45.274195],
              [-83.405914, 45.227157],
              [-83.315924, 45.139992],
              [-83.265896, 45.026844],
              [-83.399255, 45.070364],
              [-83.44205199999999, 45.051055999999996],
              [-83.438856, 44.940843],
              [-83.320503, 44.880570999999996],
              [-83.276836, 44.689353999999994],
              [-83.314517, 44.608725],
              [-83.31761, 44.486058],
              [-83.33698799999999, 44.332919],
              [-83.442731, 44.265361],
              [-83.524817, 44.261558],
              [-83.56774399999999, 44.155899],
              [-83.58408999999999, 44.056748],
              [-83.679654, 44.036364999999996],
              [-83.693214, 43.988769999999995],
              [-83.787863, 43.985279],
              [-83.869406, 43.960719],
              [-83.910613, 43.89322],
              [-83.94774, 43.735164999999995],
              [-83.90947899999999, 43.672622],
              [-83.817894, 43.673789],
              [-83.683351, 43.590584],
              [-83.51234, 43.733726],
              [-83.407146, 43.919807],
              [-83.28231, 43.938030999999995],
              [-83.26153, 43.973524999999995],
              [-83.046577, 44.01571],
              [-83.024604, 44.045173999999996],
              [-82.928884, 44.069389],
              [-82.793205, 44.023247],
              [-82.709839, 43.948226],
              [-82.633641, 43.831224],
              [-82.612224, 43.739771],
              [-82.593785, 43.581466999999996],
              [-82.53993, 43.422377999999995],
              [-82.52308599999999, 43.225361],
              [-82.486042, 43.102486],
              [-82.415937, 43.005555],
              [-82.469912, 42.887459],
              [-82.467483, 42.76191],
              [-82.509935, 42.637294],
              [-82.583996, 42.554041],
              [-82.679059, 42.52221],
              [-82.702518, 42.586242999999996],
              [-82.85931599999999, 42.541934999999995],
              [-82.870347, 42.450888],
              [-82.92397, 42.352067999999996],
              [-83.096521, 42.290138],
              [-83.133923, 42.17474],
              [-83.133511, 42.088142999999995],
              [-83.185526, 42.052243],
              [-83.216897, 41.988561],
              [-83.269521, 41.939042],
              [-83.32602399999999, 41.924960999999996],
              [-83.341557, 41.879956],
              [-83.44166799999999, 41.808645999999996],
              [-83.45383199999999, 41.732647],
            ],
          ],
          [
            [
              [-89.22133199999999, 47.908069],
              [-89.179154, 47.93503],
              [-88.94088599999999, 48.01959],
              [-88.81608399999999, 48.057006],
              [-88.631908, 48.148306999999996],
              [-88.425162, 48.21065],
              [-88.427373, 48.166764],
              [-88.55044, 48.102111],
              [-88.579172, 48.040758],
              [-88.718555, 47.995134],
              [-88.85292299999999, 47.965322],
              [-88.898986, 47.900684999999996],
              [-89.157738, 47.824014999999996],
              [-89.255202, 47.876101999999996],
              [-89.22133199999999, 47.908069],
            ],
          ],
          [
            [
              [-90.41813599999999, 46.566094],
              [-90.327626, 46.607744],
              [-90.04542, 46.668271999999995],
              [-89.918466, 46.740324],
              [-89.83195599999999, 46.804052999999996],
              [-89.720277, 46.830413],
              [-89.64225499999999, 46.82534],
              [-89.415154, 46.843982999999994],
              [-89.227914, 46.912954],
              [-89.142595, 46.984859],
              [-88.959409, 47.008496],
              [-88.88914, 47.100575],
              [-88.69966, 47.204831],
              [-88.584912, 47.242360999999995],
              [-88.50077999999999, 47.293503],
              [-88.418673, 47.371188],
              [-88.217822, 47.448738],
              [-88.085252, 47.468961],
              [-87.92926899999999, 47.478736999999995],
              [-87.80118399999999, 47.473301],
              [-87.680067, 47.455684999999995],
              [-87.591498, 47.424113],
              [-87.604704, 47.388625],
              [-87.94161299999999, 47.390073],
              [-87.94336, 47.335899],
              [-88.01647799999999, 47.306275],
              [-88.19421799999999, 47.209241999999996],
              [-88.23989499999999, 47.139435999999996],
              [-88.340052, 47.080493999999995],
              [-88.385606, 47.004521999999994],
              [-88.455404, 46.923321],
              [-88.477935, 46.850559999999994],
              [-88.372681, 46.872277],
              [-88.143688, 46.966665],
              [-88.065192, 46.918563],
              [-87.900339, 46.909686],
              [-87.687164, 46.841741999999996],
              [-87.59530699999999, 46.78295],
              [-87.57320299999999, 46.720470999999996],
              [-87.503025, 46.647497],
              [-87.381649, 46.580059],
              [-87.366767, 46.507303],
              [-87.17506499999999, 46.497547999999995],
              [-86.976958, 46.526581],
              [-86.903742, 46.466138],
              [-86.81096699999999, 46.449663],
              [-86.750157, 46.479109],
              [-86.695645, 46.555026],
              [-86.62738, 46.53371],
              [-86.55773099999999, 46.487434],
              [-86.45993, 46.551928],
              [-86.138295, 46.672934999999995],
              [-85.995044, 46.673676],
              [-85.84105699999999, 46.688896],
              [-85.482096, 46.680431999999996],
              [-85.25686, 46.75338],
              [-84.964652, 46.772845],
              [-85.028291, 46.675125],
              [-85.027374, 46.553756],
              [-84.969464, 46.47629],
              [-84.849767, 46.460245],
              [-84.678423, 46.487694],
              [-84.607945, 46.456747],
              [-84.49340099999999, 46.440312999999996],
              [-84.42027399999999, 46.501076999999995],
              [-84.293016, 46.492802999999995],
              [-84.19372899999999, 46.539919999999995],
              [-84.117925, 46.517618999999996],
              [-84.13890599999999, 46.372220999999996],
              [-84.097766, 46.256512],
              [-84.114941, 46.174113999999996],
              [-84.026536, 46.131648],
              [-83.974012, 46.081551999999995],
              [-83.882303, 46.042065],
              [-83.815826, 46.108529],
              [-83.598612, 46.090084999999995],
              [-83.480639, 45.996164],
              [-83.526347, 45.918636],
              [-83.583052, 45.915918999999995],
              [-83.65765999999999, 45.945463],
              [-83.80104, 45.937582],
              [-83.910838, 45.965613],
              [-84.08007099999999, 45.970822],
              [-84.254952, 45.956067999999995],
              [-84.376429, 45.931962],
              [-84.480436, 45.977764],
              [-84.567493, 45.947702],
              [-84.63285499999999, 45.951007],
              [-84.73400199999999, 45.907025999999995],
              [-84.706383, 45.848658],
              [-84.792763, 45.858691],
              [-84.917484, 45.93067],
              [-85.003597, 46.00613],
              [-85.15202699999999, 46.050725],
              [-85.381394, 46.082043999999996],
              [-85.540858, 46.079581],
              [-85.648581, 45.983695],
              [-85.697203, 45.960158],
              [-85.810442, 45.980087],
              [-85.913769, 45.919439],
              [-86.07206699999999, 45.965312999999995],
              [-86.278007, 45.942057],
              [-86.34913399999999, 45.83416],
              [-86.439661, 45.760669],
              [-86.54142999999999, 45.70811],
              [-86.61697199999999, 45.620581],
              [-86.636895, 45.542052999999996],
              [-86.712328, 45.610938999999995],
              [-86.705184, 45.690901],
              [-86.647319, 45.732617999999995],
              [-86.773279, 45.811385],
              [-86.838746, 45.722307],
              [-86.964275, 45.672761],
              [-87.070442, 45.718779],
              [-87.172241, 45.661788],
              [-87.35085199999999, 45.407742999999996],
              [-87.465201, 45.273351],
              [-87.548964, 45.191590999999995],
              [-87.59020799999999, 45.095264],
              [-87.648191, 45.106367999999996],
              [-87.741805, 45.197050999999995],
              [-87.667423, 45.316359999999996],
              [-87.657349, 45.368752],
              [-87.706767, 45.383827],
              [-87.750928, 45.355036999999996],
              [-87.863489, 45.35302],
              [-87.84742899999999, 45.444176999999996],
              [-87.805773, 45.473138999999996],
              [-87.777671, 45.609204],
              [-87.824676, 45.653211],
              [-87.805076, 45.703556],
              [-87.879812, 45.754843],
              [-87.96696999999999, 45.764021],
              [-87.995876, 45.795435],
              [-88.048514, 45.782548999999996],
              [-88.13506699999999, 45.821694],
              [-88.073944, 45.875592999999995],
              [-88.115346, 45.922211],
              [-88.246307, 45.962983],
              [-88.30951999999999, 45.959368999999995],
              [-88.380183, 45.991654],
              [-88.409864, 45.979687999999996],
              [-88.526673, 46.020821999999995],
              [-88.65776, 45.989287],
              [-88.739994, 46.027308],
              [-88.811948, 46.021609],
              [-89.09163, 46.138504999999995],
              [-90.12048899999999, 46.336852],
              [-90.15824099999999, 46.420485],
              [-90.214866, 46.499947],
              [-90.285707, 46.518845999999996],
              [-90.331887, 46.553278],
              [-90.387228, 46.533663],
              [-90.41813599999999, 46.566094],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 27,
        STATENS: "00662849",
        AFFGEOID: "0400000US27",
        GEOID: 27,
        STUSPS: "MN",
        NAME: "Minnesota",
        LSAD: "00",
        ALAND: 206236605303,
        AWATER: 18924324242,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-97.229039, 49.000687],
            [-95.153711, 48.998903],
            [-95.153314, 49.384358],
            [-95.058404, 49.35317],
            [-94.952111, 49.368679],
            [-94.816222, 49.320986999999995],
            [-94.774228, 49.124994],
            [-94.750221, 49.099762999999996],
            [-94.75021799999999, 48.999992],
            [-94.718932, 48.999990999999994],
            [-94.68306899999999, 48.883928999999995],
            [-94.694312, 48.789352],
            [-94.61900999999999, 48.737373999999996],
            [-94.508862, 48.700362],
            [-94.446604, 48.6929],
            [-94.388848, 48.711945],
            [-94.281797, 48.705255],
            [-94.250191, 48.656323],
            [-93.927004, 48.63122],
            [-93.844008, 48.629394999999995],
            [-93.80527, 48.570299],
            [-93.81517799999999, 48.526508],
            [-93.674568, 48.516296999999994],
            [-93.46750399999999, 48.545663999999995],
            [-93.464308, 48.591792],
            [-93.371156, 48.605084999999995],
            [-93.347528, 48.626619999999996],
            [-93.207398, 48.642474],
            [-93.14242, 48.624924],
            [-92.954876, 48.631493],
            [-92.89468699999999, 48.594915],
            [-92.72804599999999, 48.53929],
            [-92.634931, 48.542873],
            [-92.657101, 48.466915],
            [-92.57563599999999, 48.440827],
            [-92.51491, 48.448313],
            [-92.45632499999999, 48.414204],
            [-92.469948, 48.351836],
            [-92.369174, 48.220268],
            [-92.31466499999999, 48.240527],
            [-92.295412, 48.323957],
            [-92.26227999999999, 48.354932999999996],
            [-92.055228, 48.359213],
            [-92.00013299999999, 48.321355],
            [-91.980772, 48.247800999999995],
            [-91.89347, 48.237699],
            [-91.781182, 48.200432],
            [-91.71493099999999, 48.19913],
            [-91.69236599999999, 48.11933],
            [-91.55927199999999, 48.108267999999995],
            [-91.542512, 48.053267999999996],
            [-91.465499, 48.06677],
            [-91.336578, 48.069627],
            [-91.250112, 48.084087],
            [-91.15610699999999, 48.140474999999995],
            [-90.906829, 48.237339],
            [-90.84362399999999, 48.243576],
            [-90.77596199999999, 48.122229],
            [-90.70370199999999, 48.096008999999995],
            [-90.566113, 48.12262],
            [-90.471019, 48.106075999999995],
            [-90.31723, 48.103792999999996],
            [-90.136191, 48.112136],
            [-90.029626, 48.087588],
            [-89.973433, 48.02035],
            [-89.86815299999999, 47.989898],
            [-89.749314, 48.023325],
            [-89.625087, 48.011517],
            [-89.555015, 47.974849],
            [-89.66061599999999, 47.951215999999995],
            [-89.793539, 47.891358],
            [-89.923649, 47.862061999999995],
            [-89.974296, 47.830514],
            [-90.187636, 47.77813],
            [-90.42139, 47.73515],
            [-90.537105, 47.703055],
            [-90.73592699999999, 47.624342999999996],
            [-90.86827, 47.5569],
            [-91.02312471770209, 47.4649635160608],
            [-91.146958, 47.381464],
            [-91.262512, 47.279289999999996],
            [-91.456965, 47.139156],
            [-91.57381699999999, 47.089917],
            [-91.644564, 47.026491],
            [-91.73709799999999, 46.982853],
            [-91.806851, 46.933727],
            [-91.906483, 46.891236],
            [-92.062088, 46.804038],
            [-92.01529, 46.706469],
            [-92.10025499999999, 46.734446],
            [-92.143338, 46.731595999999996],
            [-92.20549199999999, 46.664741],
            [-92.292192, 46.663242],
            [-92.294033, 46.074377],
            [-92.35176, 46.015685],
            [-92.44963, 46.002252],
            [-92.47276099999999, 45.972952],
            [-92.545682, 45.970118],
            [-92.65612499999999, 45.924442],
            [-92.721128, 45.883804999999995],
            [-92.776496, 45.790014],
            [-92.869689, 45.715142],
            [-92.887929, 45.639005999999995],
            [-92.881136, 45.573409],
            [-92.756906, 45.557499],
            [-92.646768, 45.437929],
            [-92.698967, 45.336374],
            [-92.76186799999999, 45.284938],
            [-92.766932, 45.195111],
            [-92.74050899999999, 45.113395999999995],
            [-92.802911, 45.065402999999996],
            [-92.761904, 45.022467],
            [-92.750802, 44.941567],
            [-92.768574, 44.854368],
            [-92.80528699999999, 44.768361],
            [-92.696491, 44.689436],
            [-92.61802499999999, 44.61287],
            [-92.54928, 44.577704],
            [-92.314071, 44.538014],
            [-92.291005, 44.485464],
            [-92.232472, 44.445434],
            [-92.111085, 44.413948],
            [-91.9636, 44.362111999999996],
            [-91.916191, 44.318093999999995],
            [-91.892698, 44.231105],
            [-91.817302, 44.164235],
            [-91.71909699999999, 44.128853],
            [-91.64787299999999, 44.064108999999995],
            [-91.57328299999999, 44.026900999999995],
            [-91.440536, 44.001501],
            [-91.29100199999999, 43.852733],
            [-91.243955, 43.773046],
            [-91.273252, 43.666623],
            [-91.21770599999999, 43.50055],
            [-93.9707615585282, 43.49960500320739],
            [-95.21493799999999, 43.500885],
            [-96.45326, 43.500389999999996],
            [-96.452213, 44.360149],
            [-96.457781, 45.30761],
            [-96.52178699999999, 45.375645],
            [-96.710786, 45.43693],
            [-96.781036, 45.535972],
            [-96.84395699999999, 45.594003],
            [-96.82616, 45.654163999999994],
            [-96.672665, 45.732336],
            [-96.587093, 45.816444999999995],
            [-96.563672, 45.935244999999995],
            [-96.574264, 46.016545],
            [-96.554507, 46.083977999999995],
            [-96.59567, 46.21985],
            [-96.60104, 46.319554],
            [-96.70909499999999, 46.435294],
            [-96.744436, 46.56596],
            [-96.790523, 46.63688],
            [-96.788803, 46.777575],
            [-96.763973, 46.912507],
            [-96.83350399999999, 47.01011],
            [-96.81907799999999, 47.081151999999996],
            [-96.85748, 47.440456999999995],
            [-96.854073, 47.57201],
            [-96.928506, 47.744884],
            [-96.996364, 47.844398],
            [-97.06898699999999, 48.026267],
            [-97.146745, 48.168555999999995],
            [-97.129533, 48.257815],
            [-97.14912199999999, 48.532305],
            [-97.142915, 48.583732999999995],
            [-97.100009, 48.667925999999994],
            [-97.227854, 48.945864],
            [-97.229039, 49.000687],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 29,
        STATENS: "01779791",
        AFFGEOID: "0400000US29",
        GEOID: 29,
        STUSPS: "MO",
        NAME: "Missouri",
        LSAD: "00",
        ALAND: 178039995643,
        AWATER: 2500220114,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.76564499999999, 40.585208],
            [-94.533878, 40.570738999999996],
            [-94.09108499999999, 40.572897],
            [-93.135802, 40.582854],
            [-92.68669299999999, 40.589808999999995],
            [-91.939292, 40.60615],
            [-91.729115, 40.61364],
            [-91.670993, 40.550937],
            [-91.618999, 40.539083999999995],
            [-91.608347, 40.50004],
            [-91.498093, 40.401925999999996],
            [-91.419422, 40.378264],
            [-91.469656, 40.322409],
            [-91.511956, 40.170441],
            [-91.48406399999999, 40.019332],
            [-91.43709, 39.946417],
            [-91.43605099999999, 39.84551],
            [-91.361571, 39.787548],
            [-91.367753, 39.729029],
            [-91.17423199999999, 39.591975],
            [-91.148275, 39.545798],
            [-91.100307, 39.538695],
            [-91.03827, 39.448436],
            [-90.93741899999999, 39.400802999999996],
            [-90.84010599999999, 39.340438],
            [-90.72995999999999, 39.255894],
            [-90.70790199999999, 39.15086],
            [-90.681086, 39.10059],
            [-90.713629, 39.053976999999996],
            [-90.657254, 38.920269999999995],
            [-90.595354, 38.87505],
            [-90.55569299999999, 38.870785],
            [-90.50011699999999, 38.910408],
            [-90.467784, 38.961808999999995],
            [-90.395816, 38.960037],
            [-90.230336, 38.91086],
            [-90.113327, 38.849306],
            [-90.117707, 38.805748],
            [-90.20991, 38.72605],
            [-90.18110999999999, 38.659549999999996],
            [-90.18450999999999, 38.611551],
            [-90.248913, 38.544751999999995],
            [-90.288815, 38.438452999999996],
            [-90.34974299999999, 38.377609],
            [-90.372519, 38.323353999999995],
            [-90.36392599999999, 38.236354999999996],
            [-90.32235299999999, 38.181593],
            [-90.21870799999999, 38.094364999999996],
            [-90.12600599999999, 38.05057],
            [-90.008353, 37.970179],
            [-89.92318499999999, 37.870672],
            [-89.85104799999999, 37.90398],
            [-89.696559, 37.814336999999995],
            [-89.667993, 37.759484],
            [-89.521948, 37.696475],
            [-89.494051, 37.580116],
            [-89.5124, 37.52981],
            [-89.42594, 37.407471],
            [-89.428185, 37.356158],
            [-89.49516, 37.324795],
            [-89.517032, 37.28192],
            [-89.470525, 37.253357],
            [-89.456105, 37.18812],
            [-89.384175, 37.103266999999995],
            [-89.359456, 37.042606],
            [-89.195039, 36.989768],
            [-89.132915, 36.982057],
            [-89.098843, 36.95785],
            [-89.147674, 36.847148],
            [-89.15699, 36.755967999999996],
            [-89.202511, 36.716618],
            [-89.165488, 36.662425999999996],
            [-89.227319, 36.569375],
            [-89.27893499999999, 36.577698999999996],
            [-89.324658, 36.624032],
            [-89.378694, 36.622292],
            [-89.407906, 36.562345],
            [-89.544434, 36.57451],
            [-89.57148099999999, 36.538087],
            [-89.539232, 36.497934],
            [-89.54233699999999, 36.420103],
            [-89.522695, 36.344789],
            [-89.600544, 36.342985],
            [-89.611819, 36.309087999999996],
            [-89.554289, 36.277750999999995],
            [-89.602374, 36.238105999999995],
            [-89.678046, 36.248284],
            [-89.592102, 36.135636999999996],
            [-89.68002899999999, 36.082494],
            [-89.692437, 36.020506999999995],
            [-89.73309499999999, 36.000608],
            [-90.368718, 35.995812],
            [-90.29449199999999, 36.112949],
            [-90.235585, 36.139474],
            [-90.22042499999999, 36.184764],
            [-90.155928, 36.214074],
            [-90.06398, 36.303038],
            [-90.066136, 36.386272],
            [-90.13103799999999, 36.415068999999995],
            [-90.153871, 36.495343999999996],
            [-90.494575, 36.498368],
            [-91.404915, 36.497119999999995],
            [-91.64259, 36.499334999999995],
            [-92.35027699999999, 36.497786999999995],
            [-94.617919, 36.499414],
            [-94.617964, 36.998905],
            [-94.617885, 37.682213999999995],
            [-94.612614, 38.237766],
            [-94.612866, 38.477571],
            [-94.607354, 39.113444],
            [-94.62393399999999, 39.156603],
            [-94.680336, 39.184303],
            [-94.74193799999999, 39.170203],
            [-94.799663, 39.206018],
            [-94.908065, 39.323662999999996],
            [-94.888972, 39.392432],
            [-94.94666199999999, 39.399716999999995],
            [-95.113557, 39.553940999999995],
            [-95.04716499999999, 39.595116999999995],
            [-95.037464, 39.652905],
            [-94.971317, 39.686409999999995],
            [-94.97107799999999, 39.723146],
            [-94.899316, 39.724042],
            [-94.860371, 39.74953],
            [-94.878677, 39.826522],
            [-94.95154, 39.900532999999996],
            [-95.018743, 39.897372],
            [-95.08153399999999, 39.861717999999996],
            [-95.23111399999999, 39.943784],
            [-95.30829, 39.999998],
            [-95.38295699999999, 40.027111999999995],
            [-95.414734, 40.06982],
            [-95.394216, 40.108263],
            [-95.48102, 40.188524],
            [-95.47254799999999, 40.236078],
            [-95.54715999999999, 40.259066],
            [-95.553292, 40.291157999999996],
            [-95.653729, 40.322582],
            [-95.649418, 40.396149],
            [-95.71429099999999, 40.527208],
            [-95.75711, 40.52599],
            [-95.76564499999999, 40.585208],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 36,
        STATENS: "01779796",
        AFFGEOID: "0400000US36",
        GEOID: 36,
        STUSPS: "NY",
        NAME: "New York",
        LSAD: "00",
        ALAND: 122054577774,
        AWATER: 19242052501,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-72.018926, 41.274114],
              [-71.926802, 41.290122],
              [-71.917281, 41.251332999999995],
              [-72.03475399999999, 41.234818],
              [-72.018926, 41.274114],
            ],
          ],
          [
            [
              [-79.761951, 42.26986],
              [-79.627484, 42.324686],
              [-79.453533, 42.411156999999996],
              [-79.38194299999999, 42.466491],
              [-79.13856899999999, 42.564462],
              [-79.111361, 42.613358],
              [-79.06376, 42.644757999999996],
              [-79.04885999999999, 42.689158],
              [-78.904843, 42.746120999999995],
              [-78.851355, 42.791758],
              [-78.909159, 42.933257],
              [-79.019964, 42.994755999999995],
              [-79.00545, 43.057231],
              [-79.074467, 43.077855],
              [-79.044567, 43.153255],
              [-79.070469, 43.262454],
              [-78.83406099999999, 43.317555],
              [-78.547395, 43.369541],
              [-78.145195, 43.37551],
              [-77.76023099999999, 43.341161],
              [-77.660359, 43.282998],
              [-77.551022, 43.235763],
              [-77.341092, 43.280660999999995],
              [-77.13042899999999, 43.285635],
              [-76.952174, 43.270692],
              [-76.769025, 43.318452],
              [-76.684856, 43.352691],
              [-76.630774, 43.413356],
              [-76.417581, 43.521285],
              [-76.319701, 43.512274999999995],
              [-76.235834, 43.529256],
              [-76.203473, 43.574978],
              [-76.196596, 43.649761],
              [-76.22926799999999, 43.804134999999995],
              [-76.296758, 43.857079],
              [-76.441848, 43.882864],
              [-76.412138, 43.925675999999996],
              [-76.279314, 43.972462],
              [-76.30767399999999, 44.025276999999996],
              [-76.37556, 44.031535999999996],
              [-76.370706, 44.100499],
              [-76.33458399999999, 44.164944999999996],
              [-76.286547, 44.203773],
              [-76.206777, 44.214543],
              [-76.161833, 44.280777],
              [-76.000998, 44.347533999999996],
              [-75.94954, 44.349129],
              [-75.834126, 44.422433],
              [-75.76623, 44.515851],
              [-75.423943, 44.756329],
              [-75.255517, 44.857651],
              [-75.066245, 44.930174],
              [-74.992756, 44.977449],
              [-74.907956, 44.983359],
              [-74.83466899999999, 45.014683],
              [-74.74463999999999, 44.990576999999995],
              [-74.611048, 44.999203],
              [-74.23413599999999, 44.992148],
              [-73.343124, 45.010839999999995],
              [-73.338979, 44.917680999999995],
              [-73.37982199999999, 44.857037],
              [-73.33443, 44.802188],
              [-73.389966, 44.61962],
              [-73.36727499999999, 44.567544999999996],
              [-73.312871, 44.507245999999995],
              [-73.293613, 44.440559],
              [-73.334637, 44.356877],
              [-73.31661799999999, 44.257768999999996],
              [-73.395399, 44.166903],
              [-73.43688, 44.042578],
              [-73.405977, 44.011485],
              [-73.407742, 43.929887],
              [-73.374051, 43.875563],
              [-73.39030199999999, 43.817371],
              [-73.350707, 43.770463],
              [-73.414546, 43.658209],
              [-73.424977, 43.598774999999996],
              [-73.39576699999999, 43.568087],
              [-73.327702, 43.625913],
              [-73.242042, 43.534925],
              [-73.278673, 42.83341],
              [-73.264957, 42.74594],
              [-73.50814199999999, 42.086256999999996],
              [-73.487314, 42.049638],
              [-73.550961, 41.295421999999995],
              [-73.482709, 41.212759999999996],
              [-73.727775, 41.100696],
              [-73.659533, 41.017857],
              [-73.657336, 40.985171],
              [-73.697974, 40.939598],
              [-73.756776, 40.912599],
              [-73.713674, 40.870098999999996],
              [-73.49994099999999, 40.918166],
              [-73.392862, 40.955297],
              [-73.22928499999999, 40.905121],
              [-73.148994, 40.928898],
              [-73.110368, 40.971938],
              [-73.04044499999999, 40.964498],
              [-72.859831, 40.966088],
              [-72.708069, 40.977851],
              [-72.58532699999999, 40.997586999999996],
              [-72.354123, 41.139952],
              [-72.189163, 41.193549],
              [-72.283093, 41.067873999999996],
              [-72.21747599999999, 41.040611],
              [-72.162898, 41.053187],
              [-72.126704, 41.115139],
              [-72.095711, 41.05402],
              [-72.051928, 41.020506],
              [-71.959595, 41.071236999999996],
              [-71.856214, 41.070598],
              [-71.936977, 41.006136999999995],
              [-72.298727, 40.903151],
              [-72.39585, 40.866659999999996],
              [-72.757176, 40.764371],
              [-73.012545, 40.679651],
              [-73.20844, 40.630883999999995],
              [-73.35146499999999, 40.630500000000005],
              [-73.507325, 40.593410999999996],
              [-73.640902, 40.582823],
              [-73.774928, 40.590759],
              [-73.940591, 40.542896],
              [-74.057316, 40.597546],
              [-74.112585, 40.547602999999995],
              [-74.260611, 40.502435999999996],
              [-74.216839, 40.558617999999996],
              [-74.202247, 40.630902999999996],
              [-74.086806, 40.651596],
              [-74.047313, 40.690466],
              [-73.938081, 40.874699],
              [-73.8939818600359, 40.9971982035389],
              [-74.301994, 41.172594],
              [-74.694914, 41.357423],
              [-74.734893, 41.425818],
              [-74.89035799999999, 41.455324],
              [-74.982463, 41.496466999999996],
              [-75.04387899999999, 41.575094],
              [-75.053431, 41.752538],
              [-75.11336899999999, 41.840697999999996],
              [-75.26300499999999, 41.885109],
              [-75.29176199999999, 41.947092],
              [-75.34112499999999, 41.992771999999995],
              [-75.477144, 41.999407],
              [-76.462155, 41.998934],
              [-77.007635, 42.000848],
              [-77.83203, 41.998523999999996],
              [-78.59665, 41.999877],
              [-79.761313, 41.998808],
              [-79.761951, 42.26986],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 41,
        STATENS: "01155107",
        AFFGEOID: "0400000US41",
        GEOID: 41,
        STUSPS: "OR",
        NAME: "Oregon",
        LSAD: "00",
        ALAND: 248608666869,
        AWATER: 6190902750,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-123.547659, 46.259108999999995],
            [-123.47964400000001, 46.269130999999994],
            [-123.427629, 46.229347999999995],
            [-123.430847, 46.181827],
            [-123.371433, 46.146372],
            [-123.280166, 46.144842999999995],
            [-123.166414, 46.188973],
            [-123.115904, 46.185268],
            [-122.904119, 46.083734],
            [-122.813998, 45.960983999999996],
            [-122.785026, 45.867698999999995],
            [-122.795605, 45.81],
            [-122.761451, 45.759163],
            [-122.774511, 45.680437],
            [-122.738109, 45.644138],
            [-122.643907, 45.609739],
            [-122.492259, 45.583281],
            [-122.43867399999999, 45.563584999999996],
            [-122.380302, 45.575941],
            [-122.331502, 45.548241],
            [-122.262625, 45.544321],
            [-122.183695, 45.577695999999996],
            [-122.101675, 45.583515999999996],
            [-121.900858, 45.662009],
            [-121.811304, 45.706761],
            [-121.735104, 45.694039],
            [-121.533106, 45.726541],
            [-121.423592, 45.69399],
            [-121.33777, 45.704949],
            [-121.215779, 45.671237999999995],
            [-121.183841, 45.606441],
            [-121.1222, 45.616067],
            [-121.084933, 45.647892999999996],
            [-120.943977, 45.656445],
            [-120.895575, 45.642945],
            [-120.855674, 45.671544999999995],
            [-120.591166, 45.746547],
            [-120.505863, 45.700047999999995],
            [-120.40396, 45.699248999999995],
            [-120.210754, 45.725950999999995],
            [-120.141352, 45.773151999999996],
            [-120.07015, 45.785152],
            [-119.965744, 45.824365],
            [-119.802655, 45.84753],
            [-119.669877, 45.856867],
            [-119.600549, 45.919581],
            [-119.487829, 45.906307],
            [-119.25715, 45.939926],
            [-119.12612, 45.932859],
            [-118.987129, 45.999855],
            [-117.717852, 45.999866],
            [-116.915989, 45.995413],
            [-116.85979499999999, 45.907264],
            [-116.78752, 45.840204],
            [-116.665344, 45.781997999999994],
            [-116.59300400000001, 45.778541],
            [-116.535698, 45.734231],
            [-116.528272, 45.681473],
            [-116.463504, 45.615784999999995],
            [-116.502756, 45.566607999999995],
            [-116.67464799999999, 45.314341999999996],
            [-116.754643, 45.113972],
            [-116.841314, 45.030907],
            [-116.858313, 44.978761],
            [-116.833632, 44.928976],
            [-116.93180000000001, 44.787181],
            [-117.062273, 44.727143],
            [-117.14293, 44.557235999999996],
            [-117.225932, 44.479389],
            [-117.21507199999999, 44.427161999999996],
            [-117.243027, 44.390974],
            [-117.192203, 44.32863],
            [-117.216974, 44.288357],
            [-117.170342, 44.25889],
            [-117.121037, 44.277584999999995],
            [-117.059352, 44.237244],
            [-116.971958, 44.235676999999995],
            [-116.965498, 44.194126],
            [-116.895931, 44.154295],
            [-116.977351, 44.085364],
            [-116.937342, 44.029376],
            [-116.976024, 43.895548],
            [-117.023577, 43.823811],
            [-117.026889, 43.596033],
            [-117.026197, 41.99989],
            [-117.197798, 42.00038],
            [-118.501002, 41.995446],
            [-118.775869, 41.992692],
            [-119.72573, 41.996296],
            [-119.999168, 41.99454],
            [-121.035195, 41.993323],
            [-121.846712, 42.00307],
            [-122.501135, 42.00846],
            [-123.045254, 42.003049],
            [-123.145959, 42.009246999999995],
            [-123.347562, 41.999108],
            [-123.656998, 41.995137],
            [-124.21160499999999, 41.99846],
            [-124.314289, 42.067864],
            [-124.351535, 42.129796],
            [-124.383633, 42.22716],
            [-124.410982, 42.250547],
            [-124.435105, 42.440163],
            [-124.39906500000001, 42.539927999999996],
            [-124.413119, 42.657934],
            [-124.510017, 42.734746],
            [-124.552441, 42.840568],
            [-124.480938, 42.951495],
            [-124.43619799999999, 43.071312],
            [-124.38246, 43.270167],
            [-124.400404, 43.302121],
            [-124.353332, 43.342667],
            [-124.286896, 43.436296],
            [-124.23353399999999, 43.55713],
            [-124.193455, 43.706084999999995],
            [-124.150267, 43.910849999999996],
            [-124.122406, 44.104442],
            [-124.1152, 44.286486],
            [-124.084401, 44.415611],
            [-124.083601, 44.501123],
            [-124.065008, 44.632504],
            [-124.074066, 44.798106999999995],
            [-124.023834, 44.949825],
            [-124.00977, 45.047266],
            [-123.975425, 45.145475999999995],
            [-123.962887, 45.280218],
            [-123.979715, 45.347724],
            [-123.960557, 45.430778],
            [-123.976544, 45.489733],
            [-123.94755599999999, 45.564878],
            [-123.939448, 45.708794999999995],
            [-123.968563, 45.757019],
            [-123.96763, 45.907807],
            [-123.993703, 45.946431],
            [-123.937471, 45.977306],
            [-123.92933, 46.041978],
            [-123.95919, 46.141675],
            [-124.041128, 46.197672],
            [-123.998052, 46.235327],
            [-123.912405, 46.179449999999996],
            [-123.757589, 46.213001],
            [-123.718149, 46.188989],
            [-123.586205, 46.228654],
            [-123.547659, 46.259108999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 47,
        STATENS: "01325873",
        AFFGEOID: "0400000US47",
        GEOID: 47,
        STUSPS: "TN",
        NAME: "Tennessee",
        LSAD: "00",
        ALAND: 106800130794,
        AWATER: 2352882756,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.73309499999999, 36.000608],
            [-89.692437, 36.020506999999995],
            [-89.68002899999999, 36.082494],
            [-89.592102, 36.135636999999996],
            [-89.678046, 36.248284],
            [-89.602374, 36.238105999999995],
            [-89.554289, 36.277750999999995],
            [-89.611819, 36.309087999999996],
            [-89.600544, 36.342985],
            [-89.522695, 36.344789],
            [-89.54233699999999, 36.420103],
            [-89.539232, 36.497934],
            [-89.21140899999999, 36.50563],
            [-88.96447099999999, 36.502190999999996],
            [-88.050466, 36.500053],
            [-88.033802, 36.551733],
            [-88.070532, 36.678118],
            [-87.849567, 36.663700999999996],
            [-87.85320399999999, 36.633247],
            [-87.64115, 36.638036],
            [-86.50777099999999, 36.652445],
            [-85.873857, 36.623642],
            [-85.48835299999999, 36.614993999999996],
            [-85.290627, 36.62645],
            [-85.096128, 36.622482999999995],
            [-84.7853999785503, 36.6033754199356],
            [-84.499938, 36.596678],
            [-83.987842, 36.589600000000004],
            [-83.690714, 36.582581],
            [-83.67541299999999, 36.600814],
            [-82.830433, 36.593761],
            [-82.48723799999999, 36.595822],
            [-81.93414399999999, 36.594212999999996],
            [-81.92264399999999, 36.616212999999995],
            [-81.6469, 36.611917999999996],
            [-81.67753499999999, 36.588117],
            [-81.699962, 36.536829],
            [-81.69531099999999, 36.467912],
            [-81.734312, 36.413342],
            [-81.70596599999999, 36.338496],
            [-81.833202, 36.347339],
            [-81.908137, 36.302012999999995],
            [-82.02874, 36.124322],
            [-82.127146, 36.104417],
            [-82.140847, 36.136216],
            [-82.21125099999999, 36.159012],
            [-82.29765499999999, 36.13351],
            [-82.409458, 36.083408999999996],
            [-82.464558, 36.006508],
            [-82.557874, 35.953901],
            [-82.610885, 35.974441999999996],
            [-82.595525, 36.026012],
            [-82.628365, 36.062104999999995],
            [-82.779397, 35.992511],
            [-82.81613, 35.923986],
            [-82.86072399999999, 35.94743],
            [-82.910608, 35.92693],
            [-82.899718, 35.874601999999996],
            [-82.978414, 35.78261],
            [-83.04853, 35.787706],
            [-83.161537, 35.763363],
            [-83.198267, 35.725494],
            [-83.25535099999999, 35.716229999999996],
            [-83.29715399999999, 35.65775],
            [-83.347262, 35.660474],
            [-83.498335, 35.562981],
            [-83.653159, 35.568309],
            [-83.77173599999999, 35.562118],
            [-83.91680099999999, 35.473611999999996],
            [-83.973171, 35.452582],
            [-84.021782, 35.407418],
            [-84.03808099999999, 35.348363],
            [-84.02351, 35.295783],
            [-84.09750799999999, 35.247382],
            [-84.178516, 35.240679],
            [-84.22371799999999, 35.269078],
            [-84.28322, 35.226577],
            [-84.32186899999999, 34.988408],
            [-85.045183, 34.986883],
            [-85.384967, 34.982987],
            [-85.605165, 34.984677999999995],
            [-86.311274, 34.991098],
            [-86.783648, 34.991925],
            [-87.21668299999999, 34.999148],
            [-88.20295899999999, 35.008027999999996],
            [-88.200064, 34.995633999999995],
            [-89.43495399999999, 34.993753999999996],
            [-90.309297, 34.995694],
            [-90.300697, 35.028793],
            [-90.19714599999999, 35.050731],
            [-90.16005799999999, 35.12883],
            [-90.09061, 35.118286999999995],
            [-90.09794699999999, 35.249983],
            [-90.121864, 35.304535],
            [-90.022064, 35.457375],
            [-90.045805, 35.496533],
            [-90.037615, 35.550329],
            [-89.95849799999999, 35.541703],
            [-89.9325, 35.607865],
            [-89.876548, 35.626653],
            [-89.956589, 35.695485999999995],
            [-89.915491, 35.754917],
            [-89.863874, 35.747592],
            [-89.72342599999999, 35.809382],
            [-89.722634, 35.873718],
            [-89.652279, 35.921462],
            [-89.73309499999999, 36.000608],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 48,
        STATENS: "01779801",
        AFFGEOID: "0400000US48",
        GEOID: 48,
        STUSPS: "TX",
        NAME: "Texas",
        LSAD: "00",
        ALAND: 676601887070,
        AWATER: 19059877230,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.002434, 36.500397],
            [-101.085156, 36.499244],
            [-100.000406, 36.499702],
            [-100.000381, 34.560508999999996],
            [-99.929334, 34.576713999999996],
            [-99.696462, 34.381036],
            [-99.600026, 34.374688],
            [-99.58448, 34.407672999999996],
            [-99.42043199999999, 34.380463999999996],
            [-99.394956, 34.442099],
            [-99.35040699999999, 34.437083],
            [-99.27534, 34.386599],
            [-99.2116, 34.31397],
            [-99.189511, 34.214312],
            [-99.0588, 34.201256],
            [-98.94022, 34.203686],
            [-98.87222899999999, 34.160446],
            [-98.690072, 34.133154999999995],
            [-98.648073, 34.164441],
            [-98.577136, 34.148962],
            [-98.475066, 34.064268999999996],
            [-98.41442599999999, 34.085074],
            [-98.36402299999999, 34.157109],
            [-98.16911999999999, 34.114171],
            [-98.12337699999999, 34.15454],
            [-98.099328, 34.104295],
            [-98.08283899999999, 34.002412],
            [-97.947572, 33.991053],
            [-97.95121499999999, 33.878423999999995],
            [-97.865765, 33.849393],
            [-97.803473, 33.88019],
            [-97.67177199999999, 33.991369999999996],
            [-97.60909099999999, 33.968092999999996],
            [-97.55827, 33.897099],
            [-97.486505, 33.916993999999995],
            [-97.444193, 33.823772999999996],
            [-97.372941, 33.819454],
            [-97.318243, 33.865120999999995],
            [-97.206141, 33.91428],
            [-97.166629, 33.847311],
            [-97.205652, 33.809824],
            [-97.149394, 33.721967],
            [-97.091072, 33.735115],
            [-97.055838, 33.855741],
            [-96.98556699999999, 33.886522],
            [-96.95231299999999, 33.944582],
            [-96.85059299999999, 33.847211],
            [-96.71242199999999, 33.831633],
            [-96.65989599999999, 33.916666],
            [-96.59011199999999, 33.880665],
            [-96.59292599999999, 33.830916],
            [-96.52386299999999, 33.818114],
            [-96.502286, 33.77346],
            [-96.436455, 33.780049999999996],
            [-96.363135, 33.694215],
            [-96.27726899999999, 33.769735],
            [-96.229023, 33.748021],
            [-96.15163, 33.831945999999995],
            [-96.063924, 33.841522999999995],
            [-95.93532499999999, 33.875099],
            [-95.820596, 33.858464999999995],
            [-95.73750799999999, 33.895967],
            [-95.603657, 33.927195],
            [-95.55691499999999, 33.92702],
            [-95.525322, 33.885487],
            [-95.44736999999999, 33.86885],
            [-95.283445, 33.877746],
            [-95.226393, 33.961954],
            [-95.149462, 33.936336],
            [-95.046568, 33.862565],
            [-94.98165, 33.852284],
            [-94.902276, 33.776289],
            [-94.841634, 33.739430999999996],
            [-94.76614599999999, 33.748031],
            [-94.71486499999999, 33.707260999999995],
            [-94.630586, 33.673401],
            [-94.57287199999999, 33.669886],
            [-94.528928, 33.62184],
            [-94.485875, 33.637867],
            [-94.419057, 33.577217],
            [-94.354165, 33.556452],
            [-94.18339499999999, 33.592211999999996],
            [-94.07267, 33.572234],
            [-94.04342799999999, 33.551425],
            [-94.042964, 33.019219],
            [-94.041833, 31.992402],
            [-93.97746099999999, 31.926419],
            [-93.90955699999999, 31.893144],
            [-93.85338999999999, 31.805467],
            [-93.80341899999999, 31.700685999999997],
            [-93.834924, 31.586211],
            [-93.749476, 31.46869],
            [-93.697603, 31.428409],
            [-93.668146, 31.375103],
            [-93.67544, 31.301039999999997],
            [-93.613942, 31.259375],
            [-93.602443, 31.182540999999997],
            [-93.535097, 31.185613999999998],
            [-93.531219, 31.051678],
            [-93.549841, 30.967118],
            [-93.530936, 30.924533999999998],
            [-93.56930299999999, 30.802968999999997],
            [-93.617688, 30.738478999999998],
            [-93.629904, 30.67994],
            [-93.685121, 30.625200999999997],
            [-93.72919499999999, 30.544842],
            [-93.702665, 30.429947],
            [-93.745333, 30.397022],
            [-93.760328, 30.329924],
            [-93.70719, 30.275513],
            [-93.70393999999999, 30.054291],
            [-93.80781499999999, 29.954549],
            [-93.83037399999999, 29.894358999999998],
            [-93.929208, 29.802951999999998],
            [-93.837971, 29.690618999999998],
            [-94.056506, 29.671163],
            [-94.161549, 29.636588],
            [-94.594853, 29.467903],
            [-94.670389, 29.43078],
            [-94.73104699999999, 29.369141],
            [-94.72252999999999, 29.331446],
            [-95.026219, 29.148063999999998],
            [-95.191391, 29.02309],
            [-95.38239, 28.866348],
            [-95.439594, 28.859022],
            [-95.81250399999999, 28.664942],
            [-96.194412, 28.502224],
            [-96.39037599999999, 28.381815],
            [-96.442849, 28.317666],
            [-96.63201, 28.222821],
            [-96.792158, 28.110497],
            [-96.886459, 28.030734],
            [-97.00332499999999, 27.908306999999997],
            [-97.04484599999999, 27.834466],
            [-97.14085399999999, 27.716687999999998],
            [-97.212679, 27.59642],
            [-97.29605699999999, 27.427175],
            [-97.358469, 27.234796],
            [-97.378697, 27.060043999999998],
            [-97.366872, 26.885581],
            [-97.32275, 26.701746],
            [-97.253801, 26.503163999999998],
            [-97.196935, 26.305864999999997],
            [-97.145567, 25.971131999999997],
            [-97.338346, 25.923125],
            [-97.37286399999999, 25.840117],
            [-97.422636, 25.840377999999998],
            [-97.582565, 25.937856999999997],
            [-97.64401099999999, 26.006614],
            [-97.758838, 26.032131],
            [-97.79529099999999, 26.055218],
            [-98.010971, 26.063862999999998],
            [-98.197046, 26.056153],
            [-98.248806, 26.073100999999998],
            [-98.44253599999999, 26.199151],
            [-98.61346499999999, 26.252028],
            [-98.65422099999999, 26.23596],
            [-98.779912, 26.326542],
            [-98.80734799999999, 26.369421],
            [-98.890965, 26.357568999999998],
            [-98.958325, 26.394056],
            [-99.032316, 26.412081999999998],
            [-99.08200199999999, 26.39651],
            [-99.110855, 26.426278],
            [-99.091635, 26.476976999999998],
            [-99.171404, 26.549847999999997],
            [-99.208907, 26.724760999999997],
            [-99.268613, 26.843213],
            [-99.3289, 26.879761],
            [-99.387367, 26.982398999999997],
            [-99.44697, 27.026025999999998],
            [-99.42998399999999, 27.159149],
            [-99.463309, 27.268437],
            [-99.529654, 27.306051],
            [-99.487521, 27.412395999999998],
            [-99.497519, 27.500496],
            [-99.52832, 27.498896],
            [-99.530138, 27.580206999999998],
            [-99.556812, 27.614335999999998],
            [-99.704601, 27.654954],
            [-99.758534, 27.717070999999997],
            [-99.844737, 27.778809],
            [-99.90438499999999, 27.875283999999997],
            [-99.932161, 27.96771],
            [-99.984923, 27.990728999999998],
            [-100.028725, 28.073117999999997],
            [-100.075474, 28.124882],
            [-100.174413, 28.179447999999997],
            [-100.267604, 28.250269],
            [-100.320393, 28.362116999999998],
            [-100.337059, 28.427151],
            [-100.38886, 28.515748],
            [-100.39727, 28.575637],
            [-100.500354, 28.661959999999997],
            [-100.53583, 28.805888],
            [-100.627206, 28.903734],
            [-100.674656, 29.099777],
            [-100.772649, 29.168491999999997],
            [-100.795681, 29.227729999999998],
            [-100.886842, 29.307848],
            [-100.995607, 29.363402999999998],
            [-101.060151, 29.458661],
            [-101.137503, 29.473542],
            [-101.19272, 29.520284999999998],
            [-101.254895, 29.520342],
            [-101.305533, 29.577924999999997],
            [-101.307332, 29.640715999999998],
            [-101.367198, 29.664040999999997],
            [-101.400636, 29.738079],
            [-101.503223, 29.764581999999997],
            [-101.561569, 29.794658],
            [-101.654578, 29.765162999999998],
            [-101.966167, 29.807343],
            [-102.073646, 29.786925999999998],
            [-102.301381, 29.877674],
            [-102.349861, 29.862316999999997],
            [-102.392906, 29.765569],
            [-102.512687, 29.780303],
            [-102.551081, 29.752357999999997],
            [-102.677192, 29.738260999999998],
            [-102.693466, 29.676506999999997],
            [-102.808692, 29.522319],
            [-102.83097, 29.444267],
            [-102.824564, 29.399558],
            [-102.871857, 29.352093],
            [-102.891022, 29.287112999999998],
            [-102.871347, 29.241625],
            [-102.917805, 29.190697],
            [-102.995688, 29.161219],
            [-103.035683, 29.103029],
            [-103.076355, 29.085721999999997],
            [-103.126748, 28.982124],
            [-103.227801, 28.991532],
            [-103.28119, 28.982138],
            [-103.463196, 29.066822],
            [-103.524613, 29.120998],
            [-103.724743, 29.19147],
            [-103.789034, 29.257502],
            [-103.856893, 29.281851999999997],
            [-103.975235, 29.296017],
            [-104.143692, 29.383277999999997],
            [-104.229081, 29.48105],
            [-104.371175, 29.543063],
            [-104.539761, 29.676074],
            [-104.565688, 29.770462],
            [-104.672327, 29.911112],
            [-104.703998, 30.02421],
            [-104.692094, 30.107304],
            [-104.702788, 30.211736],
            [-104.761634, 30.301147999999998],
            [-104.859521, 30.390413],
            [-104.889376, 30.535144],
            [-104.924796, 30.604832],
            [-104.972071, 30.61026],
            [-105.00124, 30.672583],
            [-105.06233399999999, 30.686303],
            [-105.21866, 30.801567],
            [-105.314863, 30.816961],
            [-105.394242, 30.852978999999998],
            [-105.399609, 30.888941],
            [-105.55743, 30.990229],
            [-105.627349, 31.098544999999998],
            [-105.773257, 31.166897],
            [-105.869353, 31.288634],
            [-105.938452, 31.318735],
            [-105.953943, 31.364749],
            [-106.004926, 31.392457999999998],
            [-106.080258, 31.398702],
            [-106.175675, 31.456279],
            [-106.280811, 31.562061999999997],
            [-106.303536, 31.620413],
            [-106.370139, 31.71071],
            [-106.41794, 31.752008999999997],
            [-106.484642, 31.747809],
            [-106.528242, 31.783147999999997],
            [-106.63588, 31.871513999999998],
            [-106.618486, 32.000495],
            [-105.750527, 32.002206],
            [-105.153994, 32.000496999999996],
            [-103.064423, 32.000518],
            [-103.064889, 32.849359],
            [-103.060103, 33.219225],
            [-103.043516, 34.079381999999995],
            [-103.043946, 34.379554999999996],
            [-103.040824, 36.055231],
            [-103.041924, 36.500439],
            [-103.002434, 36.500397],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 51,
        STATENS: "01779803",
        AFFGEOID: "0400000US51",
        GEOID: 51,
        STUSPS: "VA",
        NAME: "Virginia",
        LSAD: "00",
        ALAND: 102283343474,
        AWATER: 8504608966,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-75.66971099999999, 37.950796],
              [-75.624341, 37.994211],
              [-75.242266, 38.027209],
              [-75.38063799999999, 37.851701999999996],
              [-75.43900099999999, 37.869335],
              [-75.48926999999999, 37.832457],
              [-75.551898, 37.748121999999995],
              [-75.614527, 37.609296],
              [-75.607824, 37.560705999999996],
              [-75.672877, 37.483695999999995],
              [-75.658379, 37.451814999999996],
              [-75.778817, 37.297176],
              [-75.817387, 37.193436999999996],
              [-75.942399, 37.089607],
              [-75.979608, 37.100448],
              [-76.02347499999999, 37.289066999999996],
              [-75.987122, 37.368548],
              [-75.976491, 37.444877999999996],
              [-75.941182, 37.563839],
              [-75.859262, 37.703111],
              [-75.81215499999999, 37.749502],
              [-75.818125, 37.791698],
              [-75.73588, 37.816561],
              [-75.70291399999999, 37.849658999999996],
              [-75.757694, 37.903912],
              [-75.66971099999999, 37.950796],
            ],
          ],
          [
            [
              [-81.96829699999999, 37.537797999999995],
              [-81.932279, 37.511961],
              [-81.98489099999999, 37.454315],
              [-81.849949, 37.285227],
              [-81.77474699999999, 37.274847],
              [-81.678603, 37.202467],
              [-81.560625, 37.206663],
              [-81.42794599999999, 37.271015],
              [-81.362156, 37.337686999999995],
              [-81.225104, 37.234874],
              [-81.112596, 37.278497],
              [-80.919259, 37.306163],
              [-80.83547899999999, 37.334824],
              [-80.883248, 37.383933],
              [-80.836446, 37.424355],
              [-80.770082, 37.372363],
              [-80.54483599999999, 37.474695],
              [-80.46482, 37.426144],
              [-80.29164399999999, 37.536505],
              [-80.28244, 37.585481],
              [-80.22338599999999, 37.623185],
              [-80.29225799999999, 37.683732],
              [-80.25814299999999, 37.720611999999996],
              [-80.19963299999999, 37.827507],
              [-80.036236, 37.96792],
              [-79.971231, 38.044326],
              [-79.916174, 38.184385999999996],
              [-79.787542, 38.273298],
              [-79.804093, 38.313922],
              [-79.7346, 38.356728],
              [-79.689675, 38.431439],
              [-79.649075, 38.591515],
              [-79.54257, 38.553217],
              [-79.476638, 38.457228],
              [-79.297758, 38.416438],
              [-79.23161999999999, 38.474041],
              [-79.15435699999999, 38.606518],
              [-79.092955, 38.659517],
              [-79.057253, 38.761413],
              [-78.999014, 38.840074],
              [-78.869276, 38.762991],
              [-78.772793, 38.893741999999996],
              [-78.681617, 38.92584],
              [-78.620453, 38.982600999999995],
              [-78.561711, 39.009007],
              [-78.508132, 39.088629999999995],
              [-78.413943, 39.158415],
              [-78.428697, 39.187217],
              [-78.40181299999999, 39.276754],
              [-78.34048, 39.353491999999996],
              [-78.347087, 39.466012],
              [-77.82830183326729, 39.1324224548325],
              [-77.71951899999999, 39.321314],
              [-77.588235, 39.301955],
              [-77.45988299999999, 39.218682],
              [-77.521222, 39.161057],
              [-77.51992899999999, 39.120925],
              [-77.462617, 39.076248],
              [-77.310705, 39.052008],
              [-77.2484037049754, 39.026888354292296],
              [-77.249803, 38.985909],
              [-77.14660099999999, 38.96421],
              [-77.119759, 38.934343],
              [-77.039099, 38.868111999999996],
              [-77.039006, 38.791644999999995],
              [-77.040998, 38.737913999999996],
              [-77.13250099999999, 38.673815999999995],
              [-77.1302, 38.635017],
              [-77.246704, 38.635217],
              [-77.29527399999999, 38.562125],
              [-77.322622, 38.467130999999995],
              [-77.31728799999999, 38.383576],
              [-77.265295, 38.333165],
              [-77.048137, 38.360144999999996],
              [-77.026304, 38.302685],
              [-76.957796, 38.243182999999995],
              [-76.962311, 38.214075],
              [-76.83879499999999, 38.163475999999996],
              [-76.613939, 38.148587],
              [-76.600937, 38.110084],
              [-76.53591899999999, 38.069531999999995],
              [-76.491998, 38.017222],
              [-76.427487, 37.977038],
              [-76.316952, 37.934929],
              [-76.23672499999999, 37.889174],
              [-76.251358, 37.833072],
              [-76.310307, 37.794849],
              [-76.32912, 37.670975999999996],
              [-76.27944699999999, 37.618224999999995],
              [-76.29796, 37.557635999999995],
              [-76.25045399999999, 37.421886],
              [-76.27555199999999, 37.309964],
              [-76.393958, 37.395939999999996],
              [-76.437525, 37.37975],
              [-76.36229, 37.270226],
              [-76.394132, 37.22515],
              [-76.3431, 37.186551],
              [-76.271262, 37.084544],
              [-76.304272, 37.001377999999995],
              [-76.267962, 36.964546999999996],
              [-76.189959, 36.931447],
              [-76.087955, 36.908646999999995],
              [-75.996252, 36.922047],
              [-75.961589, 36.799994999999996],
              [-75.890946, 36.630753],
              [-75.86704399999999, 36.550754],
              [-76.738329, 36.550985],
              [-76.917318, 36.546046],
              [-77.749706, 36.545519999999996],
              [-78.509965, 36.541064999999996],
              [-79.51064699999999, 36.540738],
              [-80.295243, 36.543973],
              [-80.704831, 36.562318999999995],
              [-80.9018360537965, 36.5617546210407],
              [-81.499831, 36.57982],
              [-81.67753499999999, 36.588117],
              [-81.6469, 36.611917999999996],
              [-81.92264399999999, 36.616212999999995],
              [-81.93414399999999, 36.594212999999996],
              [-82.48723799999999, 36.595822],
              [-82.830433, 36.593761],
              [-83.67541299999999, 36.600814],
              [-83.527112, 36.665985],
              [-83.43650799999999, 36.666185],
              [-83.23639899999999, 36.726887],
              [-83.136395, 36.743088],
              [-83.07558999999999, 36.850589],
              [-83.012587, 36.847288999999996],
              [-82.895445, 36.882145],
              [-82.865192, 36.920922999999995],
              [-82.86918299999999, 36.974182],
              [-82.750715, 37.024107],
              [-82.72225399999999, 37.057947999999996],
              [-82.726294, 37.111852],
              [-82.558178, 37.199605999999996],
              [-82.449164, 37.243908],
              [-82.35534299999999, 37.26522],
              [-81.96829699999999, 37.537797999999995],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 55,
        STATENS: "01779806",
        AFFGEOID: "0400000US55",
        GEOID: 55,
        STUSPS: "WI",
        NAME: "Wisconsin",
        LSAD: "00",
        ALAND: 140269495483,
        AWATER: 29365430262,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-86.934276, 45.421149],
              [-86.83574899999999, 45.450188],
              [-86.80586799999999, 45.412903],
              [-86.86774299999999, 45.353065],
              [-86.899891, 45.295185],
              [-86.956198, 45.352005999999996],
              [-86.934276, 45.421149],
            ],
          ],
          [
            [
              [-90.776921, 47.024324],
              [-90.65042199999999, 47.054677999999996],
              [-90.560936, 47.037012999999995],
              [-90.511623, 46.961407],
              [-90.549104, 46.915461],
              [-90.637124, 46.906724],
              [-90.712032, 46.98526],
              [-90.776921, 47.024324],
            ],
          ],
          [
            [
              [-92.01529, 46.706469],
              [-91.961889, 46.682539],
              [-91.820027, 46.690176],
              [-91.574291, 46.757487999999995],
              [-91.511077, 46.757453],
              [-91.360804, 46.798136],
              [-91.211647, 46.866824],
              [-91.16760099999999, 46.84476],
              [-90.984617, 46.925602],
              [-90.989375, 46.982274],
              [-90.924128, 47.001888],
              [-90.745305, 46.894254],
              [-90.88084099999999, 46.739957],
              [-90.852704, 46.699582],
              [-90.91515199999999, 46.658409999999996],
              [-90.95564999999999, 46.592503],
              [-90.898308, 46.58305],
              [-90.755287, 46.646288999999996],
              [-90.73725999999999, 46.692267],
              [-90.56555999999999, 46.584891999999996],
              [-90.505909, 46.589614],
              [-90.41813599999999, 46.566094],
              [-90.387228, 46.533663],
              [-90.331887, 46.553278],
              [-90.285707, 46.518845999999996],
              [-90.214866, 46.499947],
              [-90.15824099999999, 46.420485],
              [-90.12048899999999, 46.336852],
              [-89.09163, 46.138504999999995],
              [-88.811948, 46.021609],
              [-88.739994, 46.027308],
              [-88.65776, 45.989287],
              [-88.526673, 46.020821999999995],
              [-88.409864, 45.979687999999996],
              [-88.380183, 45.991654],
              [-88.30951999999999, 45.959368999999995],
              [-88.246307, 45.962983],
              [-88.115346, 45.922211],
              [-88.073944, 45.875592999999995],
              [-88.13506699999999, 45.821694],
              [-88.048514, 45.782548999999996],
              [-87.995876, 45.795435],
              [-87.96696999999999, 45.764021],
              [-87.879812, 45.754843],
              [-87.805076, 45.703556],
              [-87.824676, 45.653211],
              [-87.777671, 45.609204],
              [-87.805773, 45.473138999999996],
              [-87.84742899999999, 45.444176999999996],
              [-87.863489, 45.35302],
              [-87.750928, 45.355036999999996],
              [-87.706767, 45.383827],
              [-87.657349, 45.368752],
              [-87.667423, 45.316359999999996],
              [-87.741805, 45.197050999999995],
              [-87.648191, 45.106367999999996],
              [-87.59020799999999, 45.095264],
              [-87.625748, 45.045156999999996],
              [-87.630298, 44.976865],
              [-87.812989, 44.954012999999996],
              [-87.84343299999999, 44.924355],
              [-87.838359, 44.873987],
              [-87.904484, 44.818723],
              [-87.983494, 44.720196],
              [-87.998716, 44.609288],
              [-88.041202, 44.572581],
              [-88.005518, 44.539215999999996],
              [-87.943801, 44.529692999999995],
              [-87.866884, 44.608433999999995],
              [-87.77516, 44.639281],
              [-87.71978, 44.693245999999995],
              [-87.720889, 44.724548],
              [-87.581306, 44.851791],
              [-87.446477, 44.886109],
              [-87.393405, 44.934393],
              [-87.336457, 45.013529999999996],
              [-87.264877, 45.081361],
              [-87.238224, 45.167259],
              [-87.175068, 45.173049999999996],
              [-87.12160899999999, 45.209782999999995],
              [-87.10874299999999, 45.257003],
              [-87.057627, 45.292837999999996],
              [-86.97778, 45.290684],
              [-86.978759, 45.227332999999994],
              [-87.04417, 45.186946],
              [-87.06315699999999, 45.079316],
              [-87.13938399999999, 45.012564999999995],
              [-87.188375, 44.948077],
              [-87.206285, 44.885928],
              [-87.27602999999999, 44.83318],
              [-87.401629, 44.631191],
              [-87.446963, 44.586273999999996],
              [-87.54538199999999, 44.321385],
              [-87.507419, 44.210803],
              [-87.53994, 44.15969],
              [-87.600882, 44.131695],
              [-87.655183, 44.081894],
              [-87.73601699999999, 43.873720999999996],
              [-87.700251, 43.76735],
              [-87.706204, 43.679542],
              [-87.79013499999999, 43.563054],
              [-87.793239, 43.492782999999996],
              [-87.840955, 43.420677],
              [-87.889207, 43.307652],
              [-87.90048499999999, 43.12591],
              [-87.870184, 43.064412],
              [-87.89578399999999, 43.015814],
              [-87.842681, 42.944116],
              [-87.834879, 42.856716999999996],
              [-87.76667499999999, 42.784895999999996],
              [-87.785074, 42.700818999999996],
              [-87.814674, 42.64402],
              [-87.800477, 42.49192],
              [-88.21690000000001, 42.495923],
              [-88.70738, 42.493587],
              [-89.926484, 42.505787],
              [-90.642843, 42.508480999999996],
              [-90.700856, 42.626445],
              [-90.74367699999999, 42.645559999999996],
              [-90.94156699999999, 42.683844],
              [-91.01723899999999, 42.719566],
              [-91.07071599999999, 42.775501999999996],
              [-91.09881999999999, 42.864421],
              [-91.138, 42.903772],
              [-91.174692, 43.038713],
              [-91.175253, 43.134665],
              [-91.05790999999999, 43.253968],
              [-91.107237, 43.313645],
              [-91.20736699999999, 43.373658999999996],
              [-91.232276, 43.450952],
              [-91.21770599999999, 43.50055],
              [-91.273252, 43.666623],
              [-91.243955, 43.773046],
              [-91.29100199999999, 43.852733],
              [-91.440536, 44.001501],
              [-91.57328299999999, 44.026900999999995],
              [-91.64787299999999, 44.064108999999995],
              [-91.71909699999999, 44.128853],
              [-91.817302, 44.164235],
              [-91.892698, 44.231105],
              [-91.916191, 44.318093999999995],
              [-91.9636, 44.362111999999996],
              [-92.111085, 44.413948],
              [-92.232472, 44.445434],
              [-92.291005, 44.485464],
              [-92.314071, 44.538014],
              [-92.54928, 44.577704],
              [-92.61802499999999, 44.61287],
              [-92.696491, 44.689436],
              [-92.80528699999999, 44.768361],
              [-92.768574, 44.854368],
              [-92.750802, 44.941567],
              [-92.761904, 45.022467],
              [-92.802911, 45.065402999999996],
              [-92.74050899999999, 45.113395999999995],
              [-92.766932, 45.195111],
              [-92.76186799999999, 45.284938],
              [-92.698967, 45.336374],
              [-92.646768, 45.437929],
              [-92.756906, 45.557499],
              [-92.881136, 45.573409],
              [-92.887929, 45.639005999999995],
              [-92.869689, 45.715142],
              [-92.776496, 45.790014],
              [-92.721128, 45.883804999999995],
              [-92.65612499999999, 45.924442],
              [-92.545682, 45.970118],
              [-92.47276099999999, 45.972952],
              [-92.44963, 46.002252],
              [-92.35176, 46.015685],
              [-92.294033, 46.074377],
              [-92.292192, 46.663242],
              [-92.20549199999999, 46.664741],
              [-92.143338, 46.731595999999996],
              [-92.10025499999999, 46.734446],
              [-92.01529, 46.706469],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: "04",
        STATENS: "01779777",
        AFFGEOID: "0400000US04",
        GEOID: "04",
        STUSPS: "AZ",
        NAME: "Arizona",
        LSAD: "00",
        ALAND: 294205282243,
        AWATER: 1027790845,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.719633, 32.718762999999996],
            [-114.570675, 32.747417],
            [-114.468971, 32.845155],
            [-114.463127, 32.901883999999995],
            [-114.511343, 33.023455],
            [-114.670803, 33.037984],
            [-114.706175, 33.105335],
            [-114.679359, 33.159518999999996],
            [-114.674491, 33.255597],
            [-114.723259, 33.288078999999996],
            [-114.707348, 33.376628],
            [-114.635183, 33.422726],
            [-114.597283, 33.490653],
            [-114.524599, 33.552231],
            [-114.525201, 33.661583],
            [-114.496565, 33.719155],
            [-114.520465, 33.827777999999995],
            [-114.508708, 33.900639999999996],
            [-114.534987, 33.928498999999995],
            [-114.454807, 34.010968],
            [-114.428026, 34.092787],
            [-114.292806, 34.166725],
            [-114.229715, 34.186928],
            [-114.139055, 34.259538],
            [-114.172845, 34.344978999999995],
            [-114.335372, 34.450038],
            [-114.378852, 34.450376],
            [-114.378223, 34.516521],
            [-114.422382, 34.580711],
            [-114.465246, 34.691202],
            [-114.634382, 34.87289],
            [-114.633487, 35.001857],
            [-114.619905, 35.121632],
            [-114.57274699999999, 35.138725],
            [-114.587129, 35.262375999999996],
            [-114.627137, 35.409504],
            [-114.6645, 35.449497],
            [-114.653406, 35.610789],
            [-114.689407, 35.651412],
            [-114.70371, 35.814585],
            [-114.669687, 35.865083999999996],
            [-114.731159, 35.943916],
            [-114.742779, 36.009963],
            [-114.736165, 36.104366999999996],
            [-114.627855, 36.141011999999996],
            [-114.511721, 36.150956],
            [-114.448654, 36.12641],
            [-114.372106, 36.143114],
            [-114.316109, 36.063109],
            [-114.21369, 36.015613],
            [-114.151725, 36.024563],
            [-114.046838, 36.194069],
            [-114.0506, 37.000395999999995],
            [-112.966471, 37.000219],
            [-111.405869, 37.001481],
            [-110.75068999999999, 37.003197],
            [-110.47019, 36.997997],
            [-109.045223, 36.999083999999996],
            [-109.046796, 35.363606],
            [-109.045851, 34.959717999999995],
            [-109.047117001409, 32.777569000002],
            [-109.050044, 31.332501999999998],
            [-109.829689, 31.334066999999997],
            [-111.074825, 31.332238999999998],
            [-112.365043, 31.74113],
            [-113.750756, 32.169005],
            [-114.813613, 32.494277],
            [-114.795635, 32.550956],
            [-114.809393, 32.617118999999995],
            [-114.76495, 32.649391],
            [-114.719633, 32.718762999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: "05",
        STATENS: "00068085",
        AFFGEOID: "0400000US05",
        GEOID: "05",
        STUSPS: "AR",
        NAME: "Arkansas",
        LSAD: "00",
        ALAND: 134771603434,
        AWATER: 2960200961,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.617919, 36.499414],
            [-92.35027699999999, 36.497786999999995],
            [-91.64259, 36.499334999999995],
            [-91.404915, 36.497119999999995],
            [-90.494575, 36.498368],
            [-90.153871, 36.495343999999996],
            [-90.13103799999999, 36.415068999999995],
            [-90.066136, 36.386272],
            [-90.06398, 36.303038],
            [-90.155928, 36.214074],
            [-90.22042499999999, 36.184764],
            [-90.235585, 36.139474],
            [-90.29449199999999, 36.112949],
            [-90.368718, 35.995812],
            [-89.73309499999999, 36.000608],
            [-89.652279, 35.921462],
            [-89.722634, 35.873718],
            [-89.72342599999999, 35.809382],
            [-89.863874, 35.747592],
            [-89.915491, 35.754917],
            [-89.956589, 35.695485999999995],
            [-89.876548, 35.626653],
            [-89.9325, 35.607865],
            [-89.95849799999999, 35.541703],
            [-90.037615, 35.550329],
            [-90.045805, 35.496533],
            [-90.022064, 35.457375],
            [-90.121864, 35.304535],
            [-90.09794699999999, 35.249983],
            [-90.09061, 35.118286999999995],
            [-90.16005799999999, 35.12883],
            [-90.19714599999999, 35.050731],
            [-90.300697, 35.028793],
            [-90.309297, 34.995694],
            [-90.24447599999999, 34.937596],
            [-90.250095, 34.90732],
            [-90.40163299999999, 34.835305],
            [-90.46379499999999, 34.834922999999996],
            [-90.47352699999999, 34.788835],
            [-90.546053, 34.702076],
            [-90.58722399999999, 34.615732],
            [-90.549244, 34.568101],
            [-90.583717, 34.458829],
            [-90.575336, 34.415152],
            [-90.641398, 34.383869],
            [-90.660404, 34.33576],
            [-90.729131, 34.364205999999996],
            [-90.765174, 34.342818],
            [-90.752681, 34.289266],
            [-90.812829, 34.279438],
            [-90.839981, 34.236114],
            [-90.89456, 34.22438],
            [-90.894385, 34.160953],
            [-90.94632299999999, 34.109373999999995],
            [-90.874541, 34.072041],
            [-90.89242, 34.02686],
            [-90.942662, 34.018049999999995],
            [-91.004981, 33.977011],
            [-91.026382, 33.90798],
            [-91.061247, 33.877505],
            [-91.026782, 33.763642],
            [-91.111494, 33.774567999999995],
            [-91.075389, 33.714403],
            [-91.13090199999999, 33.610918999999996],
            [-91.188942, 33.576225],
            [-91.215671, 33.529423],
            [-91.11376399999999, 33.393124],
            [-91.142219, 33.348988999999996],
            [-91.12553899999999, 33.280255],
            [-91.068708, 33.232935999999995],
            [-91.104317, 33.131598],
            [-91.153015, 33.135093],
            [-91.180836, 33.098364],
            [-91.120379, 33.05453],
            [-91.166073, 33.004106],
            [-92.222825, 33.00908],
            [-92.971137, 33.017192],
            [-94.042964, 33.019219],
            [-94.04342799999999, 33.551425],
            [-94.07267, 33.572234],
            [-94.18339499999999, 33.592211999999996],
            [-94.354165, 33.556452],
            [-94.419057, 33.577217],
            [-94.485875, 33.637867],
            [-94.45750000000001, 34.634945],
            [-94.43151499999999, 35.369591],
            [-94.49454899999999, 35.768302999999996],
            [-94.5862, 36.299969],
            [-94.617919, 36.499414],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: "08",
        STATENS: "01779779",
        AFFGEOID: "0400000US08",
        GEOID: "08",
        STUSPS: "CO",
        NAME: "Colorado",
        LSAD: "00",
        ALAND: 268426928342,
        AWATER: 1176085119,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.050076, 41.000659],
            [-108.250649, 41.000113999999996],
            [-107.367443, 41.003073],
            [-106.217573, 40.997734],
            [-104.855273, 40.998048],
            [-104.497058, 41.001805],
            [-104.053249, 41.001405999999996],
            [-102.051717516378, 41.002376967623896],
            [-102.051744, 40.003077999999995],
            [-102.046571, 39.047038],
            [-102.041876, 37.723875],
            [-102.04224, 36.993083],
            [-102.698142, 36.995149],
            [-103.002199, 37.000104],
            [-103.733247, 36.998016],
            [-104.338833, 36.993535],
            [-105.1208, 36.995428],
            [-105.997472, 36.995416999999996],
            [-106.869796, 36.992426],
            [-106.877292, 37.000139],
            [-109.045223, 36.999083999999996],
            [-109.041762, 38.16469],
            [-109.060062, 38.275489],
            [-109.059962, 38.499987],
            [-109.051512, 39.126095],
            [-109.050973, 40.180848999999995],
            [-109.048249, 40.653600999999995],
            [-109.050076, 41.000659],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 18,
        STATENS: "00448508",
        AFFGEOID: "0400000US18",
        GEOID: 18,
        STUSPS: "IN",
        NAME: "Indiana",
        LSAD: "00",
        ALAND: 92790411854,
        AWATER: 1535839439,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.52404399999999, 41.708335],
            [-87.470742, 41.672835],
            [-87.41581599999999, 41.688182999999995],
            [-87.365439, 41.629536],
            [-87.26153599999999, 41.620335999999995],
            [-87.02788799999999, 41.674661],
            [-86.824828, 41.760239999999996],
            [-85.79136299999999, 41.759051],
            [-84.805883, 41.760216],
            [-84.80608199999999, 41.696089],
            [-84.80211903226379, 40.7281459368726],
            [-84.8041205270149, 40.352762230297095],
            [-84.814129, 39.726555999999995],
            [-84.820157, 39.10548],
            [-84.897171, 39.052406999999995],
            [-84.832617, 38.961459999999995],
            [-84.87776199999999, 38.920356999999996],
            [-84.786406, 38.88222],
            [-84.812877, 38.786086999999995],
            [-84.962535, 38.778034999999996],
            [-85.071928, 38.741566999999996],
            [-85.18727799999999, 38.687608999999995],
            [-85.275454, 38.741172],
            [-85.400481, 38.73598],
            [-85.44886199999999, 38.713367999999996],
            [-85.43616999999999, 38.598292],
            [-85.4156, 38.546341],
            [-85.49886599999999, 38.468242],
            [-85.587758, 38.450495],
            [-85.621625, 38.417089],
            [-85.64620099999999, 38.342915999999995],
            [-85.683561, 38.295469],
            [-85.750962, 38.267869999999995],
            [-85.816164, 38.282969],
            [-85.894764, 38.188469],
            [-85.922395, 38.028679],
            [-86.033386, 37.970382],
            [-86.095766, 38.00893],
            [-86.206439, 38.021876],
            [-86.321274, 38.147418],
            [-86.387216, 38.124632],
            [-86.471903, 38.046217999999996],
            [-86.52182499999999, 38.038326999999995],
            [-86.509368, 37.902887],
            [-86.599848, 37.906754],
            [-86.61521499999999, 37.852857],
            [-86.722247, 37.892648],
            [-86.810913, 37.99715],
            [-86.927747, 37.934956],
            [-87.01031499999999, 37.919668],
            [-87.057836, 37.827456999999995],
            [-87.105614, 37.767631],
            [-87.18006299999999, 37.841375],
            [-87.25524999999999, 37.867326],
            [-87.418585, 37.944763],
            [-87.486347, 37.920218],
            [-87.551277, 37.925418],
            [-87.608479, 37.898793999999995],
            [-87.625851, 37.851918999999995],
            [-87.68163299999999, 37.855917],
            [-87.723635, 37.892058],
            [-87.808013, 37.875191],
            [-87.87254, 37.920998999999995],
            [-87.93812799999999, 37.870650999999995],
            [-87.903804, 37.817761999999995],
            [-87.97026199999999, 37.781856],
            [-88.02803, 37.799223999999995],
            [-88.067364, 37.856051],
            [-88.016311, 37.961574],
            [-88.030884, 38.030713],
            [-87.98877, 38.055591],
            [-87.92746799999999, 38.151945999999995],
            [-87.975819, 38.197834],
            [-87.96896799999999, 38.237389],
            [-87.831972, 38.307241],
            [-87.779996, 38.370841999999996],
            [-87.714047, 38.47988],
            [-87.660732, 38.541092],
            [-87.62012, 38.639489],
            [-87.545538, 38.677613],
            [-87.498948, 38.757774],
            [-87.54737, 38.875614],
            [-87.529496, 38.971925],
            [-87.579117, 39.001607],
            [-87.572588, 39.057286],
            [-87.625379, 39.101805999999996],
            [-87.640435, 39.166727],
            [-87.577029, 39.211123],
            [-87.600397, 39.312903999999996],
            [-87.531646, 39.347888],
            [-87.532308, 40.011587],
            [-87.526292, 40.535409],
            [-87.52676799999999, 41.298176999999995],
            [-87.52404399999999, 41.708335],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: "09",
        STATENS: "01779780",
        AFFGEOID: "0400000US09",
        GEOID: "09",
        STUSPS: "CT",
        NAME: "Connecticut",
        LSAD: "00",
        ALAND: 12542396439,
        AWATER: 1814978794,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.487314, 42.049638],
            [-72.84714199999999, 42.036894],
            [-72.81007799999999, 41.998315999999996],
            [-72.735496, 42.036398999999996],
            [-71.80064999999999, 42.023568999999995],
            [-71.79924199999999, 42.008064999999995],
            [-71.789678, 41.724734],
            [-71.79768299999999, 41.416709],
            [-71.839649, 41.412119],
            [-71.835951, 41.353935],
            [-71.860513, 41.320248],
            [-71.886302, 41.33641],
            [-72.134221, 41.299398],
            [-72.201422, 41.315697],
            [-72.293044, 41.280044],
            [-72.40593, 41.278397999999996],
            [-72.547235, 41.250499],
            [-72.598036, 41.268698],
            [-72.760341, 41.241234999999996],
            [-72.786142, 41.264796],
            [-72.881445, 41.242596999999996],
            [-72.93564599999999, 41.258497],
            [-73.020449, 41.206396999999996],
            [-73.07945, 41.194015],
            [-73.130253, 41.146797],
            [-73.20265599999999, 41.158096],
            [-73.26235799999999, 41.117495999999996],
            [-73.42216499999999, 41.047562],
            [-73.468239, 41.051347],
            [-73.657336, 40.985171],
            [-73.659533, 41.017857],
            [-73.727775, 41.100696],
            [-73.482709, 41.212759999999996],
            [-73.550961, 41.295421999999995],
            [-73.487314, 42.049638],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 31,
        STATENS: "01779792",
        AFFGEOID: "0400000US31",
        GEOID: 31,
        STUSPS: "NE",
        NAME: "Nebraska",
        LSAD: "00",
        ALAND: 198972282955,
        AWATER: 1356441861,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.053127, 43.000585],
            [-103.476133, 43.000768],
            [-101.000429, 42.99753],
            [-98.4985499961057, 42.9985599930527],
            [-98.43450299999999, 42.929227],
            [-98.280007, 42.874995999999996],
            [-98.14806, 42.840013],
            [-98.035034, 42.764205],
            [-97.950147, 42.769619],
            [-97.905001, 42.798871999999996],
            [-97.857957, 42.865092999999995],
            [-97.70102999999999, 42.843796999999995],
            [-97.59926, 42.856229],
            [-97.45217699999999, 42.846047999999996],
            [-97.41706599999999, 42.865918],
            [-97.23786799999999, 42.853139],
            [-97.213957, 42.820142999999995],
            [-97.13133099999999, 42.771929],
            [-97.02485, 42.762429999999995],
            [-96.965679, 42.724531999999996],
            [-96.906797, 42.7338],
            [-96.80165199999999, 42.698774],
            [-96.778182, 42.662993],
            [-96.697639, 42.659143],
            [-96.7093, 42.603753],
            [-96.61148899999999, 42.506088],
            [-96.525142, 42.510234],
            [-96.44550799999999, 42.490629999999996],
            [-96.38130699999999, 42.461694],
            [-96.411808, 42.410894],
            [-96.40799799999999, 42.337407999999996],
            [-96.33600299999999, 42.264806],
            [-96.347752, 42.166806],
            [-96.2689, 42.113589999999995],
            [-96.272877, 42.047238],
            [-96.132537, 41.974624999999996],
            [-96.159098, 41.910056999999995],
            [-96.064537, 41.793002],
            [-96.11148299999999, 41.668548],
            [-96.118105, 41.613495],
            [-96.08049299999999, 41.528199],
            [-96.005079, 41.544004],
            [-95.982962, 41.469778],
            [-95.922529, 41.455766],
            [-95.92568999999999, 41.322196999999996],
            [-95.890152, 41.278307999999996],
            [-95.90969, 41.184398],
            [-95.856788, 41.187098],
            [-95.86868799999999, 41.124697999999995],
            [-95.865878, 41.017403],
            [-95.828329, 40.972378],
            [-95.837774, 40.924712],
            [-95.81070899999999, 40.886680999999996],
            [-95.841309, 40.845604],
            [-95.834156, 40.783015999999996],
            [-95.888697, 40.736292],
            [-95.84603399999999, 40.682604999999995],
            [-95.781909, 40.653272],
            [-95.76564499999999, 40.585208],
            [-95.75711, 40.52599],
            [-95.71429099999999, 40.527208],
            [-95.649418, 40.396149],
            [-95.653729, 40.322582],
            [-95.553292, 40.291157999999996],
            [-95.54715999999999, 40.259066],
            [-95.47254799999999, 40.236078],
            [-95.48102, 40.188524],
            [-95.394216, 40.108263],
            [-95.414734, 40.06982],
            [-95.38295699999999, 40.027111999999995],
            [-95.30829, 39.999998],
            [-97.41583299999999, 40.002001],
            [-98.613755, 40.0024],
            [-99.813401, 40.001400000000004],
            [-102.051744, 40.003077999999995],
            [-102.051717516378, 41.002376967623896],
            [-104.053249, 41.001405999999996],
            [-104.053127, 43.000585],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 35,
        STATENS: "00897535",
        AFFGEOID: "0400000US35",
        GEOID: 35,
        STUSPS: "NM",
        NAME: "New Mexico",
        LSAD: "00",
        ALAND: 314161410324,
        AWATER: 755712514,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.045223, 36.999083999999996],
            [-106.877292, 37.000139],
            [-106.869796, 36.992426],
            [-105.997472, 36.995416999999996],
            [-105.1208, 36.995428],
            [-104.338833, 36.993535],
            [-103.733247, 36.998016],
            [-103.002199, 37.000104],
            [-103.002434, 36.500397],
            [-103.041924, 36.500439],
            [-103.040824, 36.055231],
            [-103.043946, 34.379554999999996],
            [-103.043516, 34.079381999999995],
            [-103.060103, 33.219225],
            [-103.064889, 32.849359],
            [-103.064423, 32.000518],
            [-105.153994, 32.000496999999996],
            [-105.750527, 32.002206],
            [-106.618486, 32.000495],
            [-106.63588, 31.871513999999998],
            [-106.528242, 31.783147999999997],
            [-108.208394, 31.783599],
            [-108.208573, 31.333395],
            [-109.050044, 31.332501999999998],
            [-109.047117001409, 32.777569000002],
            [-109.045851, 34.959717999999995],
            [-109.046796, 35.363606],
            [-109.045223, 36.999083999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 37,
        STATENS: "01027616",
        AFFGEOID: "0400000US37",
        GEOID: 37,
        STUSPS: "NC",
        NAME: "North Carolina",
        LSAD: "00",
        ALAND: 125917995955,
        AWATER: 13472722504,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.67753499999999, 36.588117],
            [-81.499831, 36.57982],
            [-80.9018360537965, 36.5617546210407],
            [-80.704831, 36.562318999999995],
            [-80.295243, 36.543973],
            [-79.51064699999999, 36.540738],
            [-78.509965, 36.541064999999996],
            [-77.749706, 36.545519999999996],
            [-76.917318, 36.546046],
            [-76.738329, 36.550985],
            [-75.86704399999999, 36.550754],
            [-75.79641, 36.290351],
            [-75.71831, 36.113673999999996],
            [-75.658537, 36.02043],
            [-75.49608599999999, 35.728515],
            [-75.458659, 35.596596999999996],
            [-75.48677099999999, 35.391652],
            [-75.533627, 35.225825],
            [-75.635493, 35.220259999999996],
            [-75.757916, 35.183079],
            [-75.91298499999999, 35.1196],
            [-76.137269, 34.987857999999996],
            [-76.31021, 34.852309],
            [-76.450454, 34.71445],
            [-76.535946, 34.588577],
            [-76.553806, 34.628251999999996],
            [-76.618719, 34.67255],
            [-76.726969, 34.69669],
            [-76.906257, 34.68282],
            [-77.136843, 34.632926],
            [-77.240991, 34.587506999999995],
            [-77.322524, 34.535574],
            [-77.46292199999999, 34.471354],
            [-77.63503399999999, 34.359555],
            [-77.764022, 34.245641],
            [-77.82920899999999, 34.162618],
            [-77.915536, 33.971723],
            [-77.960172, 33.853314999999995],
            [-78.018689, 33.888289],
            [-78.136952, 33.912178],
            [-78.276147, 33.912364],
            [-78.38396399999999, 33.901945999999995],
            [-78.54108699999999, 33.851112],
            [-79.071169, 34.29924],
            [-79.358317, 34.545358],
            [-79.675299, 34.804744],
            [-80.5616733913504, 34.8174814452703],
            [-80.79699699999999, 34.823873999999996],
            [-80.78204199999999, 34.935781999999996],
            [-80.93495, 35.107409],
            [-81.041489, 35.044703],
            [-81.05802899999999, 35.07319],
            [-81.04287, 35.149248],
            [-81.494265, 35.169882],
            [-82.411301, 35.202483],
            [-82.53255999999999, 35.155617],
            [-82.68603999999999, 35.124545],
            [-82.746431, 35.079131],
            [-82.783283, 35.0856],
            [-83.10861399600839, 35.000658821346],
            [-83.619985, 34.986592],
            [-84.32186899999999, 34.988408],
            [-84.28322, 35.226577],
            [-84.22371799999999, 35.269078],
            [-84.178516, 35.240679],
            [-84.09750799999999, 35.247382],
            [-84.02351, 35.295783],
            [-84.03808099999999, 35.348363],
            [-84.021782, 35.407418],
            [-83.973171, 35.452582],
            [-83.91680099999999, 35.473611999999996],
            [-83.77173599999999, 35.562118],
            [-83.653159, 35.568309],
            [-83.498335, 35.562981],
            [-83.347262, 35.660474],
            [-83.29715399999999, 35.65775],
            [-83.25535099999999, 35.716229999999996],
            [-83.198267, 35.725494],
            [-83.161537, 35.763363],
            [-83.04853, 35.787706],
            [-82.978414, 35.78261],
            [-82.899718, 35.874601999999996],
            [-82.910608, 35.92693],
            [-82.86072399999999, 35.94743],
            [-82.81613, 35.923986],
            [-82.779397, 35.992511],
            [-82.628365, 36.062104999999995],
            [-82.595525, 36.026012],
            [-82.610885, 35.974441999999996],
            [-82.557874, 35.953901],
            [-82.464558, 36.006508],
            [-82.409458, 36.083408999999996],
            [-82.29765499999999, 36.13351],
            [-82.21125099999999, 36.159012],
            [-82.140847, 36.136216],
            [-82.127146, 36.104417],
            [-82.02874, 36.124322],
            [-81.908137, 36.302012999999995],
            [-81.833202, 36.347339],
            [-81.70596599999999, 36.338496],
            [-81.734312, 36.413342],
            [-81.69531099999999, 36.467912],
            [-81.699962, 36.536829],
            [-81.67753499999999, 36.588117],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 39,
        STATENS: "01085497",
        AFFGEOID: "0400000US39",
        GEOID: 39,
        STUSPS: "OH",
        NAME: "Ohio",
        LSAD: "00",
        ALAND: 105831263791,
        AWATER: 10266413579,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-82.863342, 41.693692999999996],
              [-82.82571999999999, 41.722809999999996],
              [-82.782719, 41.694002999999995],
              [-82.788876, 41.643046999999996],
              [-82.84209899999999, 41.628322999999995],
              [-82.863342, 41.693692999999996],
            ],
          ],
          [
            [
              [-84.80608199999999, 41.696089],
              [-84.134417, 41.712931],
              [-83.45383199999999, 41.732647],
              [-83.409531, 41.691247],
              [-83.326825, 41.701561999999996],
              [-83.23165999999999, 41.644217999999995],
              [-83.066593, 41.59534],
              [-83.028072, 41.555656],
              [-82.93436899999999, 41.514353],
              [-82.83410099999999, 41.587587],
              [-82.717878, 41.54193],
              [-82.687921, 41.492323999999996],
              [-82.616952, 41.428425],
              [-82.533208, 41.391157],
              [-82.460599, 41.386316],
              [-82.361784, 41.426643999999996],
              [-82.268479, 41.430842],
              [-82.181598, 41.471634],
              [-81.994565, 41.51444],
              [-81.937862, 41.491443],
              [-81.738755, 41.48855],
              [-81.633652, 41.540458],
              [-81.388632, 41.707144],
              [-81.286925, 41.760242999999996],
              [-81.18436799999999, 41.786671],
              [-81.05192, 41.839557],
              [-80.900342, 41.868911999999995],
              [-80.800794, 41.909635],
              [-80.519425, 41.977523],
              [-80.518991, 40.638801],
              [-80.62717099999999, 40.619935999999996],
              [-80.667957, 40.582496],
              [-80.62219499999999, 40.520497],
              [-80.604895, 40.446667],
              [-80.631596, 40.385467999999996],
              [-80.606596, 40.303869],
              [-80.70599399999999, 40.151590999999996],
              [-80.73680399999999, 40.080072],
              [-80.74012599999999, 39.970793],
              [-80.803394, 39.918762],
              [-80.824969, 39.801092],
              [-80.869933, 39.763555],
              [-80.829764, 39.711839],
              [-80.86557499999999, 39.662751],
              [-81.07594999999999, 39.50966],
              [-81.12853299999999, 39.449374999999996],
              [-81.347567, 39.34577],
              [-81.393794, 39.351706],
              [-81.456143, 39.409273999999996],
              [-81.559647, 39.330774],
              [-81.565247, 39.276174999999995],
              [-81.678331, 39.273755],
              [-81.752754, 39.184675999999996],
              [-81.742953, 39.106578],
              [-81.80785499999999, 39.083977999999995],
              [-81.775734, 38.980737],
              [-81.827354, 38.945898],
              [-81.89847, 38.929603],
              [-81.941829, 38.993294999999996],
              [-82.00706199999999, 39.029578],
              [-82.08906499999999, 38.975978],
              [-82.134766, 38.905578999999996],
              [-82.16157, 38.824632],
              [-82.20929, 38.802672],
              [-82.175167, 38.608484],
              [-82.27427, 38.593683],
              [-82.323999, 38.449268],
              [-82.560664, 38.404337999999996],
              [-82.593673, 38.421808999999996],
              [-82.61847399999999, 38.477089],
              [-82.724846, 38.5576],
              [-82.800112, 38.563182999999995],
              [-82.851314, 38.604334],
              [-82.88919299999999, 38.756076],
              [-83.011816, 38.730056999999995],
              [-83.112372, 38.671685],
              [-83.172647, 38.620252],
              [-83.239515, 38.628588],
              [-83.286514, 38.599241],
              [-83.376302, 38.661473],
              [-83.533339, 38.702104999999996],
              [-83.626922, 38.679387],
              [-83.679484, 38.630036],
              [-83.77216, 38.65815],
              [-83.78362, 38.695640999999995],
              [-83.852085, 38.751433],
              [-83.978814, 38.787104],
              [-84.051642, 38.771397],
              [-84.212904, 38.805707],
              [-84.232132, 38.880483],
              [-84.326539, 39.027463],
              [-84.40093999999999, 39.046361999999995],
              [-84.462042, 39.121759999999995],
              [-84.607928, 39.073237999999996],
              [-84.677247, 39.098259999999996],
              [-84.750749, 39.147358],
              [-84.820157, 39.10548],
              [-84.814129, 39.726555999999995],
              [-84.8041205270149, 40.352762230297095],
              [-84.80211903226379, 40.7281459368726],
              [-84.80608199999999, 41.696089],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 23,
        STATENS: "01779787",
        AFFGEOID: "0400000US23",
        GEOID: 23,
        STUSPS: "ME",
        NAME: "Maine",
        LSAD: "00",
        ALAND: 79885244456,
        AWATER: 11749091526,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-68.92401, 43.885407],
              [-68.87478399999999, 43.904714999999996],
              [-68.849009, 43.849841],
              [-68.888483, 43.803781],
              [-68.944433, 43.835325999999995],
              [-68.92401, 43.885407],
            ],
          ],
          [
            [
              [-71.083924, 45.305451],
              [-71.012757, 45.34476],
              [-70.949365, 45.331536],
              [-70.892822, 45.239171999999996],
              [-70.84443, 45.234513],
              [-70.808613, 45.311606],
              [-70.80624399999999, 45.376557999999996],
              [-70.781471, 45.431159],
              [-70.729972, 45.399359],
              [-70.634661, 45.383607999999995],
              [-70.635498, 45.427817],
              [-70.723396, 45.510394],
              [-70.688214, 45.563981],
              [-70.55282390337851, 45.6678060578851],
              [-70.383552, 45.734868999999996],
              [-70.415684, 45.786158],
              [-70.329748, 45.853795],
              [-70.259117, 45.890755],
              [-70.26541, 45.962692],
              [-70.31296999999999, 45.961856],
              [-70.30673399999999, 46.061344],
              [-70.239566, 46.142762],
              [-70.290896, 46.185838],
              [-70.207415, 46.331316],
              [-70.053748, 46.429235999999996],
              [-69.997086, 46.695229999999995],
              [-69.43919799999999, 47.250032999999995],
              [-69.219996, 47.457159],
              [-69.039301, 47.42217],
              [-69.053885, 47.377877999999995],
              [-69.0402, 47.2451],
              [-68.90098499999999, 47.178518999999994],
              [-68.80353699999999, 47.216032999999996],
              [-68.60481899999999, 47.249418],
              [-68.588725, 47.281721],
              [-68.507432, 47.296636],
              [-68.375615, 47.292268],
              [-68.361559, 47.355605],
              [-68.204263, 47.339729999999996],
              [-67.952269, 47.196141999999995],
              [-67.889155, 47.118772],
              [-67.789761, 47.065743999999995],
              [-67.788406, 46.601794999999996],
              [-67.78211399999999, 46.279381],
              [-67.779984, 45.938162999999996],
              [-67.80367799999999, 45.869378999999995],
              [-67.763955, 45.829983],
              [-67.803626, 45.781624],
              [-67.781892, 45.731189],
              [-67.803313, 45.677886],
              [-67.710464, 45.679372],
              [-67.675417, 45.630959],
              [-67.534919, 45.595428],
              [-67.455406, 45.604665],
              [-67.42364599999999, 45.572153],
              [-67.417417, 45.501985],
              [-67.476855, 45.49724],
              [-67.48432799999999, 45.451955],
              [-67.42724299999999, 45.373689999999996],
              [-67.480256, 45.268184999999995],
              [-67.390579, 45.154114],
              [-67.339869, 45.125594],
              [-67.271076, 45.191081],
              [-67.161247, 45.162879],
              [-67.112414, 45.112322999999996],
              [-67.033474, 44.939923],
              [-66.983558, 44.903276999999996],
              [-66.99296, 44.849181],
              [-66.949895, 44.817419],
              [-67.073439, 44.741957],
              [-67.169857, 44.662105],
              [-67.293403, 44.599264999999995],
              [-67.368269, 44.624672],
              [-67.44851299999999, 44.600322],
              [-67.521168, 44.50991],
              [-67.503208, 44.476918],
              [-67.579726, 44.429131],
              [-67.653123, 44.525822999999995],
              [-67.70667999999999, 44.501974999999995],
              [-67.793589, 44.494779],
              [-67.855108, 44.419433999999995],
              [-67.899571, 44.394078],
              [-67.936531, 44.411187],
              [-68.01398999999999, 44.390254999999996],
              [-68.049334, 44.330729999999996],
              [-68.125624, 44.387127],
              [-68.189155, 44.373833],
              [-68.173608, 44.328396999999995],
              [-68.22949, 44.266918],
              [-68.306519, 44.234829],
              [-68.331032, 44.10758],
              [-68.438518, 44.11618],
              [-68.584101, 44.071588999999996],
              [-68.617085, 44.010096999999995],
              [-68.657031, 44.003823],
              [-68.669383, 44.076359],
              [-68.77965, 44.057753999999996],
              [-68.874139, 44.025358999999995],
              [-68.935327, 44.130379999999995],
              [-68.88859699999999, 44.159549999999996],
              [-68.95188999999999, 44.218719],
              [-69.040193, 44.233672999999996],
              [-69.075667, 44.129991],
              [-69.03187799999999, 44.079035999999995],
              [-69.068112, 44.039767999999995],
              [-69.077028, 43.973653999999996],
              [-69.17497999999999, 43.976949],
              [-69.32103099999999, 43.856708],
              [-69.393288, 43.95642],
              [-69.50328999999999, 43.837672999999995],
              [-69.717074, 43.792403],
              [-69.754091, 43.743866],
              [-69.855081, 43.704746],
              [-69.862155, 43.758962],
              [-69.915593, 43.775112],
              [-69.983685, 43.744395],
              [-70.001273, 43.710387999999995],
              [-70.071304, 43.713772],
              [-70.09603899999999, 43.672276],
              [-70.168227, 43.675135999999995],
              [-70.245499, 43.539635],
              [-70.361214, 43.52919],
              [-70.385615, 43.487030999999995],
              [-70.327303, 43.458521],
              [-70.38398099999999, 43.41294],
              [-70.416311, 43.361059],
              [-70.517695, 43.344037],
              [-70.585184, 43.270112999999995],
              [-70.57578699999999, 43.221858999999995],
              [-70.59618499999999, 43.163466],
              [-70.665958, 43.076234],
              [-70.703818, 43.059825],
              [-70.8281, 43.129086],
              [-70.813119, 43.217251999999995],
              [-70.984335, 43.376128],
              [-70.95475499999999, 43.509802],
              [-70.97271599999999, 43.570254999999996],
              [-70.989929, 43.839239],
              [-71.008736, 44.258824999999995],
              [-71.036705, 44.736498],
              [-71.083924, 45.305451],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 25,
        STATENS: "00606926",
        AFFGEOID: "0400000US25",
        GEOID: 25,
        STUSPS: "MA",
        NAME: "Massachusetts",
        LSAD: "00",
        ALAND: 20203936287,
        AWATER: 7131805598,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-70.275526, 41.310463999999996],
              [-70.079133, 41.319503999999995],
              [-70.049053, 41.391701999999995],
              [-69.984869, 41.358818],
              [-69.96018099999999, 41.264545999999996],
              [-70.015225, 41.237964],
              [-70.211479, 41.248765],
              [-70.275526, 41.310463999999996],
            ],
          ],
          [
            [
              [-70.83380199999999, 41.353386],
              [-70.757797, 41.365702],
              [-70.686881, 41.441334],
              [-70.603555, 41.482383999999996],
              [-70.463833, 41.419145],
              [-70.448262, 41.353651],
              [-70.693635, 41.342833],
              [-70.768687, 41.303702],
              [-70.82128399999999, 41.251014],
              [-70.83380199999999, 41.353386],
            ],
          ],
          [
            [
              [-73.264957, 42.74594],
              [-72.458519, 42.726853],
              [-71.745817, 42.707287],
              [-71.29420499999999, 42.69699],
              [-71.255605, 42.736388999999996],
              [-71.181803, 42.73759],
              [-71.186104, 42.790689],
              [-71.149703, 42.815489],
              [-71.064201, 42.806289],
              [-71.031201, 42.859089],
              [-70.930799, 42.884589],
              [-70.817296, 42.87229],
              [-70.80521999999999, 42.781797999999995],
              [-70.772267, 42.711064],
              [-70.72982, 42.669602],
              [-70.645101, 42.689423],
              [-70.594014, 42.63503],
              [-70.654727, 42.582234],
              [-70.848492, 42.550194999999995],
              [-70.83599099999999, 42.490496],
              [-70.886493, 42.470197],
              [-70.913192, 42.427696999999995],
              [-70.98299399999999, 42.423995999999995],
              [-70.974897, 42.355843],
              [-70.997838, 42.321205],
              [-70.967351, 42.268167999999996],
              [-70.91749, 42.305686],
              [-70.788724, 42.25392],
              [-70.73056, 42.21094],
              [-70.63848, 42.081579],
              [-70.678798, 42.00551],
              [-70.662476, 41.960592],
              [-70.583572, 41.950007],
              [-70.525567, 41.85873],
              [-70.54102999999999, 41.815754],
              [-70.441718, 41.752897999999995],
              [-70.272289, 41.721346],
              [-70.024734, 41.787364],
              [-70.00611099999999, 41.852396],
              [-70.06900999999999, 41.884924],
              [-70.083775, 42.012040999999996],
              [-70.190834, 42.020027999999996],
              [-70.245385, 42.063733],
              [-70.138942, 42.092907],
              [-70.049382, 42.064689],
              [-69.994136, 41.999258],
              [-69.935952, 41.809422],
              [-69.931129, 41.622659],
              [-69.96498199999999, 41.55111],
              [-70.011229, 41.543931],
              [-70.00701099999999, 41.671579],
              [-70.158621, 41.650438],
              [-70.26968699999999, 41.617774999999995],
              [-70.32158799999999, 41.630508],
              [-70.445289, 41.591815],
              [-70.47625599999999, 41.558502],
              [-70.55968899999999, 41.54833],
              [-70.734306, 41.486335],
              [-70.79026999999999, 41.446338999999995],
              [-70.948431, 41.409192999999995],
              [-70.934986, 41.454699],
              [-70.806861, 41.497583],
              [-70.698197, 41.559002],
              [-70.695392, 41.602546],
              [-70.765463, 41.641574999999996],
              [-70.82191, 41.582840999999995],
              [-70.91016499999999, 41.577073],
              [-70.981708, 41.51007],
              [-71.12057, 41.497448],
              [-71.137492, 41.602561],
              [-71.132888, 41.660101999999995],
              [-71.19564, 41.67509],
              [-71.261392, 41.752300999999996],
              [-71.329396, 41.7826],
              [-71.339298, 41.893398999999995],
              [-71.38170000000001, 41.893198999999996],
              [-71.381401, 42.018798],
              [-71.79924199999999, 42.008064999999995],
              [-71.80064999999999, 42.023568999999995],
              [-72.735496, 42.036398999999996],
              [-72.81007799999999, 41.998315999999996],
              [-72.84714199999999, 42.036894],
              [-73.487314, 42.049638],
              [-73.50814199999999, 42.086256999999996],
              [-73.264957, 42.74594],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 28,
        STATENS: "01779790",
        AFFGEOID: "0400000US28",
        GEOID: 28,
        STUSPS: "MS",
        NAME: "Mississippi",
        LSAD: "00",
        ALAND: 121531899917,
        AWATER: 3928587545,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.166073, 33.004106],
            [-91.120379, 33.05453],
            [-91.180836, 33.098364],
            [-91.153015, 33.135093],
            [-91.104317, 33.131598],
            [-91.068708, 33.232935999999995],
            [-91.12553899999999, 33.280255],
            [-91.142219, 33.348988999999996],
            [-91.11376399999999, 33.393124],
            [-91.215671, 33.529423],
            [-91.188942, 33.576225],
            [-91.13090199999999, 33.610918999999996],
            [-91.075389, 33.714403],
            [-91.111494, 33.774567999999995],
            [-91.026782, 33.763642],
            [-91.061247, 33.877505],
            [-91.026382, 33.90798],
            [-91.004981, 33.977011],
            [-90.942662, 34.018049999999995],
            [-90.89242, 34.02686],
            [-90.874541, 34.072041],
            [-90.94632299999999, 34.109373999999995],
            [-90.894385, 34.160953],
            [-90.89456, 34.22438],
            [-90.839981, 34.236114],
            [-90.812829, 34.279438],
            [-90.752681, 34.289266],
            [-90.765174, 34.342818],
            [-90.729131, 34.364205999999996],
            [-90.660404, 34.33576],
            [-90.641398, 34.383869],
            [-90.575336, 34.415152],
            [-90.583717, 34.458829],
            [-90.549244, 34.568101],
            [-90.58722399999999, 34.615732],
            [-90.546053, 34.702076],
            [-90.47352699999999, 34.788835],
            [-90.46379499999999, 34.834922999999996],
            [-90.40163299999999, 34.835305],
            [-90.250095, 34.90732],
            [-90.24447599999999, 34.937596],
            [-90.309297, 34.995694],
            [-89.43495399999999, 34.993753999999996],
            [-88.200064, 34.995633999999995],
            [-88.154617, 34.922391999999995],
            [-88.097888, 34.892202],
            [-88.25444499999999, 33.698779],
            [-88.42827799999999, 32.250143],
            [-88.46866, 31.933173],
            [-88.46866899999999, 31.790722],
            [-88.432007, 31.114297999999998],
            [-88.395023, 30.369425],
            [-88.471875, 30.32002],
            [-88.522494, 30.340092],
            [-88.581929, 30.331063],
            [-88.66382, 30.362098999999997],
            [-88.700587, 30.343688999999998],
            [-88.81876199999999, 30.36059],
            [-88.89393, 30.393397999999998],
            [-88.971233, 30.390798],
            [-89.083237, 30.368097],
            [-89.18683999999999, 30.331197],
            [-89.344746, 30.293196],
            [-89.424624, 30.245390999999998],
            [-89.447465, 30.205098],
            [-89.524504, 30.180753],
            [-89.607655, 30.217095999999998],
            [-89.634208, 30.308256],
            [-89.712493, 30.47751],
            [-89.791664, 30.551523999999997],
            [-89.836331, 30.727197],
            [-89.750073, 30.91293],
            [-89.7281756901606, 31.002313887984098],
            [-90.346007, 31.000363],
            [-91.63694199999999, 30.999416],
            [-91.56036499999999, 31.049508],
            [-91.62167099999999, 31.13687],
            [-91.590051, 31.193693],
            [-91.644356, 31.234413999999997],
            [-91.621358, 31.267811],
            [-91.56419199999999, 31.261633],
            [-91.50885799999999, 31.291643999999998],
            [-91.53606099999999, 31.338355],
            [-91.510356, 31.438927999999997],
            [-91.51714, 31.498393999999998],
            [-91.43761599999999, 31.546166],
            [-91.46381699999999, 31.620365],
            [-91.395715, 31.644164999999997],
            [-91.380915, 31.732464],
            [-91.318576, 31.745314999999998],
            [-91.35951399999999, 31.799362],
            [-91.345714, 31.842861],
            [-91.29013499999999, 31.833658],
            [-91.18110999999999, 31.920059],
            [-91.17741, 31.973257],
            [-91.117409, 31.987057],
            [-91.034707, 32.101053],
            [-91.108509, 32.208149999999996],
            [-90.991227, 32.214662],
            [-90.92116999999999, 32.342073],
            [-90.986672, 32.35176],
            [-90.965986, 32.424806],
            [-91.05290699999999, 32.438442],
            [-91.06051599999999, 32.512361],
            [-91.011275, 32.516596],
            [-91.079506, 32.60068],
            [-91.113652, 32.73997],
            [-91.157614, 32.776033],
            [-91.13789, 32.848974999999996],
            [-91.070602, 32.888659],
            [-91.072075, 32.937832],
            [-91.166073, 33.004106],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 30,
        STATENS: "00767982",
        AFFGEOID: "0400000US30",
        GEOID: 30,
        STUSPS: "MT",
        NAME: "Montana",
        LSAD: "00",
        ALAND: 376963849026,
        AWATER: 3867840830,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-116.049193, 49.000912],
            [-115.207912, 48.999227999999995],
            [-114.375977, 49.00139],
            [-113.692982, 48.997631999999996],
            [-112.14376899999999, 48.998917],
            [-111.500812, 48.996963],
            [-109.500737, 49.00044],
            [-109.000708, 48.999234],
            [-107.363582, 49.000018999999995],
            [-104.875527, 48.998991],
            [-104.048736, 48.999877],
            [-104.047555, 48.494139999999994],
            [-104.042384, 47.803256],
            [-104.045313, 47.331955],
            [-104.045443, 45.94531],
            [-104.042597, 45.749998],
            [-104.039138, 44.99852],
            [-104.057698, 44.997431],
            [-105.025266, 45.00029],
            [-105.848065, 45.000395999999995],
            [-106.263586, 44.993787999999995],
            [-106.888773, 44.995885],
            [-107.351441, 45.001407],
            [-107.997353, 45.001565],
            [-109.062262, 44.999623],
            [-109.103445, 45.005904],
            [-109.574321, 45.002631],
            [-109.99504999999999, 45.003174],
            [-110.705272, 44.992323999999996],
            [-110.785008, 45.002952],
            [-111.044275, 45.001345],
            [-111.056888, 44.866658],
            [-111.048974, 44.474072],
            [-111.122654, 44.493659],
            [-111.143557, 44.535731999999996],
            [-111.201459, 44.575696],
            [-111.224161, 44.623402],
            [-111.323669, 44.724474],
            [-111.385005, 44.755128],
            [-111.438793, 44.720546],
            [-111.519126, 44.582916],
            [-111.562814, 44.555209],
            [-111.704218, 44.560204999999996],
            [-111.807914, 44.511716],
            [-111.870504, 44.564032999999995],
            [-112.125101, 44.528527],
            [-112.221698, 44.543518999999996],
            [-112.286187, 44.568472],
            [-112.358917, 44.528847],
            [-112.387389, 44.448057999999996],
            [-112.473207, 44.480027],
            [-112.707815, 44.503023],
            [-112.828191, 44.442471999999995],
            [-112.821896, 44.407436],
            [-112.881769, 44.380314999999996],
            [-112.951146, 44.416699],
            [-113.006846, 44.471714999999996],
            [-113.006828, 44.518439],
            [-113.061071, 44.577329],
            [-113.049349, 44.62938],
            [-113.131387, 44.764738],
            [-113.24716599999999, 44.82295],
            [-113.301508, 44.798984999999995],
            [-113.422376, 44.842594999999996],
            [-113.47457299999999, 44.910846],
            [-113.437726, 45.006966999999996],
            [-113.45197, 45.059247],
            [-113.57467, 45.128411],
            [-113.650064, 45.23471],
            [-113.735601, 45.325264999999995],
            [-113.73239, 45.385058],
            [-113.763368, 45.427732],
            [-113.759986, 45.480734999999996],
            [-113.802849, 45.523159],
            [-113.806729, 45.602146],
            [-113.898883, 45.644166999999996],
            [-113.971565, 45.700635999999996],
            [-114.08314899999999, 45.603995999999995],
            [-114.18647, 45.545539],
            [-114.251836, 45.537811999999995],
            [-114.279217, 45.480616],
            [-114.36852, 45.492716],
            [-114.50634099999999, 45.559216],
            [-114.538132, 45.606834],
            [-114.499637, 45.669035],
            [-114.504869, 45.722176],
            [-114.562509, 45.779927],
            [-114.517143, 45.835992999999995],
            [-114.422963, 45.855381],
            [-114.402261, 45.961489],
            [-114.480241, 46.030325],
            [-114.460049, 46.097103999999995],
            [-114.52130000000001, 46.125287],
            [-114.514706, 46.167725999999995],
            [-114.445928, 46.173933],
            [-114.449819, 46.237119],
            [-114.422458, 46.387097],
            [-114.384756, 46.411784],
            [-114.403019, 46.498675],
            [-114.351655, 46.508119],
            [-114.320665, 46.646963],
            [-114.360709, 46.669059],
            [-114.453239, 46.649266],
            [-114.547321, 46.644484999999996],
            [-114.621483, 46.658142999999995],
            [-114.626695, 46.712889],
            [-114.69900799999999, 46.740223],
            [-114.76718, 46.738828],
            [-114.79004, 46.778729],
            [-114.880588, 46.811791],
            [-114.943281, 46.867971],
            [-114.927432, 46.914184999999996],
            [-115.031651, 46.971548],
            [-115.071254, 47.022082999999995],
            [-115.189451, 47.131032],
            [-115.255786, 47.174724999999995],
            [-115.326903, 47.255911999999995],
            [-115.470959, 47.284873],
            [-115.531971, 47.314121],
            [-115.578619, 47.367007],
            [-115.71034, 47.417784],
            [-115.69293, 47.457237],
            [-115.634684, 47.48176],
            [-115.717024, 47.532692999999995],
            [-115.694284, 47.623459999999994],
            [-115.73627, 47.654762],
            [-115.72377, 47.696670999999995],
            [-115.835365, 47.760957],
            [-115.845474, 47.814966999999996],
            [-115.900934, 47.843064],
            [-116.049153, 47.999922999999995],
            [-116.049193, 49.000912],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 40,
        STATENS: "01102857",
        AFFGEOID: "0400000US40",
        GEOID: 40,
        STUSPS: "OK",
        NAME: "Oklahoma",
        LSAD: "00",
        ALAND: 177662951360,
        AWATER: 3374301679,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.002199, 37.000104],
            [-102.698142, 36.995149],
            [-102.04224, 36.993083],
            [-100.552683, 37.000735],
            [-99.995201, 37.001630999999996],
            [-98.354073, 36.997961],
            [-97.768704, 36.99875],
            [-94.99529299999999, 36.999528999999995],
            [-94.617964, 36.998905],
            [-94.617919, 36.499414],
            [-94.5862, 36.299969],
            [-94.49454899999999, 35.768302999999996],
            [-94.43151499999999, 35.369591],
            [-94.45750000000001, 34.634945],
            [-94.485875, 33.637867],
            [-94.528928, 33.62184],
            [-94.57287199999999, 33.669886],
            [-94.630586, 33.673401],
            [-94.71486499999999, 33.707260999999995],
            [-94.76614599999999, 33.748031],
            [-94.841634, 33.739430999999996],
            [-94.902276, 33.776289],
            [-94.98165, 33.852284],
            [-95.046568, 33.862565],
            [-95.149462, 33.936336],
            [-95.226393, 33.961954],
            [-95.283445, 33.877746],
            [-95.44736999999999, 33.86885],
            [-95.525322, 33.885487],
            [-95.55691499999999, 33.92702],
            [-95.603657, 33.927195],
            [-95.73750799999999, 33.895967],
            [-95.820596, 33.858464999999995],
            [-95.93532499999999, 33.875099],
            [-96.063924, 33.841522999999995],
            [-96.15163, 33.831945999999995],
            [-96.229023, 33.748021],
            [-96.27726899999999, 33.769735],
            [-96.363135, 33.694215],
            [-96.436455, 33.780049999999996],
            [-96.502286, 33.77346],
            [-96.52386299999999, 33.818114],
            [-96.59292599999999, 33.830916],
            [-96.59011199999999, 33.880665],
            [-96.65989599999999, 33.916666],
            [-96.71242199999999, 33.831633],
            [-96.85059299999999, 33.847211],
            [-96.95231299999999, 33.944582],
            [-96.98556699999999, 33.886522],
            [-97.055838, 33.855741],
            [-97.091072, 33.735115],
            [-97.149394, 33.721967],
            [-97.205652, 33.809824],
            [-97.166629, 33.847311],
            [-97.206141, 33.91428],
            [-97.318243, 33.865120999999995],
            [-97.372941, 33.819454],
            [-97.444193, 33.823772999999996],
            [-97.486505, 33.916993999999995],
            [-97.55827, 33.897099],
            [-97.60909099999999, 33.968092999999996],
            [-97.67177199999999, 33.991369999999996],
            [-97.803473, 33.88019],
            [-97.865765, 33.849393],
            [-97.95121499999999, 33.878423999999995],
            [-97.947572, 33.991053],
            [-98.08283899999999, 34.002412],
            [-98.099328, 34.104295],
            [-98.12337699999999, 34.15454],
            [-98.16911999999999, 34.114171],
            [-98.36402299999999, 34.157109],
            [-98.41442599999999, 34.085074],
            [-98.475066, 34.064268999999996],
            [-98.577136, 34.148962],
            [-98.648073, 34.164441],
            [-98.690072, 34.133154999999995],
            [-98.87222899999999, 34.160446],
            [-98.94022, 34.203686],
            [-99.0588, 34.201256],
            [-99.189511, 34.214312],
            [-99.2116, 34.31397],
            [-99.27534, 34.386599],
            [-99.35040699999999, 34.437083],
            [-99.394956, 34.442099],
            [-99.42043199999999, 34.380463999999996],
            [-99.58448, 34.407672999999996],
            [-99.600026, 34.374688],
            [-99.696462, 34.381036],
            [-99.929334, 34.576713999999996],
            [-100.000381, 34.560508999999996],
            [-100.000406, 36.499702],
            [-101.085156, 36.499244],
            [-103.002434, 36.500397],
            [-103.002199, 37.000104],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 45,
        STATENS: "01779799",
        AFFGEOID: "0400000US45",
        GEOID: 45,
        STUSPS: "SC",
        NAME: "South Carolina",
        LSAD: "00",
        ALAND: 77857913931,
        AWATER: 5074749305,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.10861399600839, 35.000658821346],
            [-82.783283, 35.0856],
            [-82.746431, 35.079131],
            [-82.68603999999999, 35.124545],
            [-82.53255999999999, 35.155617],
            [-82.411301, 35.202483],
            [-81.494265, 35.169882],
            [-81.04287, 35.149248],
            [-81.05802899999999, 35.07319],
            [-81.041489, 35.044703],
            [-80.93495, 35.107409],
            [-80.78204199999999, 34.935781999999996],
            [-80.79699699999999, 34.823873999999996],
            [-80.5616733913504, 34.8174814452703],
            [-79.675299, 34.804744],
            [-79.358317, 34.545358],
            [-79.071169, 34.29924],
            [-78.54108699999999, 33.851112],
            [-78.67226, 33.817586999999996],
            [-78.77273699999999, 33.768511],
            [-78.938076, 33.639826],
            [-79.028516, 33.533364999999996],
            [-79.084588, 33.483669],
            [-79.135441, 33.403867],
            [-79.18056299999999, 33.237955],
            [-79.172394, 33.206576999999996],
            [-79.215453, 33.155569],
            [-79.329909, 33.089985999999996],
            [-79.359961, 33.006672],
            [-79.483499, 33.001265],
            [-79.522449, 33.03535],
            [-79.60661499999999, 32.972248],
            [-79.569762, 32.926691999999996],
            [-79.69514099999999, 32.850398],
            [-79.726389, 32.805996],
            [-79.868352, 32.734849],
            [-79.88496099999999, 32.684402],
            [-80.000801, 32.605892],
            [-80.077039, 32.603319],
            [-80.148406, 32.578479],
            [-80.338354, 32.47873],
            [-80.46571, 32.4953],
            [-80.484617, 32.460975999999995],
            [-80.434303, 32.375192999999996],
            [-80.455192, 32.326457999999995],
            [-80.59639399999999, 32.273548999999996],
            [-80.714601, 32.325655999999995],
            [-80.766038, 32.292608],
            [-80.66916599999999, 32.216783],
            [-80.721463, 32.160427],
            [-80.858735, 32.099581],
            [-80.885517, 32.034600000000005],
            [-81.006745, 32.101152],
            [-81.038265, 32.084469],
            [-81.113334, 32.113205],
            [-81.119361, 32.177141999999996],
            [-81.153531, 32.237687],
            [-81.128034, 32.276297],
            [-81.133032, 32.334793999999995],
            [-81.194931, 32.411488999999996],
            [-81.194829, 32.465086],
            [-81.27492699999999, 32.544157999999996],
            [-81.397106, 32.605587],
            [-81.393818, 32.653490999999995],
            [-81.42062, 32.831223],
            [-81.499566, 32.943722],
            [-81.50202999999999, 33.015113],
            [-81.601655, 33.084688],
            [-81.755135, 33.15155],
            [-81.76353499999999, 33.203648],
            [-81.846536, 33.241746],
            [-81.846136, 33.303843],
            [-81.932737, 33.343541],
            [-81.92633599999999, 33.462937],
            [-81.990938, 33.494234999999996],
            [-82.028238, 33.544934],
            [-82.10624, 33.595636999999996],
            [-82.161908, 33.610642999999996],
            [-82.239098, 33.730872],
            [-82.32448, 33.820032999999995],
            [-82.43115, 33.867051],
            [-82.51294999999999, 33.936969],
            [-82.55683499999999, 33.945353],
            [-82.642797, 34.081312],
            [-82.715373, 34.148165],
            [-82.744982, 34.244861],
            [-82.82342, 34.358872],
            [-82.873831, 34.471508],
            [-82.99508999999999, 34.472483],
            [-83.048289, 34.493254],
            [-83.154577, 34.588198],
            [-83.221402, 34.609947],
            [-83.33869, 34.682002],
            [-83.35323799999999, 34.728648],
            [-83.323866, 34.789712],
            [-83.25258199999999, 34.853483],
            [-83.140621, 34.924915],
            [-83.10861399600839, 35.000658821346],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 46,
        STATENS: "01785534",
        AFFGEOID: "0400000US46",
        GEOID: 46,
        STUSPS: "SD",
        NAME: "South Dakota",
        LSAD: "00",
        ALAND: 196348876870,
        AWATER: 3379900654,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.057698, 44.997431],
            [-104.039138, 44.99852],
            [-104.042597, 45.749998],
            [-104.045443, 45.94531],
            [-102.550947, 45.945015],
            [-100.51194902615102, 45.9436540704345],
            [-99.092868, 45.940183999999995],
            [-98.414518, 45.936504],
            [-96.563672, 45.935244999999995],
            [-96.587093, 45.816444999999995],
            [-96.672665, 45.732336],
            [-96.82616, 45.654163999999994],
            [-96.84395699999999, 45.594003],
            [-96.781036, 45.535972],
            [-96.710786, 45.43693],
            [-96.52178699999999, 45.375645],
            [-96.457781, 45.30761],
            [-96.452213, 44.360149],
            [-96.45326, 43.500389999999996],
            [-96.598928, 43.500457],
            [-96.59425399999999, 43.434152999999995],
            [-96.52157199999999, 43.385639999999995],
            [-96.53039199999999, 43.300034],
            [-96.578823, 43.291095],
            [-96.52208399999999, 43.22096],
            [-96.475571, 43.221053999999995],
            [-96.439335, 43.113915999999996],
            [-96.458201, 43.067554],
            [-96.51160499999999, 43.039927],
            [-96.50030799999999, 42.959391],
            [-96.54168899999999, 42.922576],
            [-96.53785099999999, 42.878474999999995],
            [-96.62187499999999, 42.779255],
            [-96.624704, 42.725497],
            [-96.526766, 42.641183999999996],
            [-96.476952, 42.556079],
            [-96.49297, 42.517282],
            [-96.44550799999999, 42.490629999999996],
            [-96.525142, 42.510234],
            [-96.61148899999999, 42.506088],
            [-96.7093, 42.603753],
            [-96.697639, 42.659143],
            [-96.778182, 42.662993],
            [-96.80165199999999, 42.698774],
            [-96.906797, 42.7338],
            [-96.965679, 42.724531999999996],
            [-97.02485, 42.762429999999995],
            [-97.13133099999999, 42.771929],
            [-97.213957, 42.820142999999995],
            [-97.23786799999999, 42.853139],
            [-97.41706599999999, 42.865918],
            [-97.45217699999999, 42.846047999999996],
            [-97.59926, 42.856229],
            [-97.70102999999999, 42.843796999999995],
            [-97.857957, 42.865092999999995],
            [-97.905001, 42.798871999999996],
            [-97.950147, 42.769619],
            [-98.035034, 42.764205],
            [-98.14806, 42.840013],
            [-98.280007, 42.874995999999996],
            [-98.43450299999999, 42.929227],
            [-98.4985499961057, 42.9985599930527],
            [-101.000429, 42.99753],
            [-103.476133, 43.000768],
            [-104.053127, 43.000585],
            [-104.055032, 43.558603],
            [-104.05581, 44.691342999999996],
            [-104.057698, 44.997431],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 49,
        STATENS: "01455989",
        AFFGEOID: "0400000US49",
        GEOID: 49,
        STUSPS: "UT",
        NAME: "Utah",
        LSAD: "00",
        ALAND: 212883424892,
        AWATER: 7000211755,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.041723, 41.993719999999996],
            [-113.817964, 41.98858],
            [-113.24915899999999, 41.996203],
            [-112.264936, 42.000991],
            [-112.109532, 41.997597999999996],
            [-111.046689, 42.001567],
            [-111.046723, 40.997959],
            [-110.539819, 40.996345999999996],
            [-109.050076, 41.000659],
            [-109.048249, 40.653600999999995],
            [-109.050973, 40.180848999999995],
            [-109.051512, 39.126095],
            [-109.059962, 38.499987],
            [-109.060062, 38.275489],
            [-109.041762, 38.16469],
            [-109.045223, 36.999083999999996],
            [-110.47019, 36.997997],
            [-110.75068999999999, 37.003197],
            [-111.405869, 37.001481],
            [-112.966471, 37.000219],
            [-114.0506, 37.000395999999995],
            [-114.052701, 37.492014],
            [-114.049658, 37.881367999999995],
            [-114.05015399999999, 38.572919999999996],
            [-114.047079, 39.499942999999995],
            [-114.046178, 40.398313],
            [-114.040231, 41.49169],
            [-114.041723, 41.993719999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 53,
        STATENS: "01779804",
        AFFGEOID: "0400000US53",
        GEOID: 53,
        STUSPS: "WA",
        NAME: "Washington",
        LSAD: "00",
        ALAND: 172120795268,
        AWATER: 12540315747,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-123.23714799999999, 48.683465999999996],
              [-123.070427, 48.699971],
              [-123.019699, 48.721312],
              [-122.979519, 48.781701999999996],
              [-122.937925, 48.790315],
              [-122.81843599999999, 48.744628999999996],
              [-122.743049, 48.661991],
              [-122.79901, 48.604682999999994],
              [-122.771206, 48.562425999999995],
              [-122.779124, 48.508911],
              [-122.817912, 48.483888],
              [-122.803521, 48.428748],
              [-122.874135, 48.418195999999995],
              [-123.03915599999999, 48.460003],
              [-123.141478, 48.505291],
              [-123.20268, 48.590213999999996],
              [-123.23714799999999, 48.683465999999996],
            ],
          ],
          [
            [
              [-117.032351, 48.999188],
              [-117.035289, 48.422731999999996],
              [-117.041107, 48.124904],
              [-117.039771, 46.471779],
              [-117.035545, 46.410011999999995],
              [-117.062748, 46.353623999999996],
              [-116.99726, 46.303151],
              [-116.96437900000001, 46.253282],
              [-116.962966, 46.19968],
              [-116.923958, 46.170919999999995],
              [-116.981962, 46.084914999999995],
              [-116.942656, 46.061],
              [-116.915989, 45.995413],
              [-117.717852, 45.999866],
              [-118.987129, 45.999855],
              [-119.12612, 45.932859],
              [-119.25715, 45.939926],
              [-119.487829, 45.906307],
              [-119.600549, 45.919581],
              [-119.669877, 45.856867],
              [-119.802655, 45.84753],
              [-119.965744, 45.824365],
              [-120.07015, 45.785152],
              [-120.141352, 45.773151999999996],
              [-120.210754, 45.725950999999995],
              [-120.40396, 45.699248999999995],
              [-120.505863, 45.700047999999995],
              [-120.591166, 45.746547],
              [-120.855674, 45.671544999999995],
              [-120.895575, 45.642945],
              [-120.943977, 45.656445],
              [-121.084933, 45.647892999999996],
              [-121.1222, 45.616067],
              [-121.183841, 45.606441],
              [-121.215779, 45.671237999999995],
              [-121.33777, 45.704949],
              [-121.423592, 45.69399],
              [-121.533106, 45.726541],
              [-121.735104, 45.694039],
              [-121.811304, 45.706761],
              [-121.900858, 45.662009],
              [-122.101675, 45.583515999999996],
              [-122.183695, 45.577695999999996],
              [-122.262625, 45.544321],
              [-122.331502, 45.548241],
              [-122.380302, 45.575941],
              [-122.43867399999999, 45.563584999999996],
              [-122.492259, 45.583281],
              [-122.643907, 45.609739],
              [-122.738109, 45.644138],
              [-122.774511, 45.680437],
              [-122.761451, 45.759163],
              [-122.795605, 45.81],
              [-122.785026, 45.867698999999995],
              [-122.813998, 45.960983999999996],
              [-122.904119, 46.083734],
              [-123.115904, 46.185268],
              [-123.166414, 46.188973],
              [-123.280166, 46.144842999999995],
              [-123.371433, 46.146372],
              [-123.430847, 46.181827],
              [-123.427629, 46.229347999999995],
              [-123.47964400000001, 46.269130999999994],
              [-123.547659, 46.259108999999995],
              [-123.669501, 46.266832],
              [-123.70076399999999, 46.305278],
              [-123.75956, 46.275073],
              [-123.806139, 46.283587999999995],
              [-123.875525, 46.239787],
              [-123.969427, 46.291398],
              [-124.080671, 46.267239],
              [-124.064624, 46.326899],
              [-124.057024, 46.493338],
              [-124.069583, 46.630651],
              [-123.960642, 46.636364],
              [-123.923269, 46.672708],
              [-123.975157, 46.713971],
              [-124.080983, 46.735003],
              [-124.138225, 46.905533999999996],
              [-124.180111, 46.926356999999996],
              [-124.169113, 46.994507999999996],
              [-124.18854400000001, 47.157858999999995],
              [-124.236349, 47.287287],
              [-124.319379, 47.355559],
              [-124.355955, 47.545697999999994],
              [-124.412106, 47.691199],
              [-124.539927, 47.836967],
              [-124.625512, 47.887963],
              [-124.672427, 47.964414],
              [-124.687101, 48.098656999999996],
              [-124.72172499999999, 48.153185],
              [-124.669265, 48.296352999999996],
              [-124.72583900000001, 48.386012],
              [-124.653243, 48.390691],
              [-124.380874, 48.284698999999996],
              [-124.25088199999999, 48.264773],
              [-124.101773, 48.216882999999996],
              [-124.050734, 48.177747],
              [-123.880068, 48.160621],
              [-123.672445, 48.162715],
              [-123.551131, 48.151382],
              [-123.44197199999999, 48.124258999999995],
              [-123.23912899999999, 48.118217],
              [-123.144783, 48.175943],
              [-123.004128, 48.090516],
              [-122.833173, 48.134406],
              [-122.760448, 48.14324],
              [-122.698465, 48.103102],
              [-122.70129399999999, 47.972978999999995],
              [-122.651063, 47.920984999999995],
              [-122.546824, 47.967214999999996],
              [-122.542924, 47.996404],
              [-122.607342, 48.030992],
              [-122.59830099999999, 48.110616],
              [-122.633167, 48.163281],
              [-122.711508, 48.193573],
              [-122.752563, 48.260061],
              [-122.707077, 48.315286],
              [-122.66533799999999, 48.416453],
              [-122.689121, 48.476848999999994],
              [-122.650307, 48.530156],
              [-122.642597, 48.588339],
              [-122.710177, 48.722237],
              [-122.732506, 48.838097],
              [-122.794018, 48.88313],
              [-122.821631, 48.941368999999995],
              [-122.75802, 49.002356999999996],
              [-122.098357, 49.002145999999996],
              [-121.751252, 48.997398999999994],
              [-121.12624, 49.001411999999995],
              [-120.001199, 48.999418],
              [-117.60732300000001, 49.000842999999996],
              [-117.032351, 48.999188],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 54,
        STATENS: "01779805",
        AFFGEOID: "0400000US54",
        GEOID: 54,
        STUSPS: "WV",
        NAME: "West Virginia",
        LSAD: "00",
        ALAND: 62266581604,
        AWATER: 489443020,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.593673, 38.421808999999996],
            [-82.560664, 38.404337999999996],
            [-82.323999, 38.449268],
            [-82.27427, 38.593683],
            [-82.175167, 38.608484],
            [-82.20929, 38.802672],
            [-82.16157, 38.824632],
            [-82.134766, 38.905578999999996],
            [-82.08906499999999, 38.975978],
            [-82.00706199999999, 39.029578],
            [-81.941829, 38.993294999999996],
            [-81.89847, 38.929603],
            [-81.827354, 38.945898],
            [-81.775734, 38.980737],
            [-81.80785499999999, 39.083977999999995],
            [-81.742953, 39.106578],
            [-81.752754, 39.184675999999996],
            [-81.678331, 39.273755],
            [-81.565247, 39.276174999999995],
            [-81.559647, 39.330774],
            [-81.456143, 39.409273999999996],
            [-81.393794, 39.351706],
            [-81.347567, 39.34577],
            [-81.12853299999999, 39.449374999999996],
            [-81.07594999999999, 39.50966],
            [-80.86557499999999, 39.662751],
            [-80.829764, 39.711839],
            [-80.869933, 39.763555],
            [-80.824969, 39.801092],
            [-80.803394, 39.918762],
            [-80.74012599999999, 39.970793],
            [-80.73680399999999, 40.080072],
            [-80.70599399999999, 40.151590999999996],
            [-80.606596, 40.303869],
            [-80.631596, 40.385467999999996],
            [-80.604895, 40.446667],
            [-80.62219499999999, 40.520497],
            [-80.667957, 40.582496],
            [-80.62717099999999, 40.619935999999996],
            [-80.518991, 40.638801],
            [-80.519342, 39.721402999999995],
            [-79.47666199999999, 39.721078],
            [-79.486873, 39.205960999999995],
            [-79.424413, 39.228170999999996],
            [-79.283723, 39.30964],
            [-79.16649699999999, 39.400887999999995],
            [-79.091329, 39.472407],
            [-79.035623, 39.473344],
            [-78.956751, 39.440264],
            [-78.942618, 39.479614],
            [-78.851016, 39.554044],
            [-78.77114, 39.638387],
            [-78.707098, 39.555856999999996],
            [-78.590654, 39.530192],
            [-78.460951, 39.525987],
            [-78.382959, 39.622246],
            [-78.22507499999999, 39.658878],
            [-78.08225999999999, 39.671166],
            [-78.006734, 39.601337],
            [-77.92598799999999, 39.607642],
            [-77.829814, 39.587288],
            [-77.823762, 39.525907],
            [-77.740012, 39.401694],
            [-77.71951899999999, 39.321314],
            [-77.82830183326729, 39.1324224548325],
            [-78.347087, 39.466012],
            [-78.34048, 39.353491999999996],
            [-78.40181299999999, 39.276754],
            [-78.428697, 39.187217],
            [-78.413943, 39.158415],
            [-78.508132, 39.088629999999995],
            [-78.561711, 39.009007],
            [-78.620453, 38.982600999999995],
            [-78.681617, 38.92584],
            [-78.772793, 38.893741999999996],
            [-78.869276, 38.762991],
            [-78.999014, 38.840074],
            [-79.057253, 38.761413],
            [-79.092955, 38.659517],
            [-79.15435699999999, 38.606518],
            [-79.23161999999999, 38.474041],
            [-79.297758, 38.416438],
            [-79.476638, 38.457228],
            [-79.54257, 38.553217],
            [-79.649075, 38.591515],
            [-79.689675, 38.431439],
            [-79.7346, 38.356728],
            [-79.804093, 38.313922],
            [-79.787542, 38.273298],
            [-79.916174, 38.184385999999996],
            [-79.971231, 38.044326],
            [-80.036236, 37.96792],
            [-80.19963299999999, 37.827507],
            [-80.25814299999999, 37.720611999999996],
            [-80.29225799999999, 37.683732],
            [-80.22338599999999, 37.623185],
            [-80.28244, 37.585481],
            [-80.29164399999999, 37.536505],
            [-80.46482, 37.426144],
            [-80.54483599999999, 37.474695],
            [-80.770082, 37.372363],
            [-80.836446, 37.424355],
            [-80.883248, 37.383933],
            [-80.83547899999999, 37.334824],
            [-80.919259, 37.306163],
            [-81.112596, 37.278497],
            [-81.225104, 37.234874],
            [-81.362156, 37.337686999999995],
            [-81.42794599999999, 37.271015],
            [-81.560625, 37.206663],
            [-81.678603, 37.202467],
            [-81.77474699999999, 37.274847],
            [-81.849949, 37.285227],
            [-81.98489099999999, 37.454315],
            [-81.932279, 37.511961],
            [-81.96829699999999, 37.537797999999995],
            [-82.06441799999999, 37.544516],
            [-82.226111, 37.653092],
            [-82.29611799999999, 37.686174],
            [-82.327356, 37.762232999999995],
            [-82.41869, 37.872375],
            [-82.487556, 37.916975],
            [-82.464987, 37.976859],
            [-82.626182, 38.134834999999995],
            [-82.581796, 38.248591999999995],
            [-82.571877, 38.315781],
            [-82.597979, 38.344909],
            [-82.593673, 38.421808999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 56,
        STATENS: "01779807",
        AFFGEOID: "0400000US56",
        GEOID: 56,
        STUSPS: "WY",
        NAME: "Wyoming",
        LSAD: "00",
        ALAND: 251471960305,
        AWATER: 1862600347,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.057698, 44.997431],
            [-104.05581, 44.691342999999996],
            [-104.055032, 43.558603],
            [-104.053127, 43.000585],
            [-104.053249, 41.001405999999996],
            [-104.497058, 41.001805],
            [-104.855273, 40.998048],
            [-106.217573, 40.997734],
            [-107.367443, 41.003073],
            [-108.250649, 41.000113999999996],
            [-109.050076, 41.000659],
            [-110.539819, 40.996345999999996],
            [-111.046723, 40.997959],
            [-111.046689, 42.001567],
            [-111.043564, 42.722623999999996],
            [-111.048974, 44.474072],
            [-111.056888, 44.866658],
            [-111.044275, 45.001345],
            [-110.785008, 45.002952],
            [-110.705272, 44.992323999999996],
            [-109.99504999999999, 45.003174],
            [-109.574321, 45.002631],
            [-109.103445, 45.005904],
            [-109.062262, 44.999623],
            [-107.997353, 45.001565],
            [-107.351441, 45.001407],
            [-106.888773, 44.995885],
            [-106.263586, 44.993787999999995],
            [-105.848065, 45.000395999999995],
            [-105.025266, 45.00029],
            [-104.057698, 44.997431],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 10,
        STATENS: "01779781",
        AFFGEOID: "0400000US10",
        GEOID: 10,
        STUSPS: "DE",
        NAME: "Delaware",
        LSAD: "00",
        ALAND: 5047093738,
        AWATER: 1398754502,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-75.41506199999999, 39.801919],
            [-75.459439, 39.765813],
            [-75.47764, 39.715013],
            [-75.559446, 39.629812],
            [-75.512732, 39.578],
            [-75.528088, 39.498114],
            [-75.593068, 39.479186],
            [-75.57182999999999, 39.438897],
            [-75.40837599999999, 39.264697999999996],
            [-75.39479, 39.188354],
            [-75.407473, 39.133706],
            [-75.396277, 39.057884],
            [-75.34089, 39.01996],
            [-75.30407799999999, 38.91316],
            [-75.159022, 38.790192999999995],
            [-75.089473, 38.797198],
            [-75.071805, 38.696497],
            [-75.04893899999999, 38.451263],
            [-75.479283, 38.453697999999996],
            [-75.693721, 38.460128],
            [-75.76690460670919, 39.3776515935512],
            [-75.788596, 39.722198999999996],
            [-75.71705899999999, 39.792325],
            [-75.662846, 39.821425],
            [-75.570433, 39.839185],
            [-75.481207, 39.829191],
            [-75.41506199999999, 39.801919],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 44,
        STATENS: "01219835",
        AFFGEOID: "0400000US44",
        GEOID: 44,
        STUSPS: "RI",
        NAME: "Rhode Island",
        LSAD: "00",
        ALAND: 2677751247,
        AWATER: 1323482672,
      },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-71.631472, 41.166678],
              [-71.59334199999999, 41.237428],
              [-71.54540999999999, 41.24273],
              [-71.51921, 41.149623999999996],
              [-71.5937, 41.146339],
              [-71.631472, 41.166678],
            ],
          ],
          [
            [
              [-71.860513, 41.320248],
              [-71.835951, 41.353935],
              [-71.839649, 41.412119],
              [-71.79768299999999, 41.416709],
              [-71.789678, 41.724734],
              [-71.79924199999999, 42.008064999999995],
              [-71.381401, 42.018798],
              [-71.38170000000001, 41.893198999999996],
              [-71.339298, 41.893398999999995],
              [-71.329396, 41.7826],
              [-71.261392, 41.752300999999996],
              [-71.19564, 41.67509],
              [-71.132888, 41.660101999999995],
              [-71.137492, 41.602561],
              [-71.12057, 41.497448],
              [-71.19301999999999, 41.457930999999995],
              [-71.285639, 41.487805],
              [-71.312694, 41.451402],
              [-71.428652, 41.454158],
              [-71.483295, 41.371722],
              [-71.555381, 41.373315999999996],
              [-71.70163099999999, 41.336968],
              [-71.860513, 41.320248],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: "01",
        STATENS: "01779775",
        AFFGEOID: "0400000US01",
        GEOID: "01",
        STUSPS: "AL",
        NAME: "Alabama",
        LSAD: "00",
        ALAND: 131172403111,
        AWATER: 4594951242,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.200064, 34.995633999999995],
            [-88.20295899999999, 35.008027999999996],
            [-87.21668299999999, 34.999148],
            [-86.783648, 34.991925],
            [-86.311274, 34.991098],
            [-85.605165, 34.984677999999995],
            [-85.561424, 34.750079],
            [-85.42949899999999, 34.125095],
            [-85.18440000000001, 32.861317],
            [-85.11425, 32.730447],
            [-85.069848, 32.583146],
            [-85.00710000000001, 32.523868],
            [-84.971831, 32.442842999999996],
            [-84.98346599999999, 32.363186],
            [-85.008096, 32.336677],
            [-84.891841, 32.263397999999995],
            [-84.930127, 32.219051],
            [-85.05874899999999, 32.136018],
            [-85.047063, 32.087389],
            [-85.067829, 31.967357999999997],
            [-85.141831, 31.839260999999997],
            [-85.11892999999999, 31.732664],
            [-85.12553, 31.694965],
            [-85.05816899999999, 31.620227],
            [-85.04188099999999, 31.544684],
            [-85.071621, 31.468383999999997],
            [-85.09248699999999, 31.362880999999998],
            [-85.10751599999999, 31.186450999999998],
            [-85.03561499999999, 31.108192],
            [-85.002499, 31.000681999999998],
            [-85.893632, 30.993454999999997],
            [-86.56349399999999, 30.995202],
            [-87.162644, 30.999025999999997],
            [-87.59893699999999, 30.997422],
            [-87.592064, 30.951459999999997],
            [-87.63494299999999, 30.865857],
            [-87.52362099999999, 30.738284999999998],
            [-87.400189, 30.657200999999997],
            [-87.401189, 30.604383],
            [-87.444722, 30.507483999999998],
            [-87.41468499999999, 30.457289],
            [-87.452282, 30.344096999999998],
            [-87.51832399999999, 30.280434999999997],
            [-87.656888, 30.249709],
            [-87.818867, 30.228313999999997],
            [-87.796717, 30.324198],
            [-87.865017, 30.38345],
            [-87.93335499999999, 30.487357],
            [-87.90171099999999, 30.550879],
            [-87.93106999999999, 30.652694],
            [-88.00839599999999, 30.684956],
            [-88.061998, 30.644890999999998],
            [-88.064898, 30.588292],
            [-88.103768, 30.500902999999997],
            [-88.105699, 30.401864999999997],
            [-88.136173, 30.320729],
            [-88.257764, 30.318932999999998],
            [-88.31160799999999, 30.368907999999998],
            [-88.395023, 30.369425],
            [-88.432007, 31.114297999999998],
            [-88.46866899999999, 31.790722],
            [-88.46866, 31.933173],
            [-88.42827799999999, 32.250143],
            [-88.25444499999999, 33.698779],
            [-88.097888, 34.892202],
            [-88.154617, 34.922391999999995],
            [-88.200064, 34.995633999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 38,
        STATENS: "01779797",
        AFFGEOID: "0400000US38",
        GEOID: 38,
        STUSPS: "ND",
        NAME: "North Dakota",
        LSAD: "00",
        ALAND: 178708787440,
        AWATER: 4398990288,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.048736, 48.999877],
            [-102.216993, 48.998553],
            [-99.91377999999999, 48.999049],
            [-97.229039, 49.000687],
            [-97.227854, 48.945864],
            [-97.100009, 48.667925999999994],
            [-97.142915, 48.583732999999995],
            [-97.14912199999999, 48.532305],
            [-97.129533, 48.257815],
            [-97.146745, 48.168555999999995],
            [-97.06898699999999, 48.026267],
            [-96.996364, 47.844398],
            [-96.928506, 47.744884],
            [-96.854073, 47.57201],
            [-96.85748, 47.440456999999995],
            [-96.81907799999999, 47.081151999999996],
            [-96.83350399999999, 47.01011],
            [-96.763973, 46.912507],
            [-96.788803, 46.777575],
            [-96.790523, 46.63688],
            [-96.744436, 46.56596],
            [-96.70909499999999, 46.435294],
            [-96.60104, 46.319554],
            [-96.59567, 46.21985],
            [-96.554507, 46.083977999999995],
            [-96.574264, 46.016545],
            [-96.563672, 45.935244999999995],
            [-98.414518, 45.936504],
            [-99.092868, 45.940183999999995],
            [-100.51194902615102, 45.9436540704345],
            [-102.550947, 45.945015],
            [-104.045443, 45.94531],
            [-104.045313, 47.331955],
            [-104.042384, 47.803256],
            [-104.047555, 48.494139999999994],
            [-104.048736, 48.999877],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 42,
        STATENS: "01779798",
        AFFGEOID: "0400000US42",
        GEOID: 42,
        STUSPS: "PA",
        NAME: "Pennsylvania",
        LSAD: "00",
        ALAND: 115884023072,
        AWATER: 3396010541,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.519425, 41.977523],
            [-80.329976, 42.036167999999996],
            [-80.154084, 42.114757],
            [-80.088512, 42.173184],
            [-80.02032299999999, 42.163115999999995],
            [-79.761951, 42.26986],
            [-79.761313, 41.998808],
            [-78.59665, 41.999877],
            [-77.83203, 41.998523999999996],
            [-77.007635, 42.000848],
            [-76.462155, 41.998934],
            [-75.477144, 41.999407],
            [-75.34112499999999, 41.992771999999995],
            [-75.29176199999999, 41.947092],
            [-75.26300499999999, 41.885109],
            [-75.11336899999999, 41.840697999999996],
            [-75.053431, 41.752538],
            [-75.04387899999999, 41.575094],
            [-74.982463, 41.496466999999996],
            [-74.89035799999999, 41.455324],
            [-74.734893, 41.425818],
            [-74.694914, 41.357423],
            [-74.760325, 41.340325],
            [-74.815703, 41.296150999999995],
            [-74.905256, 41.155668],
            [-74.979873, 41.110423],
            [-75.015271, 41.061215],
            [-75.13308599999999, 40.980179],
            [-75.065438, 40.885681999999996],
            [-75.108505, 40.791094],
            [-75.177477, 40.764224999999996],
            [-75.192612, 40.715874],
            [-75.186737, 40.569406],
            [-75.136748, 40.575731],
            [-75.078503, 40.548296],
            [-75.056102, 40.416066],
            [-74.969597, 40.39977],
            [-74.946006, 40.357306],
            [-74.721604, 40.15381],
            [-74.825907, 40.123909999999995],
            [-74.863809, 40.082209999999996],
            [-74.932211, 40.068411],
            [-75.13571999999999, 39.947112],
            [-75.13342, 39.896212999999996],
            [-75.221025, 39.861112999999996],
            [-75.341765, 39.846081999999996],
            [-75.41506199999999, 39.801919],
            [-75.481207, 39.829191],
            [-75.570433, 39.839185],
            [-75.662846, 39.821425],
            [-75.71705899999999, 39.792325],
            [-75.788596, 39.722198999999996],
            [-77.469274, 39.720228999999996],
            [-78.075861, 39.722448],
            [-79.045576, 39.722927999999996],
            [-79.47666199999999, 39.721078],
            [-80.519342, 39.721402999999995],
            [-80.518991, 40.638801],
            [-80.519425, 41.977523],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 50,
        STATENS: "01779802",
        AFFGEOID: "0400000US50",
        GEOID: 50,
        STUSPS: "VT",
        NAME: "Vermont",
        LSAD: "00",
        ALAND: 23871896411,
        AWATER: 1034369068,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-73.343124, 45.010839999999995],
            [-73.048386, 45.01479],
            [-72.582371, 45.011542999999996],
            [-72.34858299999999, 45.005624999999995],
            [-71.915009, 45.007791],
            [-71.501088, 45.013377],
            [-71.531605, 44.976023],
            [-71.49440299999999, 44.911837],
            [-71.570402, 44.805276],
            [-71.626909, 44.747223999999996],
            [-71.551722, 44.627598],
            [-71.544922, 44.579277999999995],
            [-71.588076, 44.54785],
            [-71.57997399999999, 44.501777999999995],
            [-71.646551, 44.468869],
            [-71.69091999999999, 44.421234],
            [-71.77861299999999, 44.399798999999994],
            [-71.818838, 44.352939],
            [-72.002314, 44.324870999999995],
            [-72.046302, 44.291982999999995],
            [-72.06133799999999, 44.184951],
            [-72.036883, 44.103119],
            [-72.116706, 43.991954],
            [-72.105875, 43.949369999999995],
            [-72.16978, 43.873425],
            [-72.18333299999999, 43.808177],
            [-72.22206899999999, 43.759831],
            [-72.28480499999999, 43.72036],
            [-72.329522, 43.608393],
            [-72.37944, 43.574069],
            [-72.380894, 43.493393999999995],
            [-72.413377, 43.362741],
            [-72.402532, 43.32038],
            [-72.451802, 43.153486],
            [-72.435191, 43.086622],
            [-72.462248, 43.044214],
            [-72.444977, 43.004416],
            [-72.532186, 42.954944999999995],
            [-72.556112, 42.866251999999996],
            [-72.53960000000001, 42.804832],
            [-72.458519, 42.726853],
            [-73.264957, 42.74594],
            [-73.278673, 42.83341],
            [-73.242042, 43.534925],
            [-73.327702, 43.625913],
            [-73.39576699999999, 43.568087],
            [-73.424977, 43.598774999999996],
            [-73.414546, 43.658209],
            [-73.350707, 43.770463],
            [-73.39030199999999, 43.817371],
            [-73.374051, 43.875563],
            [-73.407742, 43.929887],
            [-73.405977, 44.011485],
            [-73.43688, 44.042578],
            [-73.395399, 44.166903],
            [-73.31661799999999, 44.257768999999996],
            [-73.334637, 44.356877],
            [-73.293613, 44.440559],
            [-73.312871, 44.507245999999995],
            [-73.36727499999999, 44.567544999999996],
            [-73.389966, 44.61962],
            [-73.33443, 44.802188],
            [-73.37982199999999, 44.857037],
            [-73.338979, 44.917680999999995],
            [-73.343124, 45.010839999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 20,
        STATENS: "00481813",
        AFFGEOID: "0400000US20",
        GEOID: 20,
        STUSPS: "KS",
        NAME: "Kansas",
        LSAD: "00",
        ALAND: 211752875517,
        AWATER: 1346704962,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.051744, 40.003077999999995],
            [-99.813401, 40.001400000000004],
            [-98.613755, 40.0024],
            [-97.41583299999999, 40.002001],
            [-95.30829, 39.999998],
            [-95.23111399999999, 39.943784],
            [-95.08153399999999, 39.861717999999996],
            [-95.018743, 39.897372],
            [-94.95154, 39.900532999999996],
            [-94.878677, 39.826522],
            [-94.860371, 39.74953],
            [-94.899316, 39.724042],
            [-94.97107799999999, 39.723146],
            [-94.971317, 39.686409999999995],
            [-95.037464, 39.652905],
            [-95.04716499999999, 39.595116999999995],
            [-95.113557, 39.553940999999995],
            [-94.94666199999999, 39.399716999999995],
            [-94.888972, 39.392432],
            [-94.908065, 39.323662999999996],
            [-94.799663, 39.206018],
            [-94.74193799999999, 39.170203],
            [-94.680336, 39.184303],
            [-94.62393399999999, 39.156603],
            [-94.607354, 39.113444],
            [-94.612866, 38.477571],
            [-94.612614, 38.237766],
            [-94.617885, 37.682213999999995],
            [-94.617964, 36.998905],
            [-94.99529299999999, 36.999528999999995],
            [-97.768704, 36.99875],
            [-98.354073, 36.997961],
            [-99.995201, 37.001630999999996],
            [-100.552683, 37.000735],
            [-102.04224, 36.993083],
            [-102.041876, 37.723875],
            [-102.046571, 39.047038],
            [-102.051744, 40.003077999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 32,
        STATENS: "01779793",
        AFFGEOID: "0400000US32",
        GEOID: 32,
        STUSPS: "NV",
        NAME: "Nevada",
        LSAD: "00",
        ALAND: 284331571298,
        AWATER: 2049092975,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-119.999168, 41.99454],
            [-119.72573, 41.996296],
            [-118.775869, 41.992692],
            [-118.501002, 41.995446],
            [-117.197798, 42.00038],
            [-117.026197, 41.99989],
            [-116.625947, 41.997378999999995],
            [-115.313877, 41.996103],
            [-114.89921, 41.999908999999995],
            [-114.59826699999999, 41.994510999999996],
            [-114.041723, 41.993719999999996],
            [-114.040231, 41.49169],
            [-114.046178, 40.398313],
            [-114.047079, 39.499942999999995],
            [-114.05015399999999, 38.572919999999996],
            [-114.049658, 37.881367999999995],
            [-114.052701, 37.492014],
            [-114.0506, 37.000395999999995],
            [-114.046838, 36.194069],
            [-114.151725, 36.024563],
            [-114.21369, 36.015613],
            [-114.316109, 36.063109],
            [-114.372106, 36.143114],
            [-114.448654, 36.12641],
            [-114.511721, 36.150956],
            [-114.627855, 36.141011999999996],
            [-114.736165, 36.104366999999996],
            [-114.742779, 36.009963],
            [-114.731159, 35.943916],
            [-114.669687, 35.865083999999996],
            [-114.70371, 35.814585],
            [-114.689407, 35.651412],
            [-114.653406, 35.610789],
            [-114.6645, 35.449497],
            [-114.627137, 35.409504],
            [-114.587129, 35.262375999999996],
            [-114.57274699999999, 35.138725],
            [-114.619905, 35.121632],
            [-114.633487, 35.001857],
            [-115.043812, 35.332012],
            [-115.647683, 35.809357999999996],
            [-116.093601, 36.155805],
            [-116.48823300000001, 36.459097],
            [-117.000895, 36.847694],
            [-117.68061, 37.353398999999996],
            [-118.500958, 37.949019],
            [-118.949673, 38.26894],
            [-119.587679, 38.714734],
            [-120.001014, 38.999573999999996],
            [-120.005142, 39.291258],
            [-119.997634, 39.956505],
            [-119.996155, 40.32125],
            [-119.999866, 41.183974],
            [-119.999168, 41.99454],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 33,
        STATENS: "01779794",
        AFFGEOID: "0400000US33",
        GEOID: 33,
        STUSPS: "NH",
        NAME: "New Hampshire",
        LSAD: "00",
        ALAND: 23187964254,
        AWATER: 1026252314,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-71.501088, 45.013377],
            [-71.49839899999999, 45.069629],
            [-71.448678, 45.109001],
            [-71.405636, 45.198139],
            [-71.438546, 45.239004],
            [-71.283684, 45.301977],
            [-71.182587, 45.241068999999996],
            [-71.13942999999999, 45.242957999999994],
            [-71.083924, 45.305451],
            [-71.036705, 44.736498],
            [-71.008736, 44.258824999999995],
            [-70.989929, 43.839239],
            [-70.97271599999999, 43.570254999999996],
            [-70.95475499999999, 43.509802],
            [-70.984335, 43.376128],
            [-70.813119, 43.217251999999995],
            [-70.8281, 43.129086],
            [-70.703818, 43.059825],
            [-70.798636, 42.924288],
            [-70.817296, 42.87229],
            [-70.930799, 42.884589],
            [-71.031201, 42.859089],
            [-71.064201, 42.806289],
            [-71.149703, 42.815489],
            [-71.186104, 42.790689],
            [-71.181803, 42.73759],
            [-71.255605, 42.736388999999996],
            [-71.29420499999999, 42.69699],
            [-71.745817, 42.707287],
            [-72.458519, 42.726853],
            [-72.53960000000001, 42.804832],
            [-72.556112, 42.866251999999996],
            [-72.532186, 42.954944999999995],
            [-72.444977, 43.004416],
            [-72.462248, 43.044214],
            [-72.435191, 43.086622],
            [-72.451802, 43.153486],
            [-72.402532, 43.32038],
            [-72.413377, 43.362741],
            [-72.380894, 43.493393999999995],
            [-72.37944, 43.574069],
            [-72.329522, 43.608393],
            [-72.28480499999999, 43.72036],
            [-72.22206899999999, 43.759831],
            [-72.18333299999999, 43.808177],
            [-72.16978, 43.873425],
            [-72.105875, 43.949369999999995],
            [-72.116706, 43.991954],
            [-72.036883, 44.103119],
            [-72.06133799999999, 44.184951],
            [-72.046302, 44.291982999999995],
            [-72.002314, 44.324870999999995],
            [-71.818838, 44.352939],
            [-71.77861299999999, 44.399798999999994],
            [-71.69091999999999, 44.421234],
            [-71.646551, 44.468869],
            [-71.57997399999999, 44.501777999999995],
            [-71.588076, 44.54785],
            [-71.544922, 44.579277999999995],
            [-71.551722, 44.627598],
            [-71.626909, 44.747223999999996],
            [-71.570402, 44.805276],
            [-71.49440299999999, 44.911837],
            [-71.531605, 44.976023],
            [-71.501088, 45.013377],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: {
        STATEFP: 34,
        STATENS: "01779795",
        AFFGEOID: "0400000US34",
        GEOID: 34,
        STUSPS: "NJ",
        NAME: "New Jersey",
        LSAD: "00",
        ALAND: 19048769408,
        AWATER: 3542752545,
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-75.41506199999999, 39.801919],
            [-75.341765, 39.846081999999996],
            [-75.221025, 39.861112999999996],
            [-75.13342, 39.896212999999996],
            [-75.13571999999999, 39.947112],
            [-74.932211, 40.068411],
            [-74.863809, 40.082209999999996],
            [-74.825907, 40.123909999999995],
            [-74.721604, 40.15381],
            [-74.946006, 40.357306],
            [-74.969597, 40.39977],
            [-75.056102, 40.416066],
            [-75.078503, 40.548296],
            [-75.136748, 40.575731],
            [-75.186737, 40.569406],
            [-75.192612, 40.715874],
            [-75.177477, 40.764224999999996],
            [-75.108505, 40.791094],
            [-75.065438, 40.885681999999996],
            [-75.13308599999999, 40.980179],
            [-75.015271, 41.061215],
            [-74.979873, 41.110423],
            [-74.905256, 41.155668],
            [-74.815703, 41.296150999999995],
            [-74.760325, 41.340325],
            [-74.694914, 41.357423],
            [-74.301994, 41.172594],
            [-73.8939818600359, 40.9971982035389],
            [-73.938081, 40.874699],
            [-74.047313, 40.690466],
            [-74.086806, 40.651596],
            [-74.202247, 40.630902999999996],
            [-74.216839, 40.558617999999996],
            [-74.260611, 40.502435999999996],
            [-74.261889, 40.464706],
            [-74.206188, 40.440706999999996],
            [-74.108295, 40.443788],
            [-74.047884, 40.418907999999995],
            [-73.99794299999999, 40.476668],
            [-73.971381, 40.348009999999995],
            [-73.981681, 40.279410999999996],
            [-74.030181, 40.122814],
            [-74.077247, 39.910990999999996],
            [-74.101443, 39.756173],
            [-74.190974, 39.625118],
            [-74.291585, 39.507705],
            [-74.304343, 39.471444999999996],
            [-74.41269199999999, 39.360816],
            [-74.52179699999999, 39.313815999999996],
            [-74.64659499999999, 39.212002],
            [-74.71434099999999, 39.119803999999995],
            [-74.705876, 39.102937],
            [-74.807917, 38.985948],
            [-74.864458, 38.94041],
            [-74.967274, 38.933413],
            [-74.95536299999999, 39.001262],
            [-74.885914, 39.143626999999995],
            [-74.905181, 39.174945],
            [-75.048487, 39.215222],
            [-75.136667, 39.181883],
            [-75.244357, 39.2857],
            [-75.442393, 39.402291],
            [-75.465212, 39.43893],
            [-75.536431, 39.460558999999996],
            [-75.528088, 39.498114],
            [-75.512732, 39.578],
            [-75.559446, 39.629812],
            [-75.47764, 39.715013],
            [-75.459439, 39.765813],
            [-75.41506199999999, 39.801919],
          ],
        ],
      },
    },
  ],
};
